var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalemblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1774 16.3859C8.1774 16.3859 14.1482 16.6702 14.8116 14.1824C14.8116 14.1824 14.9301 13.59 13.4374 13.4715C13.4374 13.4715 16.0674 11.9077 15.8778 10.5809C15.8778 10.5809 15.6882 10.2018 15.3328 10.2256C15.3328 10.2256 16.7071 7.47707 15.2855 7.24016C15.2855 7.24016 15.6882 4.82341 14.1245 5.1314L14.0771 3.66244C14.0771 3.66244 12.6555 3.30704 12.0394 1.838L8.1774 0.605957L4.12579 1.93283C4.12579 1.93283 3.74672 3.23595 2.25402 3.70985C2.25402 3.70985 1.78012 4.46807 1.99336 5.32104C1.99336 5.32104 0.524331 4.70491 0.642823 7.42973C0.642823 7.42973 -0.138996 7.69046 0.192668 8.66185C0.192668 8.66185 0.33483 9.91757 0.713904 10.3441C0.713904 10.3441 -0.0442452 10.3678 0.121587 11.2208C0.121587 11.2208 0.903406 12.6897 2.58568 13.6138C2.58568 13.6138 1.1878 13.5664 1.25888 14.4668C1.25888 14.4667 2.18293 16.836 8.1774 16.3859Z",
    fill: "#A84A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02635 14.3571C8.02635 14.3571 1.06043 9.73681 2.30434 3.87264C2.30434 3.87264 3.74664 3.52022 4.43676 2.09562L5.66582 1.5773L8.09743 0.816162L11.6515 1.88238C11.6515 1.88238 12.3237 3.4136 13.8875 3.80455C13.8875 3.80455 14.3881 10.5187 8.02635 14.3571Z",
    fill: "#0F0355"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55647 11.9493C8.55647 12.0048 8.51134 12.05 8.45575 12.05H7.61473C7.55914 12.05 7.51401 12.0048 7.51401 11.9493V10.8949C7.51401 11.065 7.71168 10.7942 7.61473 10.7942H8.45575C8.51134 10.7942 8.55647 10.8393 8.55647 10.8949V11.9493Z",
    fill: "#A84A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86027 11.3983C4.86027 11.3983 5.71332 10.9658 6.00354 11.0784C6.29376 11.191 6.36484 11.345 6.36484 11.345C6.36484 11.345 6.94827 10.6698 7.65908 10.9482C7.69135 10.9608 7.75611 10.9846 7.75611 10.9846C7.75611 10.9846 7.68574 11.3124 7.97895 11.348C8.51568 11.413 9.15093 11.2651 9.23175 11.2561C9.33837 11.2443 10.4935 11.0844 10.7185 11.3036C10.9436 11.5227 11.0976 11.5701 11.0976 11.5701C11.0976 11.5701 9.37398 13.3768 8.03524 14.0402C8.03524 14.0402 4.71221 12.1921 4.86027 11.3983Z",
    fill: "url(#paint0_linear_9_3255)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82791 11.3702C7.82791 11.3702 7.77901 11.0237 7.92123 10.9837C7.92123 10.9837 7.89899 10.9126 7.93012 10.9126C7.96125 10.9126 8.02785 10.9126 8.0545 10.9437C8.08115 10.9749 8.12558 10.9304 8.12558 10.9882C8.12558 11.0459 8.13005 11.3925 8.13005 11.3925C8.13005 11.3925 8.03382 11.351 7.97603 11.351C7.97603 11.351 7.82351 11.3124 7.82791 11.3702V11.3702Z",
    fill: "url(#paint1_linear_9_3255)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29479 14.1467L8.08556 14.6976L8.80525 14.1556C8.80525 14.1556 8.65421 15.8704 9.16954 16.3147H7.01935C7.01935 16.3147 7.61465 15.0797 7.29479 14.1467Z",
    fill: "url(#paint2_linear_9_3255)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86082 9.77937L7.8166 9.8142L7.38088 9.77617C7.34299 9.7456 7.29238 9.7773 7.24909 9.76259C7.12776 9.73828 6.97799 9.78157 6.89675 9.6623C6.84813 9.65917 6.79126 9.66862 6.75117 9.6549C6.73418 9.62114 6.74371 9.57046 6.72366 9.53463C6.63716 9.55788 6.55072 9.58105 6.47054 9.62014C6.46422 9.67495 6.47253 9.73508 6.45043 9.78363L5.92088 9.74461C5.89038 9.71397 5.89145 9.66862 5.88299 9.62754L5.86934 9.61382C5.77864 9.60117 5.69001 9.58432 5.60343 9.56214L5.59923 9.42396C5.51173 9.39233 5.41251 9.38707 5.3228 9.36169L5.28804 9.24043C5.22052 9.22138 5.13728 9.23837 5.077 9.19935L5.26373 8.04421C5.25641 8.00839 5.21945 8.03056 5.19834 8.02004C5.0802 7.91342 4.99796 7.79109 4.91146 7.67082C4.93043 7.64239 4.92098 7.61282 4.90101 7.58752C4.5793 7.14028 4.37778 6.64441 4.24799 6.11806C4.22268 6.10541 4.20584 6.08963 4.19951 6.06219L4.14044 5.58858L4.16902 5.54302C4.17492 5.51174 4.1703 5.4649 4.16767 5.39133C4.15722 4.63389 4.39129 3.97888 4.73525 3.36915C4.71947 3.34697 4.71307 3.3206 4.71094 3.29316L4.90399 3.02953C4.93029 3.01055 4.96413 3.01055 4.99469 3.00209C5.34171 2.57283 5.77736 2.19511 6.23946 1.9621C6.816 1.68084 7.43867 1.48771 8.12389 1.48657C8.80911 1.48771 9.43184 1.68091 10.0085 1.9621C10.4704 2.19518 10.9061 2.57283 11.2531 3.00209C11.2837 3.01055 11.3175 3.01055 11.3438 3.02953L11.5368 3.29316C11.5348 3.3206 11.5284 3.34697 11.5127 3.36915C11.8565 3.97888 12.0906 4.63389 12.0801 5.39133C12.0938 5.45559 12.0463 5.54003 12.1075 5.58851L12.0485 6.06212C12.0421 6.08956 12.0252 6.10534 11.9999 6.11799C11.8701 6.64434 11.6687 7.1402 11.3468 7.58744C11.3269 7.61268 11.3174 7.64225 11.3364 7.67075C11.2498 7.79102 11.1676 7.91335 11.0495 8.01997C11.0284 8.03042 10.9914 8.00831 10.9841 8.04414L11.1708 9.19927C11.1107 9.2383 11.0273 9.22138 10.9598 9.24036L10.925 9.36162C10.8353 9.387 10.7362 9.39226 10.6486 9.42389L10.6444 9.56207C10.5578 9.58425 10.4693 9.60109 10.3786 9.61375L10.3649 9.62746C10.3564 9.66855 10.3575 9.71397 10.327 9.74454L9.79741 9.78356C9.77524 9.73501 9.78377 9.67495 9.7773 9.62007C9.69726 9.58098 9.61069 9.55781 9.52418 9.53456C9.50421 9.57046 9.51373 9.62114 9.49667 9.65483C9.45672 9.66848 9.39965 9.6591 9.35124 9.66222C9.26999 9.7815 9.12008 9.73821 8.99889 9.76252C8.95567 9.77723 8.90492 9.7456 8.86697 9.7761L8.43131 9.81412L8.38703 9.77929C8.21302 9.78626 8.03511 9.78626 7.86082 9.77937V9.77937Z",
    fill: "url(#paint3_linear_9_3255)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12407 1.52594C7.60319 1.52267 7.11479 1.65133 6.65739 1.81943C6.03493 2.0368 5.48221 2.47451 5.01919 3.02617L5.02231 3.04409C5.05494 3.08631 5.05729 3.15014 5.09517 3.19129C5.10555 3.04792 5.19341 2.95914 5.25425 2.86055C5.38724 2.68754 5.57184 2.56728 5.73106 2.4217L5.75217 2.41431C5.7607 2.41857 5.7585 2.42696 5.7585 2.43542C5.59928 2.5746 5.41255 2.70119 5.28809 2.8774C5.18886 2.97229 5.20272 3.11367 5.18793 3.24446C5.19092 3.24901 5.17222 3.28555 5.13356 3.28334C5.06965 3.2741 5.04065 3.32151 4.99801 3.37212C5.02871 3.40589 4.99801 3.44704 4.99488 3.48287C4.97689 3.50185 4.95059 3.50085 4.92529 3.49979C4.89984 3.4882 4.90198 3.4555 4.89778 3.43439C4.88086 3.41228 4.90098 3.38798 4.89465 3.3616C4.89977 3.32258 4.95159 3.35108 4.97362 3.33104C5.00327 3.31306 5.0317 3.28356 5.03276 3.24766C5.00526 3.20757 5.02857 3.14637 5.01158 3.10216C5.00113 3.07046 4.96943 3.04515 4.93254 3.06093L4.76578 3.28249L4.77325 3.29934C4.7859 3.32997 4.82172 3.3363 4.85229 3.33737C4.86181 3.34163 4.88293 3.34049 4.8766 3.35841C4.79848 3.43972 4.88079 3.53988 4.86615 3.63797C4.85869 3.68851 4.87248 3.74757 4.82805 3.78347C4.79855 3.79086 4.78697 3.7561 4.76266 3.74871C4.73003 3.71601 4.73948 3.65268 4.75221 3.61366C4.76266 3.5398 4.79542 3.47334 4.83239 3.41008C4.82073 3.38584 4.7923 3.38691 4.77012 3.38264C4.71105 3.48493 4.65099 3.58722 4.60024 3.69384C4.37768 4.1516 4.25429 4.65051 4.21313 5.18433C4.20773 5.30133 4.21213 5.4351 4.20325 5.54293C4.20126 5.56795 4.19259 5.56945 4.18207 5.59099C4.20126 5.74395 4.19415 5.92272 4.25429 6.05877C4.26488 6.06197 4.28272 6.0641 4.28172 6.07988C4.41472 6.62415 4.61922 7.13891 4.96005 7.59781L4.96318 7.67365C5.03276 7.77601 5.11614 7.87624 5.20585 7.968C5.23108 7.98385 5.2448 7.94902 5.26371 7.93957C5.29647 7.90794 5.32277 7.96274 5.34396 7.98179C5.38092 8.10945 5.48008 8.21273 5.5749 8.31729C5.69737 8.42377 5.77328 8.59785 5.93158 8.64213C6.17617 8.82566 6.45573 8.92376 6.76479 8.95013C6.92209 8.96491 7.11828 9.0018 7.25639 8.91857C7.19945 8.92802 7.14145 8.93328 7.08345 8.93534C6.86082 8.92795 6.65518 8.8531 6.48537 8.74548C6.5148 8.78458 6.55496 8.80029 6.58553 8.83938C6.60657 8.85836 6.64779 8.8541 6.65412 8.88786C6.46625 8.89219 6.31648 8.77925 6.14241 8.73916C5.93578 8.65059 5.77961 8.43216 5.71429 8.23072C5.65735 8.05564 5.59615 7.8795 5.6066 7.68005C5.54014 7.61793 5.48861 7.54827 5.43366 7.47975L5.38184 7.58736C5.40516 7.70017 5.41781 7.81724 5.45044 7.92592C5.53381 8.14016 5.63716 8.36584 5.85233 8.50409V8.51355C5.84714 8.52307 5.83868 8.53672 5.82389 8.53146C5.59921 8.38169 5.48853 8.14016 5.40935 7.90908C5.38938 7.8247 5.38092 7.73507 5.35448 7.65283L5.2153 7.93971C5.1794 7.89749 5.15097 7.85221 5.11515 7.80892L5.54753 6.84691C5.58982 6.89959 5.61293 6.95979 5.65202 7.0136L5.52024 7.29735C5.56239 7.30894 5.60347 7.32579 5.64157 7.34903C5.66375 7.37327 5.70896 7.3818 5.71016 7.42174C5.70697 7.44712 5.67839 7.44179 5.66155 7.45238C5.65415 7.49247 5.6774 7.51991 5.66887 7.56C5.61513 7.57905 5.57504 7.50207 5.5444 7.46617C5.52223 7.43141 5.52024 7.38493 5.4928 7.35543C5.47695 7.38066 5.46749 7.40817 5.45804 7.43553C5.55606 7.64124 5.77648 7.7731 5.94523 7.91974C5.93044 7.88285 5.90521 7.85015 5.90102 7.80899C5.90201 7.79108 5.92092 7.78682 5.93478 7.78476C5.99072 7.82165 6.02015 7.89017 6.07708 7.93346C6.1235 7.93978 6.1289 7.983 6.13935 8.02003C6.2238 8.05792 6.34087 7.982 6.40526 8.07171C6.41571 8.09488 6.41571 8.13078 6.40526 8.15501C6.39254 8.20036 6.40725 8.24579 6.45054 8.26896L6.37783 7.7468C6.38103 7.73414 6.39368 7.73308 6.40214 7.72576L6.5298 7.8048L6.60984 8.24785C6.62363 8.28261 6.60564 8.34907 6.66165 8.348L6.56776 7.8333L6.57515 7.82271C6.61637 7.82065 6.65113 7.85548 6.68916 7.87126C6.73025 8.04747 6.76088 8.22887 6.79671 8.40714C6.87589 8.43564 6.9624 8.44936 7.04883 8.46194C7.0806 8.4704 7.12901 8.47786 7.15545 8.45562C7.17017 8.44296 7.1713 8.42505 7.16284 8.4102L7.06582 8.38916C6.98983 8.36485 6.89494 8.38702 6.83054 8.33115C6.83054 8.31751 6.81583 8.30059 6.83054 8.28893C6.96453 8.29526 7.0838 8.34274 7.20393 8.36911C7.21025 8.35326 7.19547 8.34594 7.19035 8.33428C7.07215 8.28573 6.93823 8.27315 6.82109 8.22034C6.8137 8.20243 6.79998 8.18238 6.81064 8.16127C6.93077 8.18558 7.03632 8.25936 7.15559 8.27528C7.15559 8.26256 7.17145 8.24785 7.15559 8.23726L6.81696 8.10647L6.78633 8.08223C6.78633 8.06425 6.75569 8.03994 6.78633 8.03048C6.91498 8.06744 7.03525 8.12651 7.15979 8.17499C7.19874 8.20449 7.20933 8.15594 7.21779 8.1307C7.07215 8.08116 6.9329 8.01363 6.78946 7.95769L6.73771 7.88178L6.43341 7.68489L6.35067 7.68254C6.12705 7.55196 6.04382 7.42928 5.89711 7.29309C5.82539 7.20559 5.76419 7.11268 5.68614 7.02725V7.00301L5.48896 6.64327L5.44454 6.61896C5.38348 6.51774 5.32754 6.41325 5.29271 6.30144C5.18921 5.9481 5.11749 5.58203 5.13967 5.17701C5.15133 5.16336 5.16611 5.15597 5.17777 5.14645C5.20194 4.95865 5.20933 4.76353 5.26413 4.58946L5.25461 4.5579C5.26733 4.40173 5.32747 4.25722 5.40238 4.12224C5.64285 3.55892 6.19039 3.00933 6.74404 2.74249C7.01727 2.62009 7.30103 2.52306 7.59544 2.45234C7.77052 2.43421 7.94473 2.39867 8.12436 2.40407C8.30398 2.39867 8.47827 2.43421 8.65327 2.45234C8.94769 2.52306 9.23137 2.62009 9.50468 2.74249C10.0585 3.00933 10.6058 3.55892 10.8465 4.12224C10.9214 4.25722 10.9814 4.40173 10.994 4.5579L10.9846 4.58946C11.0395 4.76353 11.0468 4.95865 11.0711 5.14645C11.0826 5.15597 11.0974 5.16329 11.109 5.17701C11.1312 5.58203 11.0595 5.94817 10.9561 6.30144C10.9214 6.41325 10.8654 6.51774 10.8042 6.61896L10.7599 6.64327L10.5626 7.00301V7.02725C10.4845 7.11268 10.4235 7.20559 10.3517 7.29309C10.204 7.43127 10.0731 7.60321 9.89804 7.68439L9.80833 7.69079L9.51093 7.88178L9.45918 7.95769C9.31567 8.01356 9.17635 8.08109 9.03099 8.1307C9.03931 8.15594 9.04997 8.20449 9.08885 8.17499C9.21339 8.12644 9.33365 8.06737 9.46231 8.03048C9.49295 8.03994 9.46231 8.06425 9.46231 8.08223L9.43167 8.10647L9.09319 8.23726C9.07734 8.24785 9.09319 8.26256 9.09319 8.27528C9.21232 8.25936 9.3178 8.18558 9.438 8.16127C9.44859 8.18238 9.43487 8.20243 9.42755 8.22034C9.31041 8.27308 9.17642 8.28573 9.05829 8.33428C9.05317 8.34594 9.03838 8.35333 9.04471 8.36911C9.16498 8.34274 9.28411 8.29526 9.4181 8.28893C9.43295 8.30059 9.4181 8.31743 9.4181 8.33115C9.35377 8.38702 9.25888 8.36492 9.18282 8.38916L9.0858 8.4102C9.07748 8.42505 9.0784 8.44296 9.09326 8.45562C9.11949 8.47786 9.16811 8.4704 9.19974 8.46194C9.28624 8.44929 9.37268 8.43564 9.45186 8.40714C9.48769 8.22887 9.51832 8.0474 9.55941 7.87126C9.59751 7.85548 9.63227 7.82065 9.67342 7.82271L9.68074 7.8333L9.58692 8.348C9.64286 8.34907 9.62487 8.28261 9.63873 8.24785L9.71891 7.8048L9.84643 7.72576C9.85489 7.73308 9.86754 7.73414 9.87074 7.7468L9.79803 8.26896C9.84124 8.24586 9.8561 8.20036 9.8433 8.15501C9.83286 8.13078 9.83286 8.09488 9.8433 8.07171C9.9077 7.982 10.0249 8.05799 10.1092 8.02003C10.1197 7.983 10.1251 7.93978 10.1715 7.93346C10.2284 7.89024 10.258 7.82165 10.3139 7.78476C10.3276 7.78682 10.3466 7.79108 10.3476 7.80899C10.3434 7.85015 10.3181 7.88285 10.3033 7.91974C10.4721 7.7731 10.6926 7.64124 10.7907 7.43553C10.7812 7.40817 10.7717 7.38073 10.7558 7.35543C10.7285 7.38493 10.7263 7.43134 10.7042 7.46617C10.6735 7.50207 10.6334 7.57905 10.5797 7.56C10.5712 7.51998 10.5945 7.49254 10.587 7.45238C10.5702 7.44186 10.5417 7.44719 10.5385 7.42174C10.5396 7.38173 10.585 7.3732 10.6071 7.34903C10.6451 7.32586 10.6862 7.30901 10.7285 7.29735L10.5965 7.0136C10.6356 6.95979 10.6587 6.89959 10.701 6.84691L11.1336 7.80892C11.0976 7.85214 11.0692 7.89749 11.0334 7.93971L10.8941 7.65283C10.8677 7.73507 10.8593 7.82477 10.8392 7.90908C10.7602 8.14016 10.6494 8.38162 10.4247 8.53146C10.4099 8.53672 10.4016 8.52307 10.3962 8.51355V8.50409C10.6114 8.36591 10.7148 8.14016 10.7981 7.92592C10.8309 7.81731 10.8436 7.70017 10.8667 7.58736L10.8149 7.47975C10.7601 7.54834 10.7084 7.61793 10.642 7.68005C10.6524 7.8795 10.5914 8.05564 10.5343 8.23072C10.4689 8.43216 10.3128 8.65059 10.1062 8.73916C9.93208 8.77918 9.78225 8.89212 9.59459 8.88786C9.60092 8.8541 9.642 8.85836 9.66319 8.83938C9.69368 8.80029 9.7337 8.78458 9.76334 8.74548C9.59338 8.8531 9.38775 8.92795 9.16526 8.93534C9.10719 8.93328 9.04912 8.92795 8.99218 8.91857C9.13043 9.0018 9.32662 8.96491 9.48371 8.95013C9.79277 8.92376 10.0723 8.82566 10.3171 8.64213C10.4753 8.59785 10.5513 8.42377 10.6737 8.31729C10.7685 8.21273 10.8677 8.10945 10.9046 7.98179C10.9258 7.96274 10.9521 7.90794 10.9849 7.93957C11.0038 7.94909 11.0175 7.98385 11.0429 7.968C11.1324 7.87624 11.2158 7.77608 11.2854 7.67365L11.2885 7.59781C11.6294 7.13891 11.834 6.62415 11.9668 6.07988C11.9658 6.0641 11.9838 6.06197 11.9943 6.05877C12.0544 5.92272 12.0481 5.75923 12.067 5.60627C12.0248 5.47754 12.046 5.32465 12.0354 5.18433C11.9943 4.65051 11.8709 4.15167 11.6483 3.69384C11.5977 3.58722 11.5375 3.485 11.4784 3.38264C11.4563 3.38691 11.4278 3.38577 11.4162 3.41008C11.4531 3.47334 11.4858 3.5398 11.4964 3.61366C11.5091 3.65268 11.5185 3.71594 11.4859 3.74871C11.4616 3.7561 11.45 3.79086 11.4205 3.78347C11.3762 3.74757 11.3899 3.68851 11.3826 3.63797C11.3678 3.53988 11.45 3.43965 11.372 3.35841C11.3656 3.34049 11.3868 3.34156 11.3963 3.33737C11.4269 3.3363 11.4627 3.32997 11.4753 3.29934L11.4828 3.28249L11.316 3.06093C11.279 3.04508 11.2474 3.07039 11.237 3.10216C11.22 3.14644 11.2433 3.20757 11.2158 3.24766C11.2169 3.28349 11.2454 3.31306 11.2749 3.33104C11.2971 3.35108 11.3488 3.32251 11.3539 3.3616C11.3476 3.38798 11.3677 3.41228 11.3508 3.43439C11.3466 3.4555 11.3488 3.4882 11.3234 3.49979C11.2982 3.50085 11.2717 3.50185 11.2538 3.48287C11.2506 3.44704 11.2199 3.40589 11.2506 3.37212C11.2148 3.31732 11.1577 3.26344 11.085 3.2783L11.0607 3.24453C11.0461 3.11375 11.0597 2.97237 10.9606 2.87747C10.8361 2.70126 10.6494 2.57474 10.4901 2.43549C10.4901 2.42696 10.4879 2.41857 10.4965 2.41438L10.5176 2.42177C10.6768 2.56728 10.8614 2.68762 10.9943 2.86063C11.0566 2.96604 11.1504 3.0578 11.1578 3.18547C11.1959 3.14438 11.1937 3.08638 11.2264 3.04416L11.2297 3.02625C10.7665 2.47459 10.2137 2.03687 9.59146 1.8195C9.13349 1.65133 8.64495 1.52267 8.12407 1.52594V1.52594Z",
    fill: "url(#paint4_linear_9_3255)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12409 2.44434C7.95449 2.45265 7.78844 2.46886 7.62574 2.4936C6.9875 2.62964 6.39462 2.89549 5.9242 3.41345C5.61301 3.73509 5.42628 4.10855 5.29876 4.50618L5.3166 4.56212C5.2618 4.75518 5.22278 4.95456 5.21539 5.16652L5.1775 5.20874C5.15952 5.63807 5.24488 6.02518 5.37148 6.39444C5.41889 6.47036 5.42102 6.5843 5.52345 6.61906L5.66888 6.87545C5.66888 6.93971 5.71651 6.98619 5.74807 7.0378L5.76171 7.03353L5.84196 6.80572H6.85458L6.88934 6.7266L6.96852 6.72234V6.59155C6.959 6.5484 6.91777 6.52829 6.88301 6.50824C6.88195 6.46389 6.96739 6.4882 6.93789 6.426C6.96945 6.39643 7.02439 6.44079 7.04536 6.40177C7.04117 6.38378 7.02326 6.37113 7.00328 6.37746C6.99056 6.36793 6.96419 6.3616 6.96852 6.3395C6.98118 6.32151 7.00215 6.32578 7.02127 6.32471C7.05069 6.31839 7.03172 6.28676 7.05176 6.27297C7.07287 6.26557 7.0824 6.28668 7.10031 6.28668C7.10884 6.28988 7.11516 6.27929 7.11715 6.27297C7.11197 6.17694 7.12661 6.07991 7.13194 5.98296C7.15206 5.96177 7.17203 5.92488 7.20792 5.93434C7.23742 5.92908 7.24375 5.96384 7.2596 5.97976H8.12401H8.98843C9.00428 5.96384 9.01061 5.92908 9.04025 5.93434C9.076 5.92481 9.09612 5.96177 9.11609 5.98296C9.12142 6.07991 9.13621 6.17694 9.13088 6.27297C9.13301 6.27929 9.13933 6.28988 9.14765 6.28668C9.16563 6.28668 9.17516 6.26557 9.19627 6.27297C9.21624 6.28668 9.19734 6.31839 9.22691 6.32471C9.24596 6.32578 9.267 6.32151 9.27965 6.3395C9.28384 6.36168 9.25747 6.36793 9.24475 6.37746C9.22477 6.37113 9.20686 6.38378 9.2026 6.40177C9.22378 6.44079 9.27851 6.39643 9.31014 6.426C9.28071 6.4882 9.36608 6.46389 9.36502 6.50824C9.33026 6.52829 9.28917 6.54833 9.27965 6.59155V6.72234L9.35869 6.7266L9.39345 6.80572H10.4061L10.4863 7.03353L10.5 7.0378C10.5317 6.98612 10.5791 6.93971 10.5791 6.87545L10.7247 6.61906C10.8269 6.5843 10.8291 6.47036 10.8766 6.39444C11.0031 6.02525 11.0885 5.63807 11.0707 5.20874L11.0328 5.16652C11.0253 4.95456 10.9864 4.75518 10.9314 4.56212L10.9496 4.50611C10.8219 4.10848 10.6352 3.73502 10.324 3.41338C9.85356 2.89542 9.26074 2.62957 8.6225 2.49352C8.4598 2.46879 8.29361 2.45265 8.12409 2.44434V2.44434Z",
    fill: "#E60012"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1241 6.0194L7.23538 6.01783C7.20588 6.01463 7.21753 5.97988 7.1901 5.97241C7.17105 5.97561 7.16579 5.99246 7.15946 6.00724L7.15207 6.26249L7.19735 6.25936L7.20055 6.0484L8.12403 6.05053L9.04751 6.0484L9.0507 6.25936L9.09613 6.26249L9.08866 6.00724C9.08234 5.99246 9.07722 5.97561 9.05803 5.97241C9.03073 5.9798 9.04225 6.01463 9.01275 6.01783L8.1241 6.0194V6.0194Z",
    fill: "url(#paint5_linear_9_3255)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19733 6.31836C7.18148 6.32781 7.14992 6.31722 7.15205 6.34579C7.15205 6.35844 7.1647 6.3605 7.17302 6.36683H9.07501C9.08347 6.3605 9.09612 6.35844 9.09612 6.34579C9.09811 6.31729 9.06655 6.32781 9.0507 6.31836H7.19733V6.31836Z",
    fill: "url(#paint6_linear_9_3255)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10033 6.4397L7.08356 6.4429C7.07609 6.45128 7.05399 6.45242 7.06245 6.47034C7.06245 6.48086 7.0741 6.47986 7.07922 6.48398H9.16887C9.17413 6.47979 9.18564 6.48086 9.18564 6.47034C9.1941 6.45242 9.172 6.45128 9.16468 6.4429L9.14769 6.4397H7.10033Z",
    fill: "url(#paint7_linear_9_3255)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99704 6.53564V6.72664H7.0308L7.05497 6.62222C7.07189 6.579 7.12463 6.58213 7.16266 6.58839C7.22073 6.61377 7.19528 6.68023 7.21128 6.72657H7.24923L7.26281 6.62642C7.27347 6.59372 7.3061 6.58945 7.33567 6.58839C7.36517 6.59052 7.3946 6.59265 7.41471 6.61903C7.43781 6.65386 7.40625 6.74463 7.47698 6.72664C7.48224 6.68243 7.47698 6.63488 7.50854 6.60218C7.53605 6.58846 7.56448 6.56742 7.59824 6.58114C7.62454 6.59159 7.633 6.6127 7.64359 6.63701C7.66584 6.66445 7.6362 6.74562 7.69534 6.72664C7.69434 6.68342 7.69434 6.6412 7.71965 6.6085C7.74076 6.58746 7.77239 6.59166 7.80182 6.59166C7.87155 6.59905 7.85669 6.6771 7.86842 6.72664L7.92635 6.72238C7.92848 6.69714 7.92422 6.66971 7.93069 6.64653C7.94433 6.61803 7.97696 6.60431 8.0034 6.59166C8.08038 6.59379 8.16781 6.59379 8.24479 6.59166C8.27124 6.60438 8.30386 6.61803 8.31765 6.64653C8.32398 6.66971 8.31964 6.69714 8.32184 6.72238L8.37992 6.72664C8.39136 6.6771 8.37672 6.59905 8.44631 6.59166C8.47595 6.59166 8.50758 6.58746 8.52855 6.6085C8.55392 6.6412 8.55392 6.68342 8.55286 6.72664C8.61193 6.74569 8.58243 6.66445 8.6046 6.63701C8.61505 6.6127 8.62365 6.59159 8.64995 6.58114C8.68372 6.56742 8.71215 6.58846 8.73966 6.60218C8.77122 6.63488 8.7661 6.68243 8.77122 6.72664C8.84194 6.74463 8.81031 6.65393 8.83348 6.61903C8.8536 6.59265 8.88303 6.59059 8.91267 6.58839C8.9421 6.58953 8.97486 6.59372 8.98538 6.62642L8.9991 6.72657H9.03706C9.05291 6.68023 9.02754 6.61377 9.08554 6.58839C9.12349 6.58206 9.17617 6.57893 9.19322 6.62222L9.21753 6.72664H9.25116V6.53564H6.99704V6.53564Z",
    fill: "url(#paint8_linear_9_3255)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43268 6.88171L7.38086 6.84368C7.34084 6.83103 7.30388 6.84688 7.27971 6.88171H5.85873L5.83456 6.95755H7.16257L7.27012 7.06204C7.26379 7.13475 7.28291 7.20441 7.26592 7.27301C7.2564 7.28253 7.24794 7.29518 7.23209 7.28985C7.18788 7.26668 7.19513 7.20868 7.17622 7.16859C7.15305 7.13589 7.11829 7.09047 7.06967 7.11379C6.9875 7.16966 6.99063 7.27201 6.94521 7.34899L6.42312 7.34586C6.41878 7.31949 6.4315 7.28566 6.41253 7.26881L5.94211 7.2691L5.98 7.31103H6.35346C6.37244 7.30897 6.38729 7.32376 6.38097 7.34586L6.01611 7.34736L6.03907 7.37643H10.2089L10.2301 7.35219L9.86714 7.34586C9.86081 7.32369 9.8756 7.3089 9.89465 7.31103H10.268L10.306 7.27308L9.83558 7.26881C9.81653 7.28566 9.82925 7.31949 9.82513 7.34586L9.3029 7.34899C9.25755 7.27201 9.26074 7.16973 9.17843 7.11379C9.12995 7.09054 9.09505 7.13596 9.07188 7.16859C9.0529 7.20868 9.06022 7.26668 9.01601 7.28985C9.00016 7.29511 8.9917 7.28246 8.98218 7.27301C8.9654 7.20441 8.98431 7.13483 8.97798 7.06204L9.08553 6.95755H10.4137L10.3894 6.88171H8.96853C8.94422 6.84688 8.90733 6.83103 8.86717 6.84368L8.81556 6.88171H7.43268V6.88171Z",
    fill: "url(#paint9_linear_9_3255)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07291 7.41455C6.14875 7.48947 6.23376 7.56297 6.316 7.61884L6.39455 7.61813L6.77859 7.85341L6.81023 7.923C6.96852 7.98413 7.12561 8.04959 7.28384 8.11285H7.34923C7.40723 8.06544 7.35023 8.01064 7.33558 7.96095L7.4631 7.82277C7.52217 7.79214 7.556 7.89663 7.60867 7.83969C7.63938 7.80905 7.62246 7.75524 7.62246 7.71522C7.66888 7.66561 7.73847 7.65502 7.7954 7.62232H7.82604C7.86201 7.63817 7.86933 7.67713 7.88831 7.70456C7.90828 7.70776 7.93259 7.7003 7.95477 7.69824C7.98121 7.68985 7.99066 7.66127 7.99265 7.63604C8.01277 7.56595 8.23575 7.56709 8.25544 7.63604C8.25743 7.66127 8.26702 7.68985 8.29332 7.69824C8.3155 7.7003 8.33974 7.70776 8.35978 7.70456C8.37876 7.67713 8.38623 7.6381 8.42198 7.62232H8.45269C8.50962 7.65502 8.57928 7.66554 8.62577 7.71522C8.62577 7.75524 8.60878 7.80905 8.63934 7.83969C8.69209 7.89663 8.72592 7.79214 8.78499 7.82277L8.91265 7.96095C8.89786 8.01057 8.84093 8.06544 8.89886 8.11285H8.96426C9.12255 8.04959 9.27971 7.98413 9.43787 7.923L9.46964 7.85341L9.85354 7.61813C9.87984 7.6128 9.91361 7.63078 9.94005 7.61486C10.0223 7.55906 10.0993 7.4894 10.1753 7.41455H6.07291V7.41455Z",
    fill: "#E60012"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06872 7.61816C8.01911 7.62655 8.01385 7.68882 7.99267 7.72578L7.91263 7.73936C7.85143 7.77006 7.85555 7.69088 7.82293 7.66671C7.77111 7.64347 7.73322 7.69308 7.68795 7.7046C7.6372 7.72045 7.67003 7.78798 7.66051 7.82913C7.64359 7.85756 7.6141 7.87235 7.58765 7.8882C7.54238 7.90818 7.51707 7.86069 7.47698 7.85757L7.37043 7.96092C7.3693 7.98309 7.38408 8.00001 7.39041 8.02006C7.43149 8.06747 7.37562 8.10969 7.35977 8.15085C7.32814 8.17608 7.28606 8.14765 7.25962 8.14765C7.23211 8.19399 7.20581 8.24148 7.19003 8.29322C7.19735 8.32272 7.23112 8.34909 7.25642 8.36601C7.25642 8.40183 7.24057 8.43872 7.25642 8.47249H7.28706C7.28492 8.43027 7.28919 8.38918 7.29751 8.35115L7.23531 8.30694C7.22899 8.27424 7.2459 8.251 7.25223 8.22356C7.27341 8.1856 7.3356 8.20984 7.37036 8.20245L7.43895 8.0959C7.46206 8.06427 7.4305 8.03896 7.41152 8.01572C7.40619 7.97776 7.44308 7.95665 7.46739 7.93028C7.50435 7.92083 7.53697 7.944 7.57074 7.95352C7.61083 7.91343 7.65511 7.87967 7.70152 7.85337C7.70891 7.8174 7.68987 7.7911 7.69207 7.75727C7.70685 7.73929 7.73315 7.73509 7.75426 7.72571C7.80487 7.68022 7.82499 7.76154 7.85442 7.78158L8.00326 7.7668C8.03801 7.76566 8.03389 7.72251 8.04434 7.6982C8.05522 7.65477 8.19297 7.65534 8.20356 7.6982C8.21415 7.72251 8.20989 7.76566 8.24464 7.7668L8.39341 7.78158C8.42305 7.76154 8.44303 7.68022 8.49364 7.72571C8.51475 7.73516 8.54119 7.73929 8.55583 7.75727C8.55796 7.7911 8.53906 7.8174 8.54638 7.85337C8.59279 7.87967 8.637 7.91343 8.67716 7.95352C8.711 7.944 8.74377 7.92083 8.78051 7.93028C8.80482 7.95665 8.84171 7.97776 8.83638 8.01572C8.8174 8.03896 8.78584 8.06427 8.80909 8.0959L8.87768 8.20245C8.91244 8.20984 8.97463 8.1856 8.99581 8.22356C9.00214 8.251 9.01891 8.27424 9.01259 8.30694L8.95032 8.35115C8.95885 8.38918 8.96305 8.43027 8.96084 8.47249H8.99148C9.00726 8.43872 8.99148 8.40183 8.99148 8.36601C9.01671 8.34909 9.05054 8.32272 9.05787 8.29322C9.04209 8.24148 9.01579 8.19399 8.98828 8.14765C8.96198 8.14765 8.91969 8.17608 8.88813 8.15085C8.87228 8.10969 8.81641 8.06747 8.85749 8.02006C8.86382 8.00001 8.8786 7.98302 8.87761 7.96092L8.77092 7.85757C8.73083 7.86069 8.70552 7.90818 8.66025 7.8882C8.6338 7.87235 8.60431 7.85756 8.58739 7.82913C8.57787 7.78798 8.61063 7.72045 8.5601 7.7046C8.5146 7.69308 8.47672 7.64347 8.42497 7.66671C8.39235 7.69095 8.39654 7.77006 8.33527 7.73936L8.25523 7.72578C8.23405 7.68882 8.22879 7.62655 8.17918 7.61816C8.143 7.62328 8.10511 7.62328 8.06872 7.61816Z",
    fill: "url(#paint10_linear_9_3255)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70578 8.03365C7.58878 8.15605 7.46965 8.28897 7.47065 8.45871C7.48422 8.45771 7.50007 8.46191 7.51173 8.45558C7.54237 8.35429 7.5676 8.25094 7.64984 8.17183C7.88554 7.89817 8.3627 7.89852 8.59819 8.17183C8.68043 8.25094 8.70574 8.35429 8.7363 8.45558C8.74796 8.46191 8.76381 8.45771 8.77738 8.45871C8.77859 8.2889 8.65925 8.15598 8.54225 8.03365C8.35766 7.86433 7.88931 7.86519 7.70578 8.03365V8.03365Z",
    fill: "url(#paint11_linear_9_3255)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90942 8.14428C7.79128 8.19176 7.66788 8.31623 7.65729 8.44808H7.68792C7.73121 8.35418 7.79974 8.25609 7.89883 8.20968C8.01242 8.15402 8.23633 8.15437 8.34935 8.20968C8.44858 8.25609 8.51704 8.35418 8.5604 8.44808H8.59089C8.58037 8.31623 8.4569 8.19176 8.33876 8.14428C8.24422 8.09857 8.00332 8.09886 7.90942 8.14428V8.14428Z",
    fill: "url(#paint12_linear_9_3255)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0687 8.40694C8.01595 8.4154 7.95369 8.408 7.91992 8.45549C7.91992 8.53567 7.91992 8.62743 7.91992 8.70761L7.92625 8.715C8.00558 8.75936 8.24299 8.75907 8.32175 8.715L8.32808 8.70761C8.32808 8.62743 8.32808 8.53567 8.32808 8.45549C8.28713 8.39784 8.1407 8.40424 8.0687 8.40694Z",
    fill: "url(#paint13_linear_9_3255)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95059 8.92917L7.81974 8.849C7.80616 8.84381 7.78384 8.83749 7.77112 8.849C7.77858 8.89328 7.8282 8.92597 7.86082 8.95348C8.03105 9.02917 8.21707 9.02917 8.38716 8.95348C8.42 8.92597 8.46954 8.89328 8.47693 8.849C8.46421 8.83749 8.4421 8.84381 8.42831 8.849L8.29746 8.92917C8.1779 8.96613 8.07036 8.96613 7.95059 8.92917Z",
    fill: "url(#paint14_linear_9_3255)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6194 8.9292C7.60873 8.93553 7.59189 8.94192 7.59189 8.95663C7.71323 9.09168 7.86719 9.18131 8.04753 9.1887C8.09856 9.19013 8.14946 9.19013 8.2005 9.1887C8.38083 9.18131 8.5348 9.09175 8.65614 8.95663C8.65614 8.94192 8.63929 8.93553 8.62877 8.9292C8.24108 9.21813 8.00701 9.21813 7.6194 8.9292Z",
    fill: "url(#paint15_linear_9_3255)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02763 9.44811C8.00012 9.43858 8.00431 9.41008 7.99919 9.38904C7.99919 9.32463 7.92094 9.34262 7.88205 9.31944C7.82611 9.28987 7.80621 9.35527 7.76804 9.37112C7.74068 9.3648 7.71637 9.35108 7.69533 9.33004L7.70165 9.25092C7.67009 9.20984 7.6278 9.19071 7.59198 9.16022C7.55089 9.14444 7.52026 9.17394 7.48749 9.18865C7.45053 9.21083 7.43368 9.16441 7.40845 9.1465C7.39892 9.1106 7.4211 9.08743 7.44321 9.06419C7.46965 9.01464 7.41257 8.97348 7.39779 8.9292L7.23849 8.96403C7.24916 9.02623 7.30709 8.9619 7.34618 8.97036C7.36736 8.98827 7.37049 9.01358 7.38734 9.03263C7.39366 9.06959 7.36516 9.10008 7.34199 9.12958L7.45998 9.25092C7.50547 9.25405 7.52758 9.20351 7.57712 9.21929C7.58757 9.22562 7.58878 9.23621 7.58757 9.24673C7.61614 9.2404 7.63199 9.27523 7.66043 9.25725C7.66576 9.26251 7.67088 9.26891 7.6772 9.27097C7.69419 9.29734 7.66576 9.31319 7.65723 9.33317C7.63825 9.38591 7.71317 9.38591 7.73314 9.41967C7.79434 9.46922 7.806 9.37859 7.8576 9.36487C7.91248 9.34269 7.94631 9.38918 7.98839 9.40602C7.99052 9.43346 7.99792 9.46197 8.00957 9.48194H8.23838C8.25004 9.46197 8.25743 9.43339 8.25956 9.40602C8.30178 9.38918 8.3354 9.34269 8.39035 9.36487C8.44209 9.37859 8.45361 9.46929 8.51481 9.41967C8.53478 9.38591 8.60984 9.38591 8.59072 9.33317C8.58234 9.31319 8.55383 9.29734 8.57075 9.27097C8.57708 9.26891 8.58234 9.26251 8.58752 9.25725C8.6161 9.27523 8.63195 9.2404 8.66038 9.24673C8.65917 9.23628 8.66038 9.22562 8.67083 9.21929C8.72037 9.20351 8.74255 9.25405 8.78797 9.25092L8.90611 9.12958C8.88279 9.10008 8.85429 9.06952 8.86061 9.03263C8.8776 9.01358 8.88073 8.98827 8.90177 8.97036C8.94086 8.9619 8.99886 9.02623 9.00946 8.96403L8.85017 8.9292C8.83538 8.97348 8.77845 9.01464 8.80475 9.06419C8.82692 9.08743 8.84903 9.1106 8.8395 9.1465C8.81427 9.16441 8.79735 9.21076 8.76046 9.18865C8.72769 9.17394 8.6972 9.14444 8.65597 9.16022C8.62015 9.19078 8.57786 9.20984 8.5463 9.25092L8.55262 9.33004C8.53144 9.35108 8.50735 9.3648 8.47991 9.37112C8.44195 9.35527 8.42184 9.28987 8.3659 9.31944C8.32694 9.34262 8.2489 9.32463 8.2489 9.38904C8.24364 9.41008 8.24776 9.43858 8.22047 9.44811C8.18244 9.43816 8.0658 9.43816 8.02763 9.44811V9.44811Z",
    fill: "url(#paint16_linear_9_3255)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1241 2.36273H8.43906L8.44219 2.3596C8.29342 2.22035 8.17528 2.06319 8.19646 1.85116C8.18267 1.74674 8.21125 1.66024 8.27664 1.58851L8.24487 1.57373C8.20549 1.57551 8.16469 1.5743 8.12418 1.57373C8.08366 1.5743 8.04279 1.57551 8.00348 1.57373L7.97185 1.58851C8.03724 1.66024 8.06568 1.74674 8.05189 1.85116C8.07307 2.06319 7.95493 2.22035 7.8063 2.3596L7.80943 2.36273H8.1241Z",
    fill: "url(#paint17_linear_9_3255)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32813 1.61591C8.31868 1.63596 8.34299 1.6339 8.35244 1.63596C8.59512 1.65494 8.83139 1.6887 9.0403 1.78892C9.1288 1.83008 9.11401 1.99044 9.23748 1.96201C9.27025 1.95241 9.26272 1.91559 9.25859 1.89235C9.09184 1.69822 8.83139 1.70036 8.60457 1.63603C8.51266 1.62963 8.42004 1.59167 8.32813 1.61591V1.61591Z",
    fill: "#F39800"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27978 1.70556C8.27125 1.71501 8.28077 1.7266 8.29023 1.72986C8.50319 1.73299 8.70897 1.74984 8.88198 1.85113C8.91041 1.88283 8.94738 1.9092 8.99166 1.89229C8.99692 1.88177 9.01064 1.88596 9.01277 1.87544L9.00964 1.85433C8.92726 1.80059 8.83137 1.77735 8.73634 1.7541C8.58884 1.72766 8.44099 1.6907 8.27978 1.70556V1.70556Z",
    fill: "#F39800"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54239 2.03777C9.55817 2.01879 9.56862 1.99348 9.55917 1.96818C9.49057 1.86156 9.37562 1.81201 9.26486 1.77832C9.39154 1.84691 9.35564 2.07892 9.54239 2.03777Z",
    fill: "#F39800"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23532 1.78482C8.22899 1.80174 8.24904 1.80174 8.25544 1.80906C8.42731 1.81645 8.58759 1.84915 8.75748 1.86073C8.7638 1.85654 8.75961 1.84708 8.7606 1.84076C8.58752 1.81965 8.42098 1.78375 8.24157 1.77856L8.23532 1.78482Z",
    fill: "#F39800"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27655 1.8754C8.27122 1.89225 8.2912 1.89118 8.30072 1.89545C8.47692 1.91443 8.65099 1.95772 8.83338 1.9408C8.8397 1.93241 8.85555 1.92921 8.85349 1.91649C8.83764 1.89545 8.81021 1.91123 8.79123 1.91649C8.62249 1.91649 8.46107 1.89431 8.30698 1.85742C8.29752 1.86382 8.27655 1.85849 8.27655 1.8754Z",
    fill: "#F39800"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59723 1.90918C9.67407 1.98616 9.72482 2.07366 9.78389 2.1581C9.80706 2.18547 9.84281 2.18867 9.87345 2.18654C9.89463 2.17069 9.92108 2.14645 9.90508 2.11688C9.87139 2.04203 9.78709 1.98815 9.71849 1.94707C9.6784 1.93448 9.63831 1.90918 9.59723 1.90918V1.90918Z",
    fill: "#F39800"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79544 2.01353C8.61725 2.03038 8.46115 1.98503 8.30073 1.97131C8.29966 1.9829 8.31132 1.99135 8.32184 1.99235C8.54453 2.02192 8.77959 2.08205 9.00968 2.0335C9.03079 2.02298 9.05496 2.01239 9.06874 1.98915C9.06661 1.9765 9.07294 1.96072 9.05808 1.95432C8.96106 1.94181 8.88294 1.99349 8.79544 2.01353V2.01353Z",
    fill: "#F39800"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16153 2.02736C9.10132 2.04634 9.03585 2.0516 8.98218 2.08636C9.09307 2.10008 9.22266 2.12645 9.33768 2.09595C9.34721 2.08742 9.36512 2.0843 9.36512 2.06851C9.37045 2.04214 9.35879 2.0221 9.34522 2.00312C9.29027 1.97462 9.20582 1.97881 9.16153 2.02736V2.02736Z",
    fill: "#F39800"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1087 2.34164C10.1255 2.34164 10.1572 2.34797 10.1647 2.3206C10.1773 2.17495 10.0286 2.08952 9.91888 2.03052C10.0244 2.11695 9.98648 2.26892 10.1087 2.34164V2.34164Z",
    fill: "#F39800"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31761 2.08638C8.30915 2.09377 8.30596 2.10436 8.30702 2.11702C8.37669 2.15291 8.42637 2.23409 8.50436 2.24887H8.5148C8.519 2.22883 8.49682 2.20771 8.50436 2.18667C8.53165 2.1603 8.56663 2.15504 8.59407 2.13073C8.58347 2.09271 8.53386 2.08851 8.50116 2.07167C8.44941 2.06108 8.38408 2.06008 8.33865 2.08638H8.31761V2.08638Z",
    fill: "#F39800"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49687 2.13069C9.43148 2.1454 9.35876 2.1444 9.29337 2.15812C9.2987 2.1749 9.31867 2.1803 9.33445 2.18656C9.43268 2.20873 9.54549 2.23823 9.64884 2.2066C9.67209 2.18549 9.67628 2.15599 9.67315 2.12436C9.62254 2.0832 9.54869 2.11171 9.49687 2.13069V2.13069Z",
    fill: "#F39800"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8472 2.17616C8.86938 2.21838 8.92091 2.23317 8.9642 2.24475C8.98751 2.21412 9.02448 2.20466 9.06137 2.20047C9.06769 2.1962 9.06336 2.18881 9.06456 2.18256C9.0254 2.15092 8.96846 2.16038 8.91991 2.14872C8.89049 2.14666 8.85665 2.14666 8.8472 2.17616V2.17616Z",
    fill: "#F39800"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2649 2.39754C10.2785 2.42185 10.3038 2.4345 10.3303 2.43877C10.3534 2.43564 10.3767 2.41872 10.3862 2.39754C10.4052 2.32795 10.3451 2.28253 10.3028 2.23512C10.268 2.20988 10.2333 2.18451 10.1953 2.16553C10.2131 2.23725 10.2595 2.3121 10.2649 2.39754Z",
    fill: "#F39800"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58023 2.23503C8.58236 2.26254 8.61406 2.26347 8.62885 2.28244C8.69942 2.31734 8.77746 2.34578 8.86084 2.33838C8.91265 2.28877 8.8113 2.27619 8.81975 2.22764C8.77334 2.16964 8.68798 2.19395 8.62259 2.19288C8.60674 2.2034 8.58243 2.21293 8.58023 2.23503Z",
    fill: "#F39800"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04444 2.27309C9.03705 2.30052 9.06968 2.29214 9.08233 2.30372C9.13827 2.31424 9.18255 2.36073 9.24794 2.33848C9.25534 2.27209 9.3461 2.32377 9.34824 2.25837C9.3144 2.22994 9.26273 2.24153 9.22378 2.22461C9.16151 2.23513 9.09718 2.24153 9.04444 2.27309Z",
    fill: "#F39800"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73955 2.26886C9.68681 2.26779 9.62988 2.2646 9.58026 2.26573V2.27618C9.68162 2.30682 9.77545 2.38906 9.89465 2.34897C9.91683 2.32367 9.95052 2.30362 9.94007 2.26566C9.89053 2.20027 9.82393 2.27405 9.75654 2.25507L9.73955 2.26886V2.26886Z",
    fill: "#F39800"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33133 2.36907C9.33247 2.38172 9.31228 2.3997 9.33446 2.40702C9.4189 2.40496 9.48962 2.43872 9.56979 2.44505C9.60242 2.45031 9.58877 2.41335 9.58657 2.39757C9.54015 2.34277 9.46957 2.32059 9.39672 2.33118C9.37561 2.34589 9.34398 2.34376 9.33133 2.36907V2.36907Z",
    fill: "#F39800"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58438 2.34912C8.57173 2.37656 8.61083 2.38814 8.62881 2.3976C8.68894 2.42191 8.76692 2.40392 8.82286 2.43882C8.83864 2.4325 8.85229 2.45247 8.86395 2.4357C8.85549 2.41139 8.82919 2.4008 8.81234 2.38296C8.73429 2.37656 8.64985 2.38608 8.58438 2.34912Z",
    fill: "#F39800"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94739 2.4144C8.96537 2.4682 9.02864 2.47453 9.06454 2.51455C9.08764 2.51355 9.12347 2.54838 9.13413 2.51142C9.132 2.49358 9.14891 2.48086 9.16157 2.47346C9.18893 2.46714 9.21325 2.45235 9.23429 2.43131C9.24275 2.39542 9.20045 2.407 9.18567 2.39016C9.11394 2.37644 8.99793 2.33528 8.94739 2.4144Z",
    fill: "#F39800"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85669 2.4218C9.9717 2.48293 10.0908 2.56951 10.2333 2.54946C10.2576 2.52835 10.2712 2.49878 10.2649 2.46928C10.1974 2.38065 10.0772 2.43659 9.98115 2.43133L9.85669 2.4218V2.4218Z",
    fill: "#F39800"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6868 2.47672C9.77964 2.49364 9.85136 2.56216 9.93253 2.60438L9.92941 2.58747C9.8756 2.49883 9.78497 2.45348 9.69739 2.42505H9.67728L9.6868 2.47672V2.47672Z",
    fill: "#F39800"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22058 2.54216V2.54955C9.30595 2.57379 9.37774 2.64231 9.47591 2.62546C9.46531 2.59376 9.42828 2.57372 9.42729 2.53896C9.43894 2.52211 9.45693 2.50733 9.46958 2.49048C9.42096 2.46518 9.35457 2.46617 9.29962 2.47676C9.26906 2.48728 9.22378 2.50207 9.22058 2.54216V2.54216Z",
    fill: "#F39800"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4273 2.50109C10.5708 2.64453 10.748 2.75002 10.8734 2.91564C10.8756 2.9494 10.8987 2.9831 10.8797 3.01579C10.8797 3.04216 10.8925 3.06434 10.9115 3.07806C10.9283 3.07806 10.9631 3.08339 10.9663 3.05382C10.9874 2.9494 10.8883 2.885 10.8219 2.81222C10.7006 2.68782 10.5676 2.59073 10.441 2.47998C10.4314 2.48204 10.4168 2.48851 10.4273 2.50109V2.50109Z",
    fill: "#F39800"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51804 2.56312C9.52649 2.59049 9.54647 2.61267 9.56659 2.63584C9.61826 2.6475 9.65317 2.71182 9.71529 2.68759C9.76804 2.69597 9.79668 2.64636 9.84608 2.64636C9.85042 2.64003 9.85355 2.62532 9.84289 2.62212C9.75439 2.56511 9.65636 2.52296 9.54235 2.53874L9.51804 2.56312V2.56312Z",
    fill: "#F39800"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3651 2.55254L10.7628 2.91228C10.7733 2.92173 10.7881 2.92173 10.8007 2.926L10.7976 2.91228C10.6604 2.78042 10.5224 2.65276 10.3789 2.53882C10.3704 2.53882 10.3609 2.54088 10.3651 2.55254V2.55254Z",
    fill: "#F39800"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1362 2.60866C10.1394 2.65607 10.2058 2.6319 10.2406 2.64235H10.2544C10.2586 2.62131 10.2279 2.60546 10.2089 2.59807C10.1846 2.59067 10.1561 2.59387 10.1362 2.60866Z",
    fill: "#F39800"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 2.64229C10.4842 2.78893 10.6351 2.96613 10.8176 3.05057C10.8377 3.05477 10.8482 3.03579 10.8387 3.01994C10.7944 2.97139 10.7354 2.95973 10.6867 2.92291C10.5676 2.83321 10.4579 2.72247 10.344 2.62231H10.3335V2.64229H10.3335V2.64229Z",
    fill: "#F39800"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97369 2.66666C9.98741 2.75529 10.0592 2.83227 10.1468 2.85026C10.2206 2.84912 10.1647 2.77221 10.1815 2.73632C10.1404 2.65827 10.056 2.68357 9.998 2.64661C9.98109 2.64029 9.97682 2.654 9.97369 2.66666Z",
    fill: "#F39800"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49374 2.67076V2.68022C9.51911 2.69081 9.54235 2.70446 9.56971 2.71185C9.56125 2.68967 9.53808 2.67489 9.51797 2.6665C9.50952 2.66757 9.50007 2.66337 9.49374 2.67076V2.67076Z",
    fill: "#F39800"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.306 2.74248C10.5044 2.90063 10.6773 3.12112 10.9009 3.21608C10.9262 3.22874 10.9631 3.22348 10.9906 3.22035C11.0181 3.19924 10.9843 3.17813 10.9802 3.15808C10.9179 3.07471 10.803 3.15069 10.7354 3.08217C10.5888 2.97143 10.4653 2.82586 10.3199 2.71191L10.3029 2.71504L10.306 2.74248V2.74248Z",
    fill: "#F39800"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70053 2.76692C9.70373 2.8144 9.76066 2.80275 9.7871 2.82912C9.81127 2.84703 9.83018 2.87447 9.85982 2.87766C9.92308 2.88612 9.8778 2.80907 9.9262 2.79543C9.9262 2.76159 9.88725 2.75214 9.87034 2.73316C9.8134 2.73416 9.73223 2.70885 9.70053 2.76692V2.76692Z",
    fill: "#F39800"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2332 2.85343C10.2406 2.91144 10.2279 2.97683 10.2711 3.02012C10.2954 3.04016 10.3313 3.05281 10.3618 3.03696C10.3914 3.01905 10.4262 3.04222 10.4579 3.02957C10.4905 3.01159 10.4557 2.98628 10.4547 2.96418C10.4083 2.90397 10.3555 2.85237 10.2816 2.84284C10.2702 2.826 10.2321 2.82912 10.2332 2.85343Z",
    fill: "#F39800"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9537 2.85012C9.97169 2.90066 9.93892 2.97771 10.0117 2.99882C10.0359 3.00416 10.0518 3.02946 10.0782 3.02946C10.0728 3.00622 10.0845 2.97778 10.1057 2.96407C10.1205 2.9598 10.1395 2.95454 10.1436 2.93975C10.1341 2.91871 10.1077 2.92497 10.0918 2.91239C10.0486 2.88808 10.0128 2.84806 9.96415 2.8396L9.9537 2.85012V2.85012Z",
    fill: "#F39800"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1572 3.02C10.1584 3.12548 10.2374 3.2004 10.3198 3.25521C10.3334 3.26153 10.3503 3.25727 10.3651 3.25833C10.3872 3.24568 10.3789 3.21725 10.3755 3.19927C10.345 3.10643 10.2184 3.12328 10.1994 3.02C10.1921 3.00201 10.153 2.98936 10.1572 3.02V3.02Z",
    fill: "#F39800"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5581 3.05045V3.0609C10.5846 3.10305 10.6583 3.11051 10.6519 3.17164C10.6573 3.17591 10.6657 3.17477 10.6731 3.17477C10.6911 3.13262 10.6393 3.09886 10.6109 3.07142C10.5941 3.06097 10.5698 3.02728 10.5581 3.05045Z",
    fill: "#F39800"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4168 3.11585C10.3946 3.24984 10.4842 3.36058 10.5898 3.43123C10.632 3.43657 10.6077 3.38276 10.6245 3.36165C10.6583 3.30471 10.6362 3.22873 10.6035 3.17812C10.5676 3.12111 10.4969 3.13064 10.4443 3.10633C10.4337 3.10426 10.4241 3.10739 10.4168 3.11585Z",
    fill: "#F39800"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2848 3.18857C11.287 3.20122 11.2774 3.22447 11.2986 3.22347C11.3249 3.2298 11.3154 3.19284 11.3397 3.18857C11.3428 3.16959 11.3376 3.15168 11.3197 3.14429C11.2955 3.14436 11.2996 3.17485 11.2848 3.18857Z",
    fill: "#F39800"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3123 3.28575C11.3461 3.31106 11.384 3.28469 11.4124 3.26884C11.4168 3.25405 11.4061 3.24246 11.3956 3.23713C11.3577 3.22881 11.3312 3.26258 11.3123 3.28575Z",
    fill: "#F39800"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6974 3.27536C10.6921 3.33229 10.6921 3.39981 10.6974 3.45149C10.6962 3.45888 10.7059 3.45355 10.711 3.45575C10.7185 3.44204 10.7205 3.42306 10.7385 3.41773C10.7965 3.4114 10.843 3.45575 10.9084 3.44516C10.9031 3.37344 10.8156 3.31857 10.7628 3.27216C10.7448 3.25638 10.7015 3.24266 10.6974 3.27536Z",
    fill: "#F39800"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.863 3.26882C10.9653 3.33109 11.0465 3.46187 11.1774 3.43444C11.1973 3.42918 11.1953 3.40807 11.1985 3.39335C11.1742 3.31943 11.0823 3.349 11.0254 3.32682C10.9675 3.31417 10.921 3.27095 10.863 3.2583V3.26882Z",
    fill: "#F39800"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3789 3.35115C10.4231 3.39017 10.4579 3.44184 10.4959 3.47248C10.4683 3.41547 10.4283 3.35847 10.3789 3.31738C10.3704 3.32478 10.3641 3.34169 10.3789 3.35115Z",
    fill: "#F39800"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0086 3.43777C11.0371 3.50209 11.0855 3.55803 11.1256 3.61817C11.1796 3.66032 11.2386 3.70887 11.3092 3.69096C11.3293 3.67198 11.3335 3.64035 11.3261 3.61397C11.288 3.55285 11.2163 3.55597 11.1636 3.52114C11.1142 3.48631 11.0624 3.45895 11.0118 3.42725L11.0086 3.43777V3.43777Z",
    fill: "#F39800"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7796 3.47246C10.7585 3.56728 10.881 3.57894 10.9041 3.65279C10.9231 3.6739 10.9559 3.66125 10.9801 3.66971C11.0117 3.66864 11.0349 3.70774 11.0665 3.68343C11.0201 3.57055 10.9041 3.48831 10.7871 3.46606L10.7796 3.47246V3.47246Z",
    fill: "#F39800"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5761 3.55906C10.6246 3.60121 10.6067 3.6698 10.6658 3.70783C10.7006 3.73207 10.7186 3.77109 10.7628 3.77323C10.7935 3.7701 10.8239 3.7679 10.8493 3.74899C10.8482 3.65829 10.7818 3.5791 10.7038 3.53482C10.6583 3.53909 10.6163 3.5275 10.5761 3.53169V3.55906V3.55906Z",
    fill: "#F39800"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5338 3.65285C11.5338 3.72884 11.5507 3.80589 11.5201 3.87334C11.5138 3.93134 11.4979 4.01152 11.5338 4.06007C11.5761 4.07692 11.5992 4.03576 11.6129 4.0084C11.6456 3.96617 11.6414 3.90071 11.6171 3.85643C11.596 3.78577 11.6004 3.70133 11.5507 3.64553C11.5444 3.64446 11.5381 3.64653 11.5338 3.65285Z",
    fill: "#F39800"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 3.73518C11.2364 3.81643 11.2964 3.91445 11.3883 3.95668C11.4136 3.96407 11.4462 3.96094 11.4579 3.93244C11.4663 3.9018 11.461 3.8691 11.4335 3.84905C11.3586 3.80164 11.2743 3.77946 11.2089 3.71094H11.1877V3.73518H11.1878Z",
    fill: "#F39800"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9388 3.74899V3.75951C10.9748 3.8038 11.0096 3.85334 11.074 3.84282C11.1087 3.84708 11.133 3.87552 11.171 3.87346C11.1656 3.8291 11.1182 3.78482 11.0771 3.75951C11.0339 3.75319 10.9958 3.72994 10.9463 3.7384L10.9388 3.74899V3.74899Z",
    fill: "#F39800"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7828 3.82163C10.7659 3.92604 10.8946 3.97032 10.9284 4.0537C10.9631 4.04204 10.9442 3.9893 10.9496 3.95661C10.9516 3.95028 10.9579 3.94502 10.9631 3.93976C10.9916 3.9281 11.017 3.96293 11.036 3.9355C11.0275 3.89228 10.9833 3.84899 10.9463 3.83215C10.9072 3.81523 10.8525 3.83947 10.8175 3.81104C10.806 3.81317 10.7902 3.80585 10.7828 3.82163V3.82163Z",
    fill: "#F39800"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1088 3.93973C11.1256 3.98294 11.1753 3.99453 11.2089 4.02197C11.2469 4.06739 11.267 4.12119 11.3018 4.16761H11.3092C11.2913 4.07158 11.2343 3.95877 11.1288 3.93233C11.1214 3.93233 11.1129 3.9302 11.1088 3.93973V3.93973Z",
    fill: "#F39800"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6689 3.96728C11.6784 4.05912 11.6055 4.12025 11.6267 4.21308C11.6436 4.23739 11.6753 4.23739 11.6995 4.23312C11.7586 4.19936 11.7331 4.12025 11.7343 4.06438C11.7257 4.02315 11.7058 3.98732 11.6888 3.94937C11.6752 3.94517 11.6709 3.95676 11.6689 3.96728V3.96728Z",
    fill: "#F39800"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2911 3.96704C11.2923 4.01239 11.3419 4.04509 11.3671 4.08411C11.4315 4.13792 11.4673 4.22968 11.5581 4.22655C11.5697 4.20331 11.5655 4.16855 11.5613 4.14318C11.5274 4.08304 11.4516 4.09257 11.4061 4.04615C11.3662 4.02405 11.3344 3.98289 11.2911 3.96704V3.96704Z",
    fill: "#F39800"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9907 4.00531C10.998 4.09281 11.0065 4.19623 11.0908 4.23738C11.1489 4.24684 11.19 4.29745 11.2469 4.3091C11.2721 4.26688 11.2449 4.21414 11.2332 4.17092C11.1954 4.10027 11.1477 3.99472 11.0497 3.99791C11.0295 3.9999 11.0064 3.99251 10.9907 4.00531Z",
    fill: "#F39800"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9147 4.1571C10.94 4.19087 10.9305 4.24887 10.9769 4.26472C11.0022 4.22996 10.9758 4.19087 10.96 4.1603C10.9515 4.14338 10.9199 4.13279 10.9147 4.1571V4.1571Z",
    fill: "#F39800"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4093 4.22985C11.4421 4.26461 11.4516 4.32894 11.5065 4.33321C11.5159 4.32055 11.5021 4.30797 11.499 4.29525C11.4727 4.26568 11.4399 4.22879 11.4093 4.20874V4.22985Z",
    fill: "#F39800"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0392 4.30267C11.0137 4.36807 11.0043 4.4651 11.0528 4.52417C11.0623 4.54208 11.0803 4.5526 11.1014 4.55161C11.1277 4.53796 11.1204 4.50412 11.1425 4.48614C11.1656 4.48194 11.1973 4.50938 11.2121 4.47569C11.2121 4.38285 11.1446 4.32058 11.0665 4.28476C11.055 4.28369 11.0434 4.29215 11.0392 4.30267V4.30267Z",
    fill: "#F39800"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8134 4.31956C11.807 4.34181 11.8292 4.36178 11.8313 4.38495C11.8767 4.62336 11.9431 4.8575 11.9211 5.11801C11.9262 5.21504 11.7934 5.25307 11.8176 5.35749L11.5065 5.06001C11.5223 5.01146 11.5075 4.95872 11.4928 4.91444C11.4589 4.92602 11.4527 4.96299 11.4337 4.98715L11.2333 4.80042C11.2881 4.74029 11.2765 4.63487 11.2428 4.56834C11.227 4.55469 11.2112 4.53991 11.188 4.54091C11.1563 4.55569 11.15 4.59365 11.1395 4.62421L11.1573 4.70652C11.1184 4.70226 11.0951 4.6454 11.0561 4.62741L11.0466 4.63793C11.0477 4.72863 11.0814 4.80668 11.1089 4.88693L12.0138 5.74765L12.0181 5.55779C11.9686 5.49339 11.8978 5.43745 11.8377 5.37739C11.8672 5.37945 11.899 5.36474 11.9212 5.33936C11.9717 5.25399 11.9686 5.14112 11.9622 5.03563C11.9548 4.78457 11.8904 4.55676 11.8314 4.32674C11.825 4.32489 11.8219 4.31636 11.8134 4.31956V4.31956Z",
    fill: "url(#paint18_linear_9_3255)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7311 4.32275C11.7776 4.53379 11.8387 4.73737 11.8376 4.96625C11.8303 5.02539 11.7722 5.06754 11.7827 5.12867C11.7923 5.14026 11.8124 5.13606 11.824 5.13294C11.8936 5.05176 11.8651 4.91564 11.8619 4.81122C11.8313 4.64454 11.7923 4.48212 11.7449 4.32282H11.7311V4.32275V4.32275Z",
    fill: "url(#paint19_linear_9_3255)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3123 4.39223C11.286 4.45243 11.286 4.54306 11.3123 4.60327C11.3249 4.60959 11.3439 4.62118 11.3577 4.60647C11.3777 4.55259 11.4589 4.52202 11.4232 4.45129C11.4094 4.40594 11.382 4.37325 11.3534 4.33742C11.324 4.33636 11.3271 4.37751 11.3123 4.39223V4.39223Z",
    fill: "#F39800"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.651 4.3544C11.7016 4.52627 11.7206 4.71194 11.7555 4.89028C11.7681 4.8998 11.7713 4.92091 11.7892 4.91779C11.8018 4.92298 11.8029 4.9104 11.8071 4.90407C11.8145 4.8745 11.7787 4.86398 11.7755 4.83867C11.7459 4.67412 11.7269 4.50537 11.6722 4.35134L11.6616 4.34082L11.651 4.3544Z",
    fill: "url(#paint20_linear_9_3255)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5855 4.43775C11.6404 4.63607 11.633 4.86076 11.7555 5.03164C11.7607 5.03896 11.7713 5.03476 11.7797 5.03583C11.7797 4.97676 11.7375 4.92722 11.7174 4.87341C11.6646 4.72051 11.6532 4.55063 11.6067 4.39553C11.6024 4.39027 11.594 4.38501 11.5855 4.38501V4.43775V4.43775Z",
    fill: "url(#paint21_linear_9_3255)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5021 4.43024C11.535 4.63694 11.5887 4.83426 11.6171 5.04196C11.6393 5.11901 11.6594 5.20651 11.7343 5.25299C11.7533 5.26564 11.769 5.2466 11.7859 5.2424C11.806 5.22975 11.806 5.20338 11.7997 5.18447C11.7236 5.07785 11.6129 4.98616 11.6129 4.84897C11.595 4.7034 11.5559 4.56735 11.5264 4.42704C11.5212 4.42278 11.5065 4.41972 11.5021 4.43024V4.43024Z",
    fill: "url(#paint22_linear_9_3255)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3261 4.71399C11.3208 4.76254 11.2986 4.84485 11.3672 4.86276C11.3767 4.87222 11.3767 4.88914 11.3915 4.8934C11.4231 4.89653 11.4442 4.86703 11.4505 4.84165C11.4589 4.76993 11.5148 4.65812 11.4294 4.60645L11.4093 4.61064L11.3261 4.71399V4.71399Z",
    fill: "#F39800"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1287 5.17388L11.3988 5.44392L11.3883 5.62325C11.3926 5.64223 11.4168 5.6433 11.4295 5.65481C11.4579 5.68324 11.4822 5.71708 11.5065 5.74444L11.5129 5.73712C11.5085 5.68438 11.518 5.63264 11.5444 5.59574C11.5877 5.61046 11.6098 5.65908 11.6478 5.68865C11.6213 5.77082 11.6499 5.85419 11.6753 5.92705C11.6888 5.9439 11.709 5.9439 11.7269 5.94816C11.7692 5.92072 11.7269 5.87004 11.7205 5.83415C11.7079 5.8173 11.6974 5.79626 11.7069 5.77508C11.7111 5.76989 11.7174 5.76769 11.7237 5.76875C11.7692 5.80778 11.7997 5.85213 11.8377 5.89329C11.8399 5.97446 11.6868 5.9987 11.7587 6.08314C11.7966 6.09686 11.8144 6.06203 11.842 6.04839C11.8652 6.01775 11.8631 5.9702 11.9 5.95129C11.9442 5.95449 11.9452 6.02088 11.9865 6.01356C11.9939 5.92911 12.0297 5.80572 11.9243 5.75511L11.1088 4.96924H11.1014L11.1287 5.17388V5.17388Z",
    fill: "url(#paint23_linear_9_3255)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1909 5.38497C11.1382 5.43671 11.1668 5.52215 11.1742 5.58535C11.2005 5.59906 11.208 5.55897 11.229 5.57163C11.2638 5.58961 11.2691 5.62551 11.2955 5.65074C11.3229 5.66126 11.3207 5.62856 11.3334 5.61598C11.3186 5.50737 11.3144 5.39136 11.2428 5.30905C11.1878 5.29732 11.2121 5.36073 11.1909 5.38497V5.38497Z",
    fill: "url(#paint24_linear_9_3255)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2089 5.65489C11.1404 5.72668 11.1394 5.82576 11.1426 5.92705C11.152 5.94176 11.1669 5.94176 11.1804 5.94176C11.2291 5.92492 11.2226 5.85213 11.2817 5.85533C11.2933 5.86372 11.2986 5.88902 11.3198 5.87957C11.3439 5.85739 11.3176 5.83102 11.3154 5.80679L11.2532 5.67188C11.248 5.65063 11.2258 5.65489 11.2089 5.65489V5.65489Z",
    fill: "url(#paint25_linear_9_3255)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3609 5.74464V5.99996C11.3683 6.00842 11.3767 6.0168 11.3883 6.01368C11.4083 5.99889 11.4146 5.96093 11.4475 5.96939C11.4569 5.98411 11.4727 5.98311 11.4885 5.98311C11.5138 5.93449 11.5255 5.85126 11.4853 5.8069L11.3956 5.71308C11.3703 5.70469 11.3609 5.72573 11.3609 5.74464V5.74464Z",
    fill: "url(#paint26_linear_9_3255)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5855 5.88907C11.5728 5.98091 11.575 6.08319 11.613 6.16238C11.6257 6.18662 11.6573 6.17503 11.6753 6.17283C11.7587 6.08113 11.6436 5.99249 11.6234 5.90393C11.6193 5.89127 11.6213 5.87329 11.6067 5.8691C11.5877 5.86177 11.596 5.88495 11.5855 5.88907Z",
    fill: "url(#paint27_linear_9_3255)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0634 6.07567C11.0645 6.08413 11.0592 6.10097 11.074 6.09685C11.1046 6.09053 11.1046 6.0493 11.1119 6.02087C11.1087 6.00189 11.1204 5.97765 11.1014 5.96606C11.0728 5.99243 11.0866 6.04411 11.0634 6.07567Z",
    fill: "url(#paint28_linear_9_3255)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1742 6.04221C11.112 6.15708 11.2269 6.23413 11.2226 6.34282C11.227 6.34801 11.227 6.3596 11.2364 6.3596C11.2595 6.36699 11.2817 6.34488 11.2849 6.32484C11.306 6.26051 11.3293 6.19603 11.3198 6.11806C11.2965 6.07164 11.3103 6.00731 11.2671 5.97248C11.2258 5.97034 11.2026 6.02103 11.1742 6.04221Z",
    fill: "url(#paint29_linear_9_3255)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5159 6.07277C11.5033 6.15401 11.4895 6.26056 11.5549 6.32169C11.5739 6.32375 11.6097 6.33541 11.6203 6.31117C11.6415 6.23625 11.5761 6.18777 11.5644 6.12131C11.5517 6.0813 11.5644 6.02948 11.5401 5.99365C11.5065 5.99998 11.535 6.05066 11.5159 6.07277V6.07277Z",
    fill: "url(#paint30_linear_9_3255)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3745 6.06964C11.3789 6.1646 11.3577 6.2511 11.3366 6.33547C11.3609 6.35019 11.3789 6.32069 11.3915 6.30484C11.3957 6.20888 11.4927 6.12977 11.4367 6.03161C11.4083 6.02635 11.3851 6.04639 11.3745 6.06964V6.06964Z",
    fill: "url(#paint31_linear_9_3255)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8039 6.15286C11.7691 6.22459 11.6404 6.2457 11.6794 6.3428C11.6899 6.33746 11.7236 6.35431 11.7236 6.32908C11.825 6.2784 11.8545 6.17504 11.8756 6.08008C11.844 6.09166 11.8345 6.13069 11.8039 6.15286V6.15286Z",
    fill: "url(#paint32_linear_9_3255)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0423 6.20033C11.0232 6.26778 10.9821 6.32586 10.9843 6.40184C11.0233 6.39331 11.0518 6.3491 11.0982 6.36694C11.1246 6.37647 11.0867 6.43127 11.1331 6.41549L11.1774 6.33965C11.1689 6.26892 11.1256 6.21198 11.0982 6.14865C11.0614 6.13806 11.0538 6.18028 11.0423 6.20033V6.20033Z",
    fill: "url(#paint33_linear_9_3255)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7649 6.34575C11.768 6.35528 11.7596 6.36885 11.7722 6.37319C11.7997 6.37845 11.8218 6.36885 11.8271 6.34263C11.825 6.32258 11.8462 6.30773 11.8376 6.29082C11.8048 6.28669 11.7912 6.32777 11.7649 6.34575V6.34575Z",
    fill: "url(#paint34_linear_9_3255)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4684 6.37338C11.5116 6.39449 11.5001 6.34061 11.5201 6.32163C11.5243 6.30898 11.5138 6.30265 11.5065 6.29419C11.4674 6.30059 11.48 6.34701 11.4684 6.37338V6.37338Z",
    fill: "url(#paint35_linear_9_3255)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6203 6.41547C11.5496 6.58848 11.4727 6.75829 11.3915 6.92711C11.3935 6.93664 11.3871 6.95348 11.4019 6.95448L11.4231 6.92711C11.4948 6.75723 11.5897 6.598 11.6446 6.42179C11.6478 6.40601 11.6267 6.41127 11.6203 6.41547Z",
    fill: "url(#paint36_linear_9_3255)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4927 6.47763L11.3155 6.927C11.3103 6.95337 11.2987 6.99446 11.3229 7.01664C11.3429 7.01984 11.3577 6.99666 11.3641 6.98188C11.365 6.88691 11.3988 6.80567 11.4294 6.72236C11.4684 6.6264 11.5169 6.53357 11.5444 6.43235C11.5192 6.41643 11.498 6.45659 11.4927 6.47763V6.47763Z",
    fill: "url(#paint37_linear_9_3255)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2469 6.45979C11.1446 6.46399 11.1077 6.579 11.0602 6.64653L11.0633 6.67496C11.1192 6.695 11.1688 6.61696 11.2194 6.67496C11.2532 6.68868 11.2554 6.64859 11.267 6.63274C11.2765 6.58419 11.3134 6.55469 11.3229 6.50507C11.3271 6.48084 11.3312 6.44714 11.3198 6.42603C11.2839 6.41125 11.2722 6.4524 11.2469 6.45979V6.45979Z",
    fill: "url(#paint38_linear_9_3255)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9937 6.45983C10.9148 6.4567 10.9148 6.54633 10.8797 6.59161C10.8819 6.64022 10.8746 6.69289 10.8872 6.73725C10.9367 6.7467 10.9641 6.69815 10.9937 6.66759C11.0348 6.60646 11.0623 6.53894 11.0601 6.45983C11.0591 6.40602 11.0095 6.44184 10.9937 6.45983V6.45983Z",
    fill: "url(#paint39_linear_9_3255)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6857 6.45974C11.6171 6.66857 11.5444 6.87635 11.402 7.05469C11.3672 7.08625 11.3123 7.08625 11.3018 7.14112C11.2934 7.16024 11.3155 7.16025 11.3229 7.16863C11.4178 7.15811 11.4579 7.05156 11.5097 6.98617C11.5878 6.81415 11.6573 6.64114 11.7206 6.46393C11.7186 6.45448 11.7258 6.44083 11.7132 6.4355C11.6995 6.43337 11.6879 6.44915 11.6857 6.45974V6.45974Z",
    fill: "url(#paint40_linear_9_3255)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 6.47361C11.3155 6.67185 11.231 6.87763 11.1393 7.07907C11.1214 7.1476 11.1077 7.24789 11.1773 7.29743C11.2004 7.30063 11.2099 7.27426 11.2152 7.25941C11.2448 7.15613 11.1845 7.04744 11.2395 6.95141C11.3071 6.78473 11.3798 6.62231 11.4578 6.45989C11.4516 6.42819 11.42 6.45883 11.4156 6.47361V6.47361Z",
    fill: "url(#paint41_linear_9_3255)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7586 6.5326C11.6614 6.79005 11.5738 7.06002 11.3261 7.24469C11.288 7.28158 11.2184 7.29324 11.2226 7.3597C11.2238 7.38607 11.2617 7.38188 11.2816 7.37647C11.3809 7.33852 11.4578 7.2309 11.5128 7.14439C11.6436 6.94295 11.7236 6.71933 11.7997 6.49457C11.7807 6.43351 11.768 6.51788 11.7586 6.5326Z",
    fill: "url(#paint42_linear_9_3255)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1635 7.7637L11.267 7.64243L11.2194 7.53276C11.3091 7.51051 11.3597 7.41249 11.3956 7.33863L11.3851 7.33551C11.3185 7.37553 11.269 7.45677 11.1804 7.44625L10.8176 6.65405L10.7416 6.79963L11.1635 7.7637V7.7637Z",
    fill: "url(#paint43_linear_9_3255)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1183 6.72674C11.0518 6.71408 10.997 6.75517 10.9663 6.80905C10.9537 6.85646 10.9559 6.91347 10.9938 6.94823C11.0086 6.96308 11.0233 6.97886 11.0465 6.97147C11.1024 6.91873 11.1477 6.85547 11.1774 6.789C11.1858 6.76796 11.19 6.74472 11.1878 6.71942C11.1688 6.69091 11.1372 6.71408 11.1183 6.72674V6.72674Z",
    fill: "url(#paint44_linear_9_3255)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15521 6.76786C9.14995 6.78464 9.16153 6.79843 9.17198 6.80575C9.18881 6.81102 9.19727 6.7973 9.20259 6.78464C9.20792 6.76786 9.19627 6.75407 9.18569 6.74668C9.16892 6.74149 9.16047 6.7562 9.15521 6.76786Z",
    fill: "url(#paint45_linear_9_3255)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05804 6.77114C9.05172 6.78905 9.0655 6.80277 9.07815 6.8091C9.09498 6.81336 9.10656 6.80071 9.11289 6.78905C9.11921 6.77114 9.10557 6.75742 9.093 6.75109C9.07602 6.74683 9.06458 6.75948 9.05804 6.77114Z",
    fill: "url(#paint46_linear_9_3255)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47372 6.77099C8.46839 6.78776 8.48004 6.80155 8.49049 6.80895C8.50848 6.81414 8.5158 6.80056 8.52213 6.7889C8.52647 6.77205 8.51474 6.75826 8.50429 6.75094C8.48744 6.74561 8.47912 6.75933 8.47372 6.77099V6.77099Z",
    fill: "url(#paint47_linear_9_3255)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2143 6.77521C8.20997 6.7932 8.21949 6.80905 8.23534 6.81637C8.24799 6.8153 8.26376 6.80692 8.26596 6.79213C8.2703 6.77308 8.26063 6.7573 8.24479 6.75098C8.23214 6.75098 8.21629 6.7605 8.2143 6.77521Z",
    fill: "url(#paint48_linear_9_3255)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91572 6.77504C8.91139 6.79196 8.92205 6.80255 8.9337 6.81307C8.95048 6.8194 8.96107 6.80255 8.96846 6.79196C8.97265 6.77505 8.96213 6.76453 8.95048 6.75401C8.9337 6.74661 8.92311 6.76353 8.91572 6.77504Z",
    fill: "url(#paint49_linear_9_3255)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83339 6.7711C8.8314 6.78788 8.83339 6.8038 8.85031 6.80906C8.86297 6.81112 8.87463 6.80273 8.87783 6.79221C8.87982 6.77636 8.87662 6.75945 8.86083 6.75426C8.84818 6.75205 8.83652 6.76051 8.83339 6.7711Z",
    fill: "url(#paint50_linear_9_3255)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68048 6.78147C8.68048 6.79732 8.68574 6.81317 8.7016 6.8163C8.71746 6.8163 8.72912 6.80471 8.72912 6.78886C8.73225 6.77301 8.72378 6.76043 8.71212 6.7541C8.69307 6.7509 8.68261 6.76569 8.68048 6.78147Z",
    fill: "url(#paint51_linear_9_3255)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40101 6.77522C8.39988 6.79007 8.39988 6.80372 8.41467 6.81325C8.42947 6.81957 8.44099 6.80273 8.44213 6.79214C8.4432 6.77735 8.4432 6.76256 8.4284 6.75418C8.41368 6.74678 8.40301 6.76477 8.40101 6.77522Z",
    fill: "url(#paint52_linear_9_3255)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58761 6.77831C8.58242 6.79516 8.59408 6.80895 8.60452 6.81627C8.62251 6.82153 8.62983 6.80681 8.63615 6.79516C8.64034 6.77831 8.62983 6.76459 8.61817 6.7572C8.6014 6.75194 8.59408 6.76672 8.58761 6.77831Z",
    fill: "url(#paint53_linear_9_3255)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87149 6.93767C8.87462 6.9693 8.84085 6.9651 8.82287 6.9651C8.81242 6.99041 8.8218 7.02211 8.85031 7.0305C8.86296 7.03362 8.87981 7.03576 8.88507 7.05161C8.87874 7.14444 8.91891 7.26676 8.85031 7.33848L8.85351 7.34168L8.97166 7.34594C8.98431 7.30692 8.95154 7.28787 8.9337 7.26257V7.03362C8.95901 7.01045 8.9991 6.9936 9.01595 6.95771C8.99377 6.95032 8.96846 6.97143 8.94002 6.96823C8.93889 6.9398 8.8936 6.8786 8.87149 6.93767V6.93767Z",
    fill: "url(#paint54_linear_9_3255)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2037 7.07569C8.27123 7.11158 8.2649 7.19702 8.28288 7.26242L8.29333 7.34893H8.53913C8.58234 7.32149 8.58654 7.26455 8.60452 7.2202C8.61405 7.17065 8.62251 7.10945 8.67411 7.0894C8.69742 7.08201 8.72472 7.08621 8.7427 7.09993C8.78819 7.13582 8.78499 7.19169 8.79864 7.24131H8.83653V7.07561C8.79658 7.04292 8.77547 7.00389 8.76068 6.96167H7.48749C7.47285 7.00389 7.45167 7.04292 7.41165 7.07561V7.24131H7.44954C7.46318 7.19169 7.45999 7.13582 7.50548 7.09993C7.52339 7.08621 7.5509 7.08194 7.574 7.0894C7.62582 7.10945 7.63413 7.17065 7.64359 7.2202C7.6615 7.26455 7.66583 7.32149 7.70898 7.34893H7.95478L7.96537 7.26242C7.98321 7.19702 7.97688 7.11158 8.04441 7.07569C8.0921 7.0695 8.15615 7.0695 8.2037 7.07569V7.07569Z",
    fill: "url(#paint55_linear_9_3255)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4273 7.26579C10.4147 7.30062 10.4475 7.29002 10.4621 7.30694C10.4652 7.3417 10.4526 7.38278 10.4716 7.41136C10.5508 7.4029 10.5729 7.31213 10.6067 7.25519C10.6141 7.21731 10.6362 7.18561 10.6276 7.14125C10.6119 7.11069 10.5856 7.13919 10.5655 7.14125C10.516 7.17501 10.4632 7.21404 10.4273 7.26579V7.26579Z",
    fill: "url(#paint56_linear_9_3255)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2248 7.24867C8.20362 7.21078 8.22579 7.15165 8.17931 7.12748C8.14441 7.12613 8.10362 7.12613 8.06865 7.12748C8.02224 7.15165 8.04434 7.21078 8.02316 7.24867H8.2248V7.24867Z",
    fill: "url(#paint57_linear_9_3255)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64666 7.17301L8.62881 7.24472H8.75756C8.74803 7.2067 8.75017 7.15503 8.71206 7.13818C8.68576 7.13818 8.65512 7.14344 8.64666 7.17301V7.17301Z",
    fill: "url(#paint58_linear_9_3255)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10243 7.19299C9.1003 7.21303 9.09298 7.23094 9.0961 7.25205L9.21311 7.25518C9.21944 7.22042 9.20479 7.1856 9.1888 7.15504C9.15624 7.12341 9.1035 7.14978 9.10243 7.19299V7.19299Z",
    fill: "url(#paint59_linear_9_3255)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72484 7.28695C9.7237 7.30281 9.73529 7.307 9.74588 7.31432C9.76379 7.31859 9.77865 7.30799 9.78711 7.29754C9.7891 7.28162 9.77744 7.27643 9.76699 7.26904C9.74901 7.26477 9.73436 7.27522 9.72484 7.28695V7.28695Z",
    fill: "url(#paint60_linear_9_3255)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M9.632 7.28371C9.62667 7.29744 9.64032 7.3059 9.64877 7.31117C9.66356 7.31223 9.67521 7.3091 9.68353 7.29751C9.68886 7.28378 9.67521 7.27433 9.66676 7.26899C9.65197 7.26793 9.64039 7.27105 9.632 7.28371Z",
    fill: "url(#paint61_linear_9_3255)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52116 7.28695C9.51917 7.30281 9.53069 7.307 9.54235 7.31432C9.56026 7.31859 9.57498 7.30799 9.58344 7.29754C9.58557 7.28162 9.57391 7.27643 9.56225 7.26904C9.54448 7.26477 9.52962 7.27522 9.52116 7.28695Z",
    fill: "url(#paint62_linear_9_3255)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41785 7.28981C9.41785 7.30567 9.4295 7.31733 9.44535 7.31733C9.46121 7.31832 9.47691 7.31306 9.48011 7.29728C9.48111 7.28136 9.46966 7.27617 9.459 7.26877C9.44102 7.26564 9.42105 7.27297 9.41785 7.28981Z",
    fill: "url(#paint63_linear_9_3255)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39773 7.28677C8.39453 7.29942 8.401 7.30894 8.41145 7.3174C8.42417 7.3206 8.43363 7.31413 8.44209 7.30368C8.44528 7.28997 8.43896 7.28051 8.42837 7.27305C8.41465 7.26985 8.4052 7.27618 8.39773 7.28677Z",
    fill: "url(#paint64_linear_9_3255)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33132 7.307C9.34192 7.31645 9.36197 7.31645 9.37242 7.307C9.38195 7.29435 9.37242 7.28063 9.35877 7.27637C9.34192 7.27637 9.31547 7.28582 9.33132 7.307Z",
    fill: "url(#paint65_linear_9_3255)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48426 7.28979C8.48113 7.30138 8.48746 7.3109 8.49804 7.31403C8.50955 7.31617 8.5222 7.31197 8.52533 7.30045C8.52746 7.2888 8.52114 7.27927 8.51176 7.27614C8.49904 7.27408 8.48639 7.2782 8.48426 7.28979V7.28979Z",
    fill: "url(#paint66_linear_9_3255)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31451 7.28979C8.31131 7.30138 8.3187 7.31091 8.32809 7.31404C8.33975 7.31617 8.34928 7.30984 8.35241 7.30046C8.35454 7.2888 8.34821 7.27927 8.33869 7.27614C8.32717 7.27294 8.31764 7.28041 8.31451 7.28979V7.28979Z",
    fill: "url(#paint67_linear_9_3255)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24906 7.34915C8.26164 7.26193 7.98632 7.26051 7.99912 7.34915H8.24906Z",
    fill: "url(#paint68_linear_9_3255)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61507 7.31108L8.61194 7.34591H8.7607C8.76916 7.33112 8.75857 7.31748 8.75758 7.30369C8.7101 7.30582 8.65835 7.2985 8.61507 7.31108V7.31108Z",
    fill: "url(#paint69_linear_9_3255)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0855 7.30685C9.07086 7.3163 9.05707 7.33109 9.058 7.34899L9.24792 7.34587C9.24273 7.27622 9.13938 7.31943 9.0855 7.30685V7.30685Z",
    fill: "url(#paint70_linear_9_3255)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2892 7.4356C10.2447 7.47256 10.1846 7.51471 10.189 7.57698C10.2374 7.59809 10.3113 7.51585 10.3302 7.59489C10.3597 7.58857 10.384 7.55587 10.3998 7.5327C10.4178 7.48408 10.4358 7.43141 10.4442 7.38393C10.4526 7.36488 10.4315 7.37867 10.4273 7.36914C10.3746 7.37653 10.3376 7.42089 10.2892 7.4356V7.4356Z",
    fill: "url(#paint71_linear_9_3255)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4273 7.60119C10.4125 7.64746 10.3081 7.66445 10.3619 7.71513C10.3947 7.71399 10.4125 7.76887 10.4484 7.7425C10.5032 7.67504 10.5824 7.60851 10.555 7.51468C10.537 7.48625 10.5065 7.51042 10.4823 7.50836C10.4579 7.53359 10.4484 7.57055 10.4273 7.60119V7.60119Z",
    fill: "url(#paint72_linear_9_3255)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1193 7.70145L10.0402 7.91561C10.0359 7.94724 10.0677 7.93985 10.0845 7.93985C10.1815 7.88078 10.2702 7.78162 10.3029 7.67721C10.3029 7.6593 10.3039 7.64032 10.2849 7.62866C10.2258 7.64231 10.1509 7.63605 10.1193 7.70145Z",
    fill: "url(#paint73_linear_9_3255)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89463 7.77406C9.87557 7.82147 9.86079 7.87527 9.86712 7.93007C9.92306 7.94166 9.96216 7.89219 10.0023 7.85736C10.0338 7.80988 10.0781 7.75402 10.0507 7.69495C9.98648 7.69282 9.9252 7.71706 9.89463 7.77406V7.77406Z",
    fill: "url(#paint74_linear_9_3255)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4652 7.83633C10.4093 8.08845 10.3123 8.32465 10.189 8.54834C10.1467 8.61266 10.0929 8.67713 10.0296 8.72454C10.2481 8.68133 10.4147 8.45451 10.4927 8.26146C10.5455 8.08319 10.6182 7.91445 10.6035 7.70874L10.4652 7.83633Z",
    fill: "#E60012"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2544 7.99243C10.1572 8.26978 10.0485 8.54828 9.79753 8.75612L9.69418 8.84895C9.85134 8.8036 10.0169 8.7488 10.1161 8.5937C10.2733 8.37633 10.3577 8.12848 10.4168 7.87109L10.2544 7.99243Z",
    fill: "#E60012"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78076 8.32049L9.67307 8.47239C9.35555 8.78678 8.83339 8.86796 8.43576 8.66964C8.41145 8.66012 8.38821 8.64747 8.3629 8.64221C8.35345 8.65799 8.36411 8.68336 8.37356 8.70127L8.40733 8.73191C8.63934 8.82886 8.88201 8.89959 9.15517 8.89746C9.41249 8.90485 9.62566 8.80143 9.81865 8.6528L9.84281 8.67711C10.0159 8.47772 10.1362 8.2583 10.2058 8.01562C10.0551 8.09687 9.9242 8.22453 9.78076 8.32049V8.32049Z",
    fill: "#E60012"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9252 8.03977L11.074 9.07462C11.0772 9.09154 11.1015 9.08414 11.112 9.08094L11.1224 9.07042L10.9558 8.04411C10.9483 8.02719 10.9378 8.04724 10.9252 8.03977V8.03977Z",
    fill: "#E60012"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5793 8.46613L10.6658 9.08425L11.0181 9.05361L10.9179 8.22347L10.8936 8.12012C10.7934 8.23093 10.6847 8.35013 10.5793 8.46613V8.46613Z",
    fill: "#E60012"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1446 8.60434C8.9337 8.63704 8.67945 8.68026 8.48007 8.59062C8.47694 8.5843 8.46642 8.58117 8.46962 8.57271C8.49272 8.55046 8.52442 8.57058 8.54966 8.57271C8.78813 8.63917 9.07089 8.60648 9.28285 8.50731C9.28484 8.4936 9.26906 8.49459 9.26174 8.49047C8.97998 8.52317 8.67725 8.50518 8.40423 8.46616C8.38411 8.46616 8.37146 8.47668 8.36293 8.49359L8.3598 8.60754L8.36933 8.61813C8.62145 8.69718 8.91359 8.80266 9.18888 8.70144C9.27965 8.67614 9.36288 8.63491 9.44839 8.59695C9.54648 8.5157 9.67407 8.44725 9.73214 8.3269C9.53177 8.40922 9.33978 8.51144 9.1446 8.60434V8.60434Z",
    fill: "#E60012"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5244 8.6487L10.5792 9.17505L10.6171 9.09487L10.5517 8.5C10.4864 8.53056 10.5328 8.59901 10.5244 8.6487Z",
    fill: "#E60012"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2923 8.69697C10.3218 8.89529 10.3419 9.09787 10.382 9.29192L10.8039 9.25389C10.8113 9.23917 10.8197 9.22546 10.8219 9.20854C10.7312 9.18849 10.651 9.23072 10.5581 9.22652C10.5422 9.19169 10.5464 9.14108 10.5413 9.0978L10.4823 8.57983C10.4283 8.64111 10.3556 8.65795 10.2923 8.69697V8.69697Z",
    fill: "#E60012"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2691 8.70451C8.27542 8.69818 8.27123 8.68865 8.27343 8.68026C8.17663 8.67657 8.07164 8.67657 7.97498 8.68026C7.97697 8.68865 7.97284 8.69818 7.97917 8.70451C8.05373 8.72377 8.19454 8.7237 8.2691 8.70451Z",
    fill: "#E60012"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2892 9.3543C10.3239 9.35537 10.3207 9.30163 10.3376 9.27526L10.2617 8.71509L10.2226 8.7394L10.2892 9.3543V9.3543Z",
    fill: "#E60012"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.095 8.81522L10.1468 9.45764L10.1572 9.47236L10.4684 9.46816C10.4885 9.4597 10.5224 9.45971 10.5244 9.43014L10.517 9.42381C10.4336 9.42061 10.3533 9.44385 10.2754 9.43014L10.2575 9.39218L10.1921 8.75928C10.1647 8.78885 10.1277 8.79624 10.095 8.81522V8.81522Z",
    fill: "#E60012"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0782 9.51986L10.1193 9.47863L10.0602 8.82886L10.0159 8.84578L10.0782 9.51986Z",
    fill: "#E60012"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96734 9.63077C10.0602 9.6371 10.1667 9.63816 10.2512 9.60326V9.59694C10.1868 9.59694 10.1267 9.60859 10.0644 9.61378L10.0538 9.59694L9.98425 8.85962L9.93243 8.88073L9.96734 9.63077V9.63077Z",
    fill: "#E60012"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85358 8.92177L9.86403 9.3088C9.8324 9.44492 9.77653 9.58622 9.81868 9.73499H9.83553L9.92936 9.63797L9.89772 8.89746C9.88301 8.90599 9.86296 8.90919 9.85358 8.92177V8.92177Z",
    fill: "#E60012"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77328 8.93559L9.81874 8.9704L9.82194 8.92188C9.80928 8.93452 9.78908 8.9314 9.77328 8.93559Z",
    fill: "#E60012"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68362 8.95035C9.72485 8.98625 9.77332 9.00309 9.81866 9.02946C9.8365 8.97992 9.76692 8.98831 9.74588 8.95668C9.73224 8.93031 9.70374 8.95142 9.68362 8.95035Z",
    fill: "#E60012"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53497 8.97033C9.62134 9.02201 9.71325 9.06324 9.80495 9.10219C9.81128 9.08946 9.80495 9.07262 9.81128 9.05997C9.74481 9.03352 9.67949 9.00616 9.62134 8.95654L9.53497 8.97033V8.97033Z",
    fill: "#E60012"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01276 9.01246L9.01595 9.0325C9.25428 9.15376 9.49588 9.26458 9.74267 9.36473L9.77018 9.31305C9.57393 9.22761 9.38088 9.13791 9.18889 9.04302L9.1203 8.99121C9.08135 9.00087 9.02129 8.93641 9.01276 9.01246V9.01246Z",
    fill: "#E60012"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38934 8.99136C9.51579 9.07891 9.65944 9.12639 9.80173 9.17805C9.80294 9.16647 9.79861 9.15282 9.80493 9.1433C9.70052 9.08424 9.58346 9.05468 9.48643 8.97778L9.38934 8.99136V8.99136Z",
    fill: "#E60012"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20688 8.99772C9.35245 9.10747 9.52119 9.16128 9.68041 9.23719L9.7871 9.27835C9.79662 9.2615 9.79975 9.24139 9.79755 9.21928C9.64245 9.15175 9.4779 9.1064 9.34193 8.99459C9.29438 8.99039 9.2491 9.00191 9.20688 8.99772Z",
    fill: "#E60012"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90201 9.04309C8.9094 9.07465 8.92525 9.10848 8.95788 9.12213L9.66682 9.44812C9.67627 9.45131 9.68579 9.45551 9.69745 9.45444C9.7101 9.43859 9.71209 9.41855 9.72489 9.40277L9.12669 9.12945L8.91999 9.0293C8.9126 9.03143 8.90833 9.03776 8.90201 9.04309V9.04309Z",
    fill: "#E60012"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6204 9.18452C10.7173 9.18985 10.8292 9.13817 10.9041 9.21622L11.1014 9.17506L11.056 9.10547L10.6519 9.14663L10.6204 9.18452V9.18452Z",
    fill: "#E60012"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80496 9.28892C8.76488 9.28892 8.73638 9.26255 8.69842 9.25729C8.68364 9.3681 8.6953 9.48624 8.70162 9.59691L8.70901 9.60324C8.8103 9.6075 8.89886 9.58106 8.99602 9.57587C8.99388 9.44402 8.98955 9.30477 8.98223 9.17085C8.95792 9.15493 8.93375 9.15713 8.91577 9.18443L8.80496 9.28892V9.28892Z",
    fill: "#E60012"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08862 9.6381C9.08862 9.49885 9.07718 9.35434 9.07185 9.21303L9.02011 9.18872L9.03383 9.6413L9.08862 9.6381Z",
    fill: "#E60012"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8524 9.22338C10.8481 9.24137 10.8588 9.26142 10.8692 9.27827C10.8787 9.28986 10.8904 9.29732 10.904 9.29938C10.9167 9.28986 10.9146 9.27095 10.9146 9.26142C10.8935 9.24876 10.8787 9.22025 10.8524 9.22338Z",
    fill: "#E60012"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11618 9.25398C9.12663 9.3532 9.10985 9.46281 9.13096 9.55777L9.39352 9.53034C9.42103 9.48918 9.41257 9.42699 9.41364 9.37105L9.1235 9.23706L9.11618 9.25398V9.25398Z",
    fill: "#E60012"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73223 9.48625H9.73536C9.74389 9.50942 9.74488 9.54005 9.76699 9.55476C9.77651 9.53692 9.77544 9.51368 9.78077 9.49257C9.80494 9.42193 9.83017 9.35228 9.83969 9.2753L9.82924 9.25732L9.72903 9.45455L9.73223 9.48625Z",
    fill: "#E60012"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3198 9.39219C10.5085 9.39219 10.6974 9.37108 10.8734 9.32998L10.8249 9.28882L10.3789 9.32366L10.3198 9.39219Z",
    fill: "#E60012"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62568 9.30877C8.6308 9.32675 8.61189 9.36051 8.64246 9.36151C8.66464 9.36471 8.66243 9.34367 8.66677 9.32995C8.66243 9.31623 8.66464 9.29725 8.64665 9.29199C8.63834 9.29405 8.62767 9.30038 8.62568 9.30877V9.30877Z",
    fill: "#E60012"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58762 9.41651L8.60141 9.64441C8.58762 9.6592 8.59188 9.68138 8.57077 9.69296L8.68479 9.67612C8.65622 9.59387 8.671 9.48511 8.65622 9.39234C8.63205 9.37443 8.60141 9.39341 8.58762 9.41651V9.41651Z",
    fill: "#E60012"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44207 9.56217C9.3872 9.59807 9.31228 9.58222 9.25101 9.60326C9.25001 9.62018 9.27219 9.61172 9.27958 9.62444C9.33552 9.63809 9.39878 9.62757 9.45571 9.62018L9.46631 9.60646C9.47782 9.56537 9.45252 9.50311 9.5 9.48199C9.56653 9.49991 9.62979 9.5326 9.69731 9.53467C9.69298 9.51469 9.68466 9.49145 9.66255 9.48619L9.45571 9.38916L9.44207 9.56217Z",
    fill: "#E60012"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29022 9.44821C8.28489 9.47458 8.28915 9.50514 8.27338 9.52732C8.27338 9.56954 8.26904 9.61802 8.29022 9.64859C8.38404 9.64333 8.47586 9.63274 8.56342 9.61376C8.57081 9.55682 8.56662 9.49676 8.55283 9.44394C8.51587 9.45873 8.48112 9.48929 8.43585 9.47238L8.38411 9.39966C8.34928 9.40805 8.29754 9.40385 8.29022 9.44821V9.44821Z",
    fill: "#E60012"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5623 9.41959C10.5559 9.44184 10.5635 9.46708 10.576 9.48614C10.5845 9.49979 10.5991 9.49979 10.6108 9.50611C10.6224 9.48926 10.615 9.46289 10.6171 9.44071C10.5992 9.43338 10.5866 9.4112 10.5623 9.41959V9.41959Z",
    fill: "#E60012"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0886 9.57264C10.2522 9.56838 10.4262 9.57051 10.5792 9.53043C10.5718 9.51565 10.5528 9.50094 10.5337 9.49561L10.1508 9.51046L10.0886 9.57264Z",
    fill: "#E60012"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20057 9.52421C8.20903 9.59692 8.1806 9.68448 8.22488 9.74148C8.28608 9.752 8.36612 9.75946 8.40422 9.7004C8.40735 9.66977 8.36726 9.68562 8.3524 9.68668C8.31651 9.68874 8.28281 9.69621 8.24471 9.69301C8.23114 9.64028 8.24372 9.57602 8.23526 9.52002L8.20057 9.52421V9.52421Z",
    fill: "#E60012"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14145 9.71404C8.14586 9.72563 8.15097 9.74041 8.16895 9.73515L8.1794 9.71717C8.1752 9.65179 8.1752 9.58434 8.16575 9.52002H8.14145V9.71404V9.71404Z",
    fill: "#E60012"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2997 9.62738C10.3018 9.64004 10.3071 9.65376 10.3198 9.65902H10.3302C10.3271 9.63997 10.3533 9.61046 10.3198 9.60307C10.3029 9.60214 10.305 9.61686 10.2997 9.62738Z",
    fill: "#E60012"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80499 9.63803C8.79759 9.64436 8.7902 9.65388 8.79866 9.66227C8.80712 9.66546 8.8219 9.67072 8.83654 9.66859C8.83974 9.65914 8.85033 9.65281 8.85772 9.64436C8.89362 9.6359 8.88203 9.70555 8.91991 9.67598C8.92944 9.66227 8.94422 9.64535 8.9337 9.62744L8.80499 9.63803V9.63803Z",
    fill: "#E60012"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0023 9.68644C8.99483 9.69276 8.98751 9.70435 8.99597 9.71387C9.07402 9.71813 9.15519 9.70754 9.23111 9.69703C9.2375 9.6907 9.23331 9.68018 9.2343 9.67272C9.22478 9.66327 9.21632 9.65161 9.20267 9.65161C9.13628 9.66327 9.06655 9.66846 9.0023 9.68644Z",
    fill: "#E60012"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94631 9.67614C9.92108 9.69093 9.89556 9.71624 9.88092 9.74155C10.0244 9.74048 10.1689 9.71837 10.3134 9.70678L10.2616 9.65503L9.94631 9.67614V9.67614Z",
    fill: "#E60012"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4284 9.72762C8.42009 9.73501 8.42201 9.74767 8.42201 9.75933C8.43579 9.77404 8.45584 9.77298 8.47695 9.77298L8.81557 9.74454L8.84293 9.73082C8.83554 9.7203 8.83455 9.69705 8.81557 9.70025C8.68791 9.7129 8.56239 9.72983 8.4284 9.72762V9.72762Z",
    fill: "#E60012"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8957 1.63608C7.65303 1.65506 7.4201 1.68883 7.21119 1.78905C7.12262 1.83021 7.13414 1.99056 7.01067 1.96213C6.97804 1.95254 6.98543 1.91572 6.98956 1.89247C7.00221 1.78457 7.46978 1.62969 7.88916 1.60474C7.92136 1.60566 7.93316 1.63132 7.8957 1.63608V1.63608Z",
    fill: "#F39800"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96851 1.70556C7.9769 1.71501 7.96737 1.7266 7.95792 1.72986C7.74489 1.73299 7.53918 1.74984 7.36617 1.85113C7.33774 1.88283 7.30078 1.9092 7.25649 1.89229C7.25123 1.88177 7.23751 1.88596 7.23538 1.87544L7.23851 1.85433C7.32089 1.80059 7.41692 1.77735 7.51182 1.7541C7.65931 1.72766 7.80716 1.6907 7.96851 1.70556V1.70556Z",
    fill: "#F39800"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70573 2.03777C6.68995 2.01879 6.67943 1.99348 6.68896 1.96818C6.75755 1.86156 6.87249 1.81201 6.98323 1.77832C6.85671 1.84691 6.89246 2.07892 6.70573 2.03777Z",
    fill: "#F39800"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01278 1.78482C8.01911 1.80174 7.9992 1.80174 7.99266 1.80906C7.82079 1.81645 7.66442 1.84815 7.49461 1.85981C7.48828 1.85555 7.48856 1.84709 7.48743 1.84076C7.66051 1.81965 7.82705 1.78375 8.00645 1.77856L8.01278 1.78482Z",
    fill: "#F39800"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97169 1.8754C7.97687 1.89225 7.9569 1.89118 7.94738 1.89545C7.77117 1.91443 7.5971 1.95772 7.41471 1.9408C7.40838 1.93241 7.39253 1.92921 7.39459 1.91649C7.41059 1.89545 7.43781 1.91123 7.45686 1.91649C7.62574 1.91649 7.78702 1.89431 7.94112 1.85742C7.95057 1.86382 7.97169 1.85849 7.97169 1.8754Z",
    fill: "#F39800"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M6.651 1.90918C6.57402 1.98616 6.52342 2.07366 6.46435 2.1581C6.44103 2.18547 6.40528 2.18867 6.37464 2.18654C6.35346 2.17069 6.32716 2.14645 6.34301 2.11688C6.37685 2.04203 6.46115 1.98815 6.52974 1.94707C6.56983 1.93448 6.60978 1.90918 6.651 1.90918V1.90918Z",
    fill: "#F39800"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45266 2.01353C7.63087 2.03038 7.78697 1.98503 7.9474 1.97131C7.94847 1.9829 7.93695 1.99135 7.92629 1.99235C7.70373 2.02192 7.46852 2.08205 7.23842 2.0335C7.21745 2.02298 7.19314 2.01239 7.17935 1.98915C7.18148 1.9765 7.17516 1.96072 7.19001 1.95432C7.28704 1.94181 7.36516 1.99349 7.45266 2.01353V2.01353Z",
    fill: "#F39800"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08673 2.02736C7.14679 2.04634 7.21218 2.0516 7.26591 2.08636C7.15517 2.10008 7.02545 2.12645 6.91045 2.09595C6.90093 2.08742 6.88301 2.0843 6.88301 2.06851C6.87783 2.04214 6.88934 2.0221 6.90306 2.00312C6.95786 1.97462 7.0423 1.97881 7.08673 2.02736V2.02736Z",
    fill: "#F39800"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13937 2.34164C6.1226 2.34164 6.09089 2.34797 6.08343 2.3206C6.07078 2.17495 6.21955 2.08952 6.32924 2.03052C6.22382 2.11695 6.26178 2.26892 6.13937 2.34164V2.34164Z",
    fill: "#F39800"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93059 2.08638C7.93891 2.09377 7.94204 2.10436 7.94104 2.11702C7.87145 2.15291 7.82183 2.23409 7.74385 2.24887H7.73326C7.72907 2.22883 7.75125 2.20771 7.74385 2.18667C7.71634 2.1603 7.68158 2.15504 7.65414 2.13073C7.66459 2.09271 7.71421 2.08851 7.74705 2.07167C7.79866 2.06108 7.86406 2.06008 7.90941 2.08638H7.93059V2.08638Z",
    fill: "#F39800"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75124 2.13069C6.81664 2.1454 6.88935 2.1444 6.95475 2.15812C6.94956 2.1749 6.92944 2.1803 6.91366 2.18656C6.81557 2.20873 6.70262 2.23823 6.59927 2.2066C6.57617 2.18549 6.57176 2.15599 6.57496 2.12436C6.62571 2.0832 6.69949 2.11171 6.75124 2.13069V2.13069Z",
    fill: "#F39800"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40103 2.17616C7.37878 2.21838 7.32718 2.23317 7.28396 2.24475C7.26065 2.21412 7.22383 2.20466 7.18694 2.20047C7.18061 2.1962 7.18481 2.18881 7.18374 2.18256C7.22276 2.15092 7.27984 2.16038 7.32817 2.14872C7.35774 2.14666 7.39143 2.14666 7.40103 2.17616V2.17616Z",
    fill: "#F39800"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98321 2.39754C5.96956 2.42185 5.94425 2.4345 5.91781 2.43877C5.89464 2.43564 5.8714 2.41872 5.86187 2.39754C5.8429 2.32795 5.90317 2.28253 5.94525 2.23512C5.98001 2.20988 6.01498 2.18451 6.05293 2.16553C6.03495 2.23725 5.98861 2.3121 5.98321 2.39754Z",
    fill: "#F39800"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66787 2.23503C7.66588 2.26254 7.63403 2.26347 7.61939 2.28244C7.54867 2.31734 7.47063 2.34578 7.38726 2.33838C7.33559 2.28877 7.4368 2.27619 7.42834 2.22764C7.47476 2.16964 7.56026 2.19395 7.62565 2.19288C7.6415 2.2034 7.66581 2.21293 7.66787 2.23503V2.23503Z",
    fill: "#F39800"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20366 2.27309C7.21112 2.30052 7.17842 2.29214 7.16577 2.30372C7.10983 2.31424 7.06554 2.36073 7.00015 2.33848C6.99276 2.27209 6.90198 2.32377 6.89999 2.25837C6.93362 2.22994 6.98536 2.24153 7.02446 2.22461C7.08673 2.23513 7.15091 2.24153 7.20366 2.27309Z",
    fill: "#F39800"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65719 2.2602C6.66657 2.26105 6.6773 2.26922 6.67261 2.27818C6.67176 2.28685 6.60295 2.29936 6.54659 2.32765C6.48468 2.35892 6.39078 2.3779 6.34898 2.34634C6.31145 2.30576 6.29503 2.29183 6.3138 2.26119C6.32986 2.21534 6.45546 2.25359 6.51097 2.26112C6.54971 2.26745 6.63551 2.25771 6.65719 2.2602V2.2602Z",
    fill: "#F39800"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91676 2.36907C6.91577 2.38172 6.93581 2.3997 6.91363 2.40702C6.82919 2.40496 6.75847 2.43872 6.67843 2.44505C6.64566 2.45031 6.65931 2.41335 6.66151 2.39757C6.70786 2.34277 6.77858 2.32059 6.85137 2.33118C6.87248 2.34589 6.90411 2.34376 6.91676 2.36907V2.36907Z",
    fill: "#F39800"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6637 2.34912C7.67635 2.37656 7.63718 2.38814 7.61941 2.3976C7.55913 2.42191 7.48115 2.40392 7.42521 2.43882C7.40936 2.4325 7.39578 2.45247 7.38412 2.4357C7.39258 2.41139 7.41888 2.4008 7.43587 2.38296C7.51392 2.37656 7.59823 2.38608 7.6637 2.34912V2.34912Z",
    fill: "#F39800"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30076 2.4144C7.28292 2.4682 7.21952 2.47453 7.18376 2.51455C7.16052 2.51355 7.1247 2.54838 7.11411 2.51142C7.11624 2.49358 7.09946 2.48086 7.08681 2.47346C7.0593 2.46714 7.035 2.45235 7.01396 2.43131C7.00564 2.39542 7.04772 2.407 7.06257 2.39016C7.13415 2.37644 7.25015 2.33528 7.30076 2.4144V2.4144Z",
    fill: "#F39800"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39148 2.4218C6.27647 2.48293 6.15733 2.56951 6.01502 2.54946C5.99071 2.52835 5.97693 2.49878 5.98325 2.46928C6.05078 2.38065 6.17112 2.43659 6.26701 2.43133L6.39148 2.4218V2.4218Z",
    fill: "#F39800"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56129 2.4768C6.46846 2.49372 6.39674 2.56224 6.31549 2.60446L6.31869 2.58754C6.37243 2.49891 6.46313 2.45356 6.55084 2.42512C6.58745 2.40174 6.58375 2.4682 6.56129 2.4768V2.4768Z",
    fill: "#F39800"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02766 2.54216V2.54955C6.94215 2.57379 6.87036 2.64231 6.77234 2.62546C6.78279 2.59376 6.81975 2.57372 6.82081 2.53896C6.8093 2.52211 6.79132 2.50733 6.77867 2.49048C6.82714 2.46518 6.89367 2.46617 6.94847 2.47676C6.97904 2.48728 7.02446 2.50207 7.02766 2.54216Z",
    fill: "#F39800"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8208 2.50109C5.67735 2.64453 5.50008 2.75002 5.37469 2.91564C5.37255 2.9494 5.34938 2.9831 5.36836 3.01579C5.36836 3.04216 5.35564 3.06434 5.33673 3.07806C5.31981 3.07806 5.28498 3.08339 5.28185 3.05382C5.26074 2.9494 5.3599 2.885 5.42629 2.81222C5.54763 2.68782 5.68055 2.59073 5.80715 2.47998C5.81668 2.48204 5.83146 2.48851 5.8208 2.50109V2.50109Z",
    fill: "#F39800"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73004 2.56312C6.72158 2.59049 6.70161 2.61267 6.68156 2.63584C6.62982 2.6475 6.59506 2.71182 6.53279 2.68759C6.48005 2.69597 6.45155 2.64636 6.402 2.64636C6.39767 2.64003 6.39454 2.62532 6.4052 2.62212C6.4937 2.56511 6.59186 2.52296 6.70573 2.53874L6.73004 2.56312V2.56312Z",
    fill: "#F39800"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88306 2.55254L5.48528 2.91228C5.47484 2.92173 5.46005 2.92173 5.44733 2.926L5.45053 2.91228C5.58764 2.78042 5.7259 2.65276 5.86941 2.53882C5.87773 2.53882 5.8874 2.54088 5.88306 2.55254V2.55254Z",
    fill: "#F39800"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11199 2.60866C6.10887 2.65607 6.04233 2.6319 6.0075 2.64235H5.99385C5.98952 2.62131 6.02015 2.60546 6.03913 2.59807C6.06337 2.59067 6.09188 2.59387 6.11199 2.60866Z",
    fill: "#F39800"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91469 2.64229C5.76393 2.78893 5.61303 2.96613 5.43057 3.05057C5.41046 3.05477 5.39994 3.03579 5.40946 3.01994C5.45375 2.97139 5.51281 2.95973 5.56143 2.92291C5.68056 2.83321 5.79023 2.72247 5.90417 2.62231H5.91462V2.64229H5.91469V2.64229Z",
    fill: "#F39800"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27442 2.66666C6.26063 2.75529 6.18891 2.83227 6.10133 2.85026C6.02761 2.84912 6.08334 2.77221 6.06657 2.73632C6.10765 2.65827 6.1921 2.68357 6.25011 2.64661C6.26703 2.64029 6.27129 2.654 6.27442 2.66666Z",
    fill: "#F39800"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94211 2.74248C5.74373 2.90063 5.57079 3.12112 5.34717 3.21608C5.32194 3.22874 5.28498 3.22348 5.25747 3.22035C5.23003 3.19924 5.2638 3.17813 5.26806 3.15808C5.33033 3.07471 5.44526 3.15069 5.51272 3.08217C5.65936 2.97143 5.78275 2.82586 5.92839 2.71191L5.94517 2.71504L5.94211 2.74248Z",
    fill: "#F39800"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54757 2.76692C6.54437 2.8144 6.48744 2.80275 6.46114 2.82912C6.43683 2.84703 6.41792 2.87447 6.38829 2.87766C6.32503 2.88612 6.37044 2.80907 6.3219 2.79543C6.3219 2.76159 6.36099 2.75214 6.37777 2.73316C6.4347 2.73416 6.51587 2.70885 6.54757 2.76692V2.76692Z",
    fill: "#F39800"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01504 2.85343C6.00757 2.91144 6.02015 2.97683 5.97694 3.02012C5.95263 3.04016 5.9168 3.05281 5.88624 3.03696C5.85681 3.01905 5.82205 3.04222 5.79021 3.02957C5.75758 3.01159 5.79234 2.98628 5.79341 2.96418C5.83975 2.90397 5.89256 2.85237 5.96649 2.84284C5.978 2.826 6.01596 2.82912 6.01504 2.85343V2.85343Z",
    fill: "#F39800"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29438 2.85012C6.2764 2.90066 6.30917 2.97771 6.23652 2.99882C6.21221 3.00416 6.19643 3.02946 6.16992 3.02946C6.17518 3.00622 6.16359 2.97778 6.14241 2.96407C6.12777 2.9598 6.10879 2.95454 6.10452 2.93975C6.11398 2.91871 6.14042 2.92497 6.15627 2.91239C6.19949 2.88808 6.23531 2.84806 6.28394 2.8396L6.29438 2.85012V2.85012Z",
    fill: "#F39800"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09088 3.02C6.08982 3.12548 6.01063 3.2004 5.92846 3.25521C5.91467 3.26153 5.89783 3.25727 5.88304 3.25833C5.86086 3.24568 5.86939 3.21725 5.87259 3.19927C5.90323 3.10643 6.02968 3.12328 6.04866 3.02C6.05612 3.00201 6.09508 2.98936 6.09088 3.02V3.02Z",
    fill: "#F39800"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83144 3.11585C5.85361 3.24984 5.76391 3.36058 5.65836 3.43123C5.61607 3.43657 5.64038 3.38276 5.62361 3.36165C5.58985 3.30471 5.61195 3.22873 5.64472 3.17812C5.68054 3.12111 5.75126 3.13064 5.804 3.10633C5.81445 3.10426 5.82397 3.10739 5.83144 3.11585Z",
    fill: "#F39800"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96325 3.18857C4.96112 3.20122 4.97064 3.22447 4.94953 3.22347C4.92324 3.2298 4.93269 3.19284 4.90838 3.18857C4.90525 3.16959 4.91051 3.15168 4.9285 3.14429C4.95259 3.14436 4.94847 3.17485 4.96325 3.18857V3.18857Z",
    fill: "url(#paint75_linear_9_3255)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93582 3.28575C4.90198 3.31106 4.8641 3.28469 4.83567 3.26884C4.83126 3.25405 4.842 3.24246 4.85245 3.23713C4.8904 3.22881 4.91677 3.26258 4.93582 3.28575Z",
    fill: "url(#paint76_linear_9_3255)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55067 3.27536C5.556 3.33229 5.556 3.39981 5.55067 3.45149C5.55188 3.45888 5.54235 3.45355 5.53709 3.45575C5.5297 3.44204 5.52757 3.42306 5.50958 3.41773C5.45172 3.4114 5.40524 3.45575 5.33984 3.44516C5.34496 3.37344 5.43267 3.31857 5.48527 3.27216C5.50326 3.25638 5.54655 3.24266 5.55067 3.27536Z",
    fill: "#F39800"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38514 3.26882C5.28278 3.33109 5.2016 3.46187 5.07074 3.43444C5.05077 3.42918 5.0529 3.40807 5.04977 3.39335C5.07394 3.31943 5.16578 3.349 5.22271 3.32682C5.28079 3.31417 5.3272 3.27095 5.38514 3.2583V3.26882V3.26882Z",
    fill: "#F39800"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23961 3.43777C5.21104 3.50209 5.16256 3.55803 5.12254 3.61817C5.06873 3.66032 5.00966 3.70887 4.93894 3.69096C4.91903 3.67198 4.91463 3.64035 4.92216 3.61397C4.96012 3.55285 5.03184 3.55597 5.08458 3.52114C5.13413 3.48631 5.1858 3.45895 5.23655 3.42725L5.23961 3.43777Z",
    fill: "#F39800"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46848 3.47246C5.48959 3.56728 5.36727 3.57894 5.34403 3.65279C5.32498 3.6739 5.29235 3.66125 5.26811 3.66971C5.23655 3.66864 5.21324 3.70774 5.18161 3.68343C5.22802 3.57055 5.34403 3.48831 5.46116 3.46606L5.46848 3.47246V3.47246Z",
    fill: "#F39800"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M5.672 3.55906C5.62352 3.60121 5.6415 3.6698 5.58243 3.70783C5.54753 3.73207 5.52969 3.77109 5.48526 3.77323C5.45477 3.7701 5.4242 3.7679 5.3989 3.74899C5.39989 3.65829 5.46628 3.5791 5.54433 3.53482C5.58982 3.53909 5.63198 3.5275 5.672 3.53169V3.55906V3.55906Z",
    fill: "#F39800"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71434 3.65285C4.71434 3.72884 4.69742 3.80589 4.72799 3.87334C4.73431 3.93134 4.75009 4.01152 4.71434 4.06007C4.67204 4.07692 4.64894 4.03576 4.63515 4.0084C4.60252 3.96617 4.60671 3.90071 4.63095 3.85643C4.65207 3.78577 4.64787 3.70133 4.69742 3.64553C4.70367 3.64446 4.71014 3.64653 4.71434 3.65285Z",
    fill: "#F39800"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06028 3.73518C5.01166 3.81643 4.95167 3.91445 4.8599 3.95668C4.83452 3.96407 4.8019 3.96094 4.79024 3.93244C4.78192 3.9018 4.78711 3.8691 4.81455 3.84905C4.88947 3.80164 4.97377 3.77946 5.03924 3.71094H5.06035V3.73518H5.06028V3.73518Z",
    fill: "#F39800"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30928 3.74899V3.75951C5.27331 3.8038 5.23855 3.85334 5.17429 3.84282C5.13939 3.84708 5.11522 3.87552 5.07712 3.87346C5.08245 3.8291 5.12986 3.78482 5.17116 3.75951C5.21424 3.75319 5.25241 3.72994 5.30196 3.7384L5.30928 3.74899V3.74899Z",
    fill: "#F39800"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46529 3.82163C5.48214 3.92604 5.35348 3.97032 5.31972 4.0537C5.28496 4.04204 5.30387 3.9893 5.29868 3.95661C5.29655 3.95028 5.29022 3.94502 5.28496 3.93976C5.25653 3.9281 5.23116 3.96293 5.21225 3.9355C5.22057 3.89228 5.26499 3.84899 5.30195 3.83215C5.3409 3.81523 5.39578 3.83947 5.43061 3.81104C5.44219 3.81317 5.45804 3.80585 5.46529 3.82163V3.82163Z",
    fill: "#F39800"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13932 3.93973C5.12254 3.98294 5.07286 3.99453 5.03917 4.02197C5.00121 4.06739 4.98124 4.12119 4.94627 4.16761H4.93887C4.95686 4.07158 5.01379 3.95877 5.11927 3.93233C5.12674 3.93233 5.1352 3.9302 5.13932 3.93973V3.93973Z",
    fill: "#F39800"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57927 3.96728C4.56967 4.05912 4.6426 4.12025 4.62142 4.21308C4.60465 4.23739 4.57294 4.23739 4.54871 4.23312C4.48964 4.19936 4.51495 4.12025 4.51395 4.06438C4.52227 4.02315 4.54238 3.98732 4.5593 3.94937C4.57302 3.94517 4.57714 3.95676 4.57927 3.96728V3.96728Z",
    fill: "#F39800"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95692 3.96704C4.95578 4.01239 4.90631 4.04509 4.88093 4.08411C4.81668 4.13792 4.78078 4.22968 4.69001 4.22655C4.67836 4.20331 4.68262 4.16855 4.68682 4.14318C4.72065 4.08304 4.79649 4.09257 4.84198 4.04615C4.882 4.02405 4.91363 3.98289 4.95692 3.96704V3.96704Z",
    fill: "#F39800"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25747 4.00531C5.25008 4.09281 5.24162 4.19623 5.15732 4.23738C5.09939 4.24684 5.0581 4.29745 5.00123 4.3091C4.976 4.26688 5.00336 4.21414 5.01488 4.17092C5.05291 4.10027 5.10039 3.99472 5.19841 3.99791C5.21859 3.9999 5.24169 3.99251 5.25747 4.00531V4.00531Z",
    fill: "#F39800"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33352 4.1571C5.30828 4.19087 5.31774 4.24887 5.27132 4.26472C5.24602 4.22996 5.27232 4.19087 5.2881 4.1603C5.29655 4.14338 5.32826 4.13279 5.33352 4.1571V4.1571Z",
    fill: "#F39800"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83881 4.22985C4.80604 4.26461 4.79651 4.32894 4.74178 4.33321C4.73232 4.32055 4.74597 4.30797 4.74917 4.29525C4.77561 4.26568 4.80824 4.22879 4.83888 4.20874V4.22985H4.83881Z",
    fill: "#F39800"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43469 4.31956C4.44102 4.34181 4.41891 4.36178 4.41678 4.38495C4.37143 4.62336 4.30497 4.8575 4.32715 5.11801C4.32189 5.21504 4.45481 5.25307 4.4305 5.35749L4.74169 5.06001C4.72591 5.01146 4.74056 4.95872 4.75534 4.91444C4.78918 4.92602 4.79543 4.96299 4.81441 4.98715L5.01479 4.80042C4.95999 4.74029 4.97171 4.63487 5.00526 4.56834C5.02112 4.55469 5.03704 4.53991 5.06014 4.54091C5.09177 4.55569 5.0981 4.59365 5.10876 4.62421L5.09077 4.70652C5.12973 4.70226 5.15304 4.6454 5.19199 4.62741L5.20152 4.63793C5.20045 4.72863 5.16669 4.80668 5.13925 4.88693L4.23432 5.74765L4.22998 5.55779C4.27952 5.49339 4.35025 5.43745 4.41031 5.37739C4.38089 5.37945 4.34925 5.36474 4.32708 5.33936C4.2764 5.25399 4.27952 5.14112 4.28585 5.03563C4.29331 4.78457 4.35764 4.55676 4.41671 4.32674C4.42311 4.32489 4.42624 4.31636 4.43469 4.31956V4.31956Z",
    fill: "url(#paint77_linear_9_3255)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5171 4.32275C4.47068 4.53379 4.4094 4.73737 4.4104 4.96625C4.41786 5.02539 4.47587 5.06754 4.46528 5.12867C4.45582 5.14026 4.43571 5.13606 4.42419 5.13294C4.35453 5.05176 4.3831 4.91564 4.3863 4.81122C4.4168 4.64454 4.45589 4.48212 4.50331 4.32282H4.5171V4.32275V4.32275Z",
    fill: "url(#paint78_linear_9_3255)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93582 4.39223C4.96212 4.45243 4.96212 4.54306 4.93582 4.60327C4.92317 4.60959 4.90419 4.62118 4.8904 4.60647C4.87042 4.55259 4.78917 4.52202 4.82493 4.45129C4.83872 4.40594 4.86623 4.37325 4.89466 4.33742C4.92416 4.33636 4.92103 4.37751 4.93582 4.39223V4.39223Z",
    fill: "#F39800"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59713 4.3544C4.54652 4.52627 4.52754 4.71194 4.49278 4.89028C4.48012 4.8998 4.47693 4.92091 4.45894 4.91779C4.44629 4.92298 4.44536 4.9104 4.44096 4.90407C4.43364 4.8745 4.46939 4.86398 4.47259 4.83867C4.50223 4.67412 4.52121 4.50537 4.57609 4.35134L4.58654 4.34082L4.59713 4.3544Z",
    fill: "url(#paint79_linear_9_3255)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66252 4.43775C4.60772 4.63607 4.61511 4.86076 4.49278 5.03164C4.48745 5.03896 4.47693 5.03476 4.46848 5.03583C4.46848 4.97676 4.51077 4.92722 4.53074 4.87341C4.58348 4.72051 4.59506 4.55063 4.64155 4.39553C4.64574 4.39027 4.6542 4.38501 4.66252 4.38501V4.43775V4.43775Z",
    fill: "url(#paint80_linear_9_3255)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74588 4.43024C4.71326 4.63694 4.65938 4.83426 4.63095 5.04196C4.60877 5.11901 4.5888 5.20651 4.51395 5.25299C4.49483 5.26564 4.47905 5.2466 4.46221 5.2424C4.44223 5.22975 4.44223 5.20338 4.44856 5.18447C4.52447 5.07785 4.63514 4.98616 4.63514 4.84897C4.65312 4.7034 4.69222 4.56735 4.72164 4.42704C4.72698 4.42278 4.74176 4.41972 4.74588 4.43024V4.43024Z",
    fill: "url(#paint81_linear_9_3255)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92218 4.71399C4.92737 4.76254 4.94955 4.84485 4.88095 4.86276C4.87143 4.87222 4.87143 4.88914 4.85679 4.8934C4.82501 4.89653 4.80404 4.86703 4.79771 4.84165C4.78926 4.76993 4.73331 4.65812 4.81868 4.60645L4.8388 4.61064L4.92218 4.71399Z",
    fill: "url(#paint82_linear_9_3255)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11935 5.17388L4.84924 5.44392L4.85984 5.62325C4.8555 5.64223 4.83126 5.6433 4.81861 5.65481C4.79018 5.68324 4.76587 5.71708 4.7417 5.74444L4.73537 5.73712C4.73956 5.68438 4.73011 5.63264 4.70367 5.59574C4.66052 5.61046 4.63842 5.65908 4.60032 5.68865C4.62676 5.77082 4.59833 5.85419 4.57295 5.92705C4.55923 5.9439 4.53919 5.9439 4.5212 5.94816C4.47891 5.92072 4.5212 5.87004 4.52753 5.83415C4.54018 5.8173 4.55063 5.79626 4.54118 5.77508C4.53698 5.76989 4.53073 5.76769 4.5244 5.76875C4.47891 5.80778 4.44849 5.85213 4.41039 5.89329C4.4084 5.97446 4.56136 5.9987 4.48957 6.08314C4.45168 6.09686 4.4337 6.06203 4.40619 6.04839C4.38309 6.01775 4.38508 5.9702 4.34819 5.95129C4.30391 5.95449 4.30291 6.02088 4.26175 6.01356C4.25436 5.92911 4.21854 5.80572 4.32402 5.75511L5.13933 4.96924H5.14679L5.11935 5.17388V5.17388Z",
    fill: "url(#paint83_linear_9_3255)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05717 5.38497C5.10984 5.43671 5.08141 5.52215 5.07394 5.58535C5.04764 5.59906 5.04025 5.55897 5.01914 5.57163C4.98438 5.58961 4.97905 5.62551 4.95254 5.65074C4.92524 5.66126 4.9273 5.62856 4.91458 5.61598C4.92944 5.50737 4.93363 5.39136 5.00528 5.30905C5.0603 5.29732 5.03599 5.36073 5.05717 5.38497V5.38497Z",
    fill: "url(#paint84_linear_9_3255)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03919 5.65489C5.10771 5.72668 5.10885 5.82576 5.10572 5.92705C5.09612 5.94176 5.08141 5.94176 5.06769 5.94176C5.01922 5.92492 5.02554 5.85213 4.96647 5.85533C4.95482 5.86372 4.94956 5.88902 4.92852 5.87957C4.90421 5.85739 4.93051 5.83102 4.93271 5.80679L4.99498 5.67188C5.00024 5.65063 5.02234 5.65489 5.03919 5.65489Z",
    fill: "url(#paint85_linear_9_3255)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8872 5.74464V5.99996C4.87981 6.00842 4.87135 6.0168 4.85983 6.01368C4.83979 5.99889 4.83346 5.96093 4.80077 5.96939C4.79131 5.98411 4.77553 5.98311 4.75954 5.98311C4.73431 5.93449 4.72272 5.85126 4.76274 5.8069L4.85244 5.71308C4.87774 5.70469 4.8872 5.72573 4.8872 5.74464V5.74464Z",
    fill: "url(#paint86_linear_9_3255)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66251 5.88907C4.67523 5.98091 4.67317 6.08319 4.63508 6.16238C4.62242 6.18662 4.5908 6.17503 4.57296 6.17283C4.48958 6.08113 4.60458 5.99249 4.62463 5.90393C4.62882 5.89127 4.62676 5.87329 4.64154 5.8691C4.66052 5.86177 4.65206 5.88495 4.66251 5.88907V5.88907Z",
    fill: "url(#paint87_linear_9_3255)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18475 6.07567C5.18376 6.08413 5.18894 6.10097 5.1743 6.09685C5.14367 6.09053 5.14367 6.0493 5.13621 6.02087C5.13941 6.00189 5.1279 5.97765 5.14687 5.96606C5.1753 5.99243 5.16151 6.04411 5.18475 6.07567Z",
    fill: "url(#paint88_linear_9_3255)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07392 6.04221C5.13612 6.15708 5.02118 6.23413 5.02545 6.34282C5.02111 6.34801 5.02111 6.3596 5.01166 6.3596C4.98855 6.36699 4.96638 6.34488 4.96318 6.32484C4.94207 6.26051 4.91896 6.19603 4.92842 6.11806C4.95159 6.07164 4.93794 6.00731 4.98116 5.97248C5.02232 5.97034 5.04549 6.02103 5.07392 6.04221Z",
    fill: "url(#paint89_linear_9_3255)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73232 6.07277C4.74498 6.15401 4.75862 6.26056 4.69316 6.32169C4.67418 6.32375 4.63842 6.33541 4.62776 6.31117C4.60665 6.23625 4.67205 6.18777 4.6837 6.12131C4.69636 6.0813 4.6837 6.02948 4.70801 5.99365C4.74178 5.99998 4.71327 6.05066 4.73232 6.07277Z",
    fill: "url(#paint90_linear_9_3255)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87357 6.06964C4.86937 6.1646 4.89041 6.2511 4.91152 6.33547C4.88721 6.35019 4.86937 6.32069 4.85672 6.30484C4.85239 6.20888 4.75537 6.12977 4.8113 6.03161C4.83981 6.02635 4.86312 6.04639 4.87357 6.06964V6.06964Z",
    fill: "url(#paint91_linear_9_3255)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44422 6.15286C4.47898 6.22459 4.60777 6.2457 4.56868 6.3428C4.55823 6.33746 4.52447 6.35431 4.52447 6.32908C4.42311 6.2784 4.39361 6.17504 4.3725 6.08008C4.40413 6.09166 4.41358 6.13069 4.44422 6.15286V6.15286Z",
    fill: "url(#paint92_linear_9_3255)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20593 6.20033C5.22491 6.26778 5.266 6.32586 5.26379 6.40184C5.22484 6.39331 5.19641 6.3491 5.14992 6.36694C5.12348 6.37647 5.16144 6.43127 5.11516 6.41549L5.07074 6.33965C5.0792 6.26892 5.12256 6.21198 5.14992 6.14865C5.18688 6.13806 5.19428 6.18028 5.20593 6.20033V6.20033Z",
    fill: "url(#paint93_linear_9_3255)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48334 6.34575C4.48021 6.35528 4.48853 6.36885 4.47595 6.37319C4.44859 6.37845 4.42634 6.36885 4.42115 6.34263C4.42314 6.32258 4.40211 6.30773 4.41049 6.29082C4.44326 6.28669 4.4569 6.32777 4.48334 6.34575V6.34575Z",
    fill: "url(#paint94_linear_9_3255)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77972 6.37338C4.73651 6.39449 4.74816 6.34061 4.72798 6.32163C4.72378 6.30898 4.7343 6.30265 4.74169 6.29419C4.78072 6.30059 4.76806 6.34701 4.77972 6.37338V6.37338Z",
    fill: "url(#paint95_linear_9_3255)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63197 6.41386C4.7125 6.58694 4.78174 6.75825 4.8568 6.92706C4.85467 6.93659 4.86099 6.95343 4.84621 6.95443L4.82503 6.92706C4.7533 6.75718 4.65841 6.59796 4.60353 6.42175C4.6009 6.39993 4.62948 6.40619 4.63197 6.41386V6.41386Z",
    fill: "url(#paint96_linear_9_3255)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75542 6.47763C4.81826 6.62377 4.88238 6.76849 4.93263 6.927C4.93796 6.95337 4.94948 6.99446 4.92531 7.01664C4.9052 7.01984 4.89041 6.99666 4.88401 6.98188C4.88302 6.88691 4.84925 6.80567 4.81862 6.72236C4.77966 6.6264 4.73111 6.53357 4.70367 6.43235C4.72912 6.41643 4.75009 6.45659 4.75542 6.47763V6.47763Z",
    fill: "url(#paint97_linear_9_3255)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00121 6.45979C5.10349 6.46399 5.14045 6.579 5.18793 6.64653L5.18473 6.67496C5.12886 6.695 5.07925 6.61696 5.02872 6.67496C4.99488 6.68868 4.99275 6.64859 4.98124 6.63274C4.97178 6.58419 4.93482 6.55469 4.92537 6.50507C4.92103 6.48084 4.91684 6.44714 4.9285 6.42603C4.96425 6.41125 4.97591 6.4524 5.00121 6.45979V6.45979Z",
    fill: "url(#paint98_linear_9_3255)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25426 6.45983C5.33345 6.4567 5.33345 6.54633 5.36828 6.59161C5.36615 6.64022 5.37354 6.69289 5.36089 6.73725C5.31134 6.7467 5.28383 6.69815 5.25419 6.66759C5.21311 6.60646 5.18567 6.53894 5.1878 6.45983C5.18894 6.40602 5.23855 6.44184 5.25426 6.45983V6.45983Z",
    fill: "url(#paint99_linear_9_3255)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56236 6.45974C4.63096 6.66857 4.70367 6.87635 4.84612 7.05469C4.88088 7.08625 4.93582 7.08625 4.94627 7.14112C4.95473 7.16024 4.93263 7.16025 4.9253 7.16863C4.83027 7.15811 4.79018 7.05156 4.73857 6.98617C4.66046 6.81415 4.5908 6.64114 4.52753 6.46393C4.52284 6.45505 4.5222 6.44083 4.53493 6.4355C4.54872 6.43337 4.56023 6.44915 4.56236 6.45974V6.45974Z",
    fill: "url(#paint100_linear_9_3255)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83248 6.47361C4.93263 6.67185 5.02163 6.87607 5.11332 7.07751C5.1313 7.1461 5.14047 7.24782 5.07074 7.29743C5.04764 7.30063 5.03812 7.27426 5.03286 7.25941C5.00336 7.15613 5.06349 7.04744 5.00855 6.95141C4.94109 6.78473 4.86824 6.62231 4.79019 6.45989C4.79652 6.42819 4.82815 6.45883 4.83248 6.47361V6.47361Z",
    fill: "url(#paint101_linear_9_3255)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48966 6.5326C4.58669 6.79005 4.67426 7.06002 4.92219 7.24469C4.96014 7.28158 5.02973 7.29324 5.02554 7.3597C5.02433 7.38607 4.98644 7.38188 4.96647 7.37647C4.86724 7.33852 4.79026 7.2309 4.73546 7.14439C4.60467 6.94295 4.52449 6.71933 4.44858 6.49457C4.46756 6.43351 4.48021 6.51788 4.48966 6.5326V6.5326Z",
    fill: "url(#paint102_linear_9_3255)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08459 7.7637L4.98124 7.64243L5.02872 7.53276C4.93894 7.51051 4.88833 7.41249 4.85251 7.33863L4.8631 7.33551C4.92956 7.37553 4.97911 7.45677 5.06767 7.44625L5.43055 6.65405L5.50639 6.79963L5.08459 7.7637V7.7637Z",
    fill: "url(#paint103_linear_9_3255)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12981 6.72674C5.19641 6.71408 5.25114 6.75517 5.28177 6.80905C5.29442 6.85646 5.29236 6.91347 5.25426 6.94823C5.23962 6.96308 5.22484 6.97886 5.20159 6.97147C5.14566 6.91873 5.10038 6.85547 5.07074 6.789C5.06242 6.76796 5.05809 6.74472 5.06029 6.71942C5.07927 6.69091 5.1109 6.71408 5.12981 6.72674V6.72674Z",
    fill: "url(#paint104_linear_9_3255)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09306 6.76786C7.09818 6.78464 7.08674 6.79843 7.07608 6.80575C7.0593 6.81102 7.05085 6.7973 7.04544 6.78464C7.04033 6.76786 7.05184 6.75407 7.06243 6.74668C7.0792 6.74149 7.08766 6.7562 7.09306 6.76786Z",
    fill: "url(#paint105_linear_9_3255)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19007 6.77114C7.1964 6.78905 7.18261 6.80277 7.16995 6.8091C7.15311 6.81336 7.14152 6.80071 7.13519 6.78905C7.1288 6.77114 7.14259 6.75742 7.15524 6.75109C7.17209 6.74683 7.18367 6.75948 7.19007 6.77114V6.77114Z",
    fill: "url(#paint106_linear_9_3255)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77436 6.77099C7.77969 6.78776 7.76804 6.80155 7.75759 6.80895C7.73961 6.81414 7.73229 6.80056 7.72596 6.7889C7.72163 6.77205 7.73335 6.75826 7.74394 6.75094C7.76064 6.74561 7.7691 6.75933 7.77436 6.77099Z",
    fill: "url(#paint107_linear_9_3255)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03395 6.77521C8.03814 6.7932 8.02863 6.80905 8.01278 6.81637C8.00013 6.8153 7.98436 6.80692 7.98216 6.79213C7.97797 6.77308 7.98749 6.7573 8.00333 6.75098C8.01598 6.75098 8.03182 6.7605 8.03395 6.77521Z",
    fill: "url(#paint108_linear_9_3255)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33253 6.77504C7.33672 6.79196 7.32599 6.80255 7.31455 6.81307C7.29756 6.8194 7.28705 6.80255 7.2798 6.79196C7.27546 6.77505 7.28612 6.76453 7.29756 6.75401C7.31455 6.74661 7.32499 6.76353 7.33253 6.77504Z",
    fill: "url(#paint109_linear_9_3255)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4147 6.7711C7.41683 6.78788 7.4147 6.8038 7.39779 6.80906C7.38507 6.81112 7.37363 6.80273 7.37043 6.79221C7.3683 6.77636 7.3715 6.75945 7.38727 6.75426C7.39992 6.75205 7.41157 6.76051 7.4147 6.7711Z",
    fill: "url(#paint110_linear_9_3255)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56759 6.78147C7.56759 6.79732 7.56233 6.81317 7.54649 6.8163C7.53065 6.8163 7.519 6.80471 7.519 6.78886C7.51587 6.77301 7.52432 6.76043 7.53598 6.7541C7.55502 6.7509 7.56546 6.76569 7.56759 6.78147Z",
    fill: "url(#paint111_linear_9_3255)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84722 6.77522C7.84822 6.79007 7.84822 6.80372 7.83343 6.81325C7.81879 6.81957 7.80714 6.80273 7.80614 6.79214C7.80493 6.77735 7.80493 6.76256 7.81972 6.75418C7.83457 6.74678 7.84509 6.76477 7.84722 6.77522V6.77522Z",
    fill: "url(#paint112_linear_9_3255)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66048 6.77831C7.66581 6.79516 7.65416 6.80895 7.64357 6.81627C7.62572 6.82153 7.61826 6.80681 7.61193 6.79516C7.60774 6.77831 7.61826 6.76459 7.62992 6.7572C7.64669 6.75194 7.65416 6.76672 7.66048 6.77831Z",
    fill: "url(#paint113_linear_9_3255)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37674 6.93767C7.37361 6.9693 7.40738 6.9651 7.42522 6.9651C7.43582 6.99041 7.42643 7.02211 7.39778 7.0305C7.38506 7.03362 7.36828 7.03576 7.36302 7.05161C7.36935 7.14444 7.32918 7.26676 7.39778 7.33848L7.39458 7.34168L7.27658 7.34594C7.26378 7.30692 7.29655 7.28787 7.31454 7.26257V7.03362C7.28923 7.01045 7.24914 6.9936 7.23215 6.95771C7.25433 6.95032 7.27978 6.97143 7.30821 6.96823C7.30921 6.9398 7.35463 6.8786 7.37674 6.93767V6.93767Z",
    fill: "url(#paint114_linear_9_3255)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8208 7.26571C5.83345 7.30054 5.80082 7.28995 5.78604 7.30686C5.78284 7.34162 5.79556 7.38271 5.77651 7.41128C5.69747 7.40282 5.67522 7.31205 5.6416 7.25511C5.63413 7.21723 5.61195 7.18552 5.62048 7.14117C5.63626 7.1106 5.66562 7.13307 5.68574 7.13513C5.73528 7.16889 5.78504 7.21396 5.8208 7.26571V7.26571Z",
    fill: "url(#paint115_linear_9_3255)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60144 7.17301L7.61942 7.24472H7.49054C7.50007 7.2067 7.498 7.15503 7.53604 7.13818C7.56234 7.13818 7.59298 7.14344 7.60144 7.17301V7.17301Z",
    fill: "url(#paint116_linear_9_3255)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14581 7.19299C7.1478 7.21303 7.15527 7.23094 7.15214 7.25205L7.03498 7.25518C7.02865 7.22042 7.04344 7.1856 7.05929 7.15504C7.09185 7.12341 7.1446 7.14978 7.14581 7.19299V7.19299Z",
    fill: "url(#paint117_linear_9_3255)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52343 7.28695C6.52442 7.30281 6.51277 7.307 6.50225 7.31432C6.48426 7.31859 6.46948 7.30799 6.46116 7.29754C6.45903 7.28162 6.47069 7.27643 6.48114 7.26904C6.49912 7.26477 6.5139 7.27522 6.52343 7.28695Z",
    fill: "url(#paint118_linear_9_3255)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61625 7.28371C6.62144 7.29744 6.60779 7.3059 6.59933 7.31117C6.58455 7.31223 6.57304 7.3091 6.56458 7.29751C6.55925 7.28378 6.57304 7.27433 6.58135 7.26899C6.59606 7.26793 6.60772 7.27105 6.61625 7.28371Z",
    fill: "url(#paint119_linear_9_3255)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72691 7.28695C6.72905 7.30281 6.71739 7.307 6.70573 7.31432C6.68796 7.31859 6.67311 7.30799 6.66465 7.29754C6.66252 7.28162 6.67418 7.27643 6.68583 7.26904C6.70374 7.26477 6.71846 7.27522 6.72691 7.28695Z",
    fill: "url(#paint120_linear_9_3255)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83028 7.28981C6.83028 7.30567 6.81876 7.31733 6.80277 7.31733C6.78692 7.31832 6.77121 7.31306 6.76801 7.29728C6.76695 7.28136 6.7786 7.27617 6.78912 7.26877C6.80711 7.26564 6.82708 7.27297 6.83028 7.28981Z",
    fill: "url(#paint121_linear_9_3255)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85036 7.28677C7.85356 7.29942 7.84723 7.30894 7.83664 7.3174C7.82391 7.3206 7.81445 7.31413 7.80613 7.30368C7.80293 7.28997 7.80926 7.28051 7.81971 7.27305C7.83344 7.26985 7.8429 7.27618 7.85036 7.28677Z",
    fill: "url(#paint122_linear_9_3255)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91678 7.307C6.90633 7.31645 6.88615 7.31645 6.8757 7.307C6.86618 7.29435 6.8757 7.28063 6.88935 7.27637C6.90633 7.27637 6.93263 7.28582 6.91678 7.307Z",
    fill: "url(#paint123_linear_9_3255)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76383 7.28979C7.76696 7.30138 7.76063 7.3109 7.75019 7.31403C7.73854 7.31617 7.72589 7.31197 7.72277 7.30045C7.72063 7.2888 7.72696 7.27927 7.73634 7.27614C7.74905 7.27408 7.7617 7.2782 7.76383 7.28979V7.28979Z",
    fill: "url(#paint124_linear_9_3255)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93373 7.28979C7.93693 7.30138 7.9294 7.31091 7.92002 7.31404C7.90837 7.31617 7.89885 7.30984 7.89572 7.30046C7.89373 7.2888 7.90006 7.27927 7.90943 7.27614C7.92094 7.27294 7.93061 7.28041 7.93373 7.28979V7.28979Z",
    fill: "url(#paint125_linear_9_3255)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63298 7.31108L7.63618 7.34591H7.48741C7.4791 7.33112 7.48955 7.31748 7.49054 7.30369C7.53816 7.30582 7.58976 7.2985 7.63298 7.31108Z",
    fill: "url(#paint126_linear_9_3255)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16258 7.30685C7.17737 7.3163 7.19102 7.33109 7.19009 7.34899L7.00015 7.34587C7.00548 7.27622 7.10884 7.31943 7.16258 7.30685V7.30685Z",
    fill: "url(#paint127_linear_9_3255)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95911 7.4356C6.0034 7.47256 6.06346 7.51471 6.05927 7.57698C6.01065 7.59809 5.93679 7.51585 5.91789 7.59489C5.88839 7.58857 5.86408 7.55587 5.8483 7.5327C5.83031 7.48408 5.81233 7.43141 5.80401 7.38393C5.79555 7.36488 5.81667 7.37867 5.82079 7.36914C5.87353 7.37653 5.91049 7.42089 5.95911 7.4356V7.4356Z",
    fill: "url(#paint128_linear_9_3255)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82078 7.60119C5.83556 7.64746 5.93998 7.66445 5.88617 7.71513C5.85355 7.71399 5.83556 7.76887 5.79967 7.7425C5.74486 7.67504 5.66568 7.60851 5.69311 7.51468C5.7111 7.48625 5.74173 7.51042 5.76597 7.50836C5.79021 7.53359 5.79966 7.57055 5.82078 7.60119V7.60119Z",
    fill: "url(#paint129_linear_9_3255)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12883 7.7014L6.20787 7.91556C6.21221 7.94719 6.1805 7.9398 6.16359 7.9398C6.06656 7.88073 5.978 7.78158 5.94523 7.67716C5.94523 7.65925 5.94424 7.64027 5.96321 7.62861C5.99499 7.6188 6.08654 7.62684 6.12883 7.7014Z",
    fill: "url(#paint130_linear_9_3255)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35347 7.77406C6.37245 7.82147 6.38731 7.87527 6.38098 7.93007C6.32504 7.94166 6.28609 7.89219 6.246 7.85736C6.21444 7.80988 6.17002 7.75402 6.19738 7.69495C6.26178 7.69282 6.32291 7.71706 6.35347 7.77406V7.77406Z",
    fill: "url(#paint131_linear_9_3255)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78282 7.83633C5.83877 8.08845 5.93579 8.32465 6.05926 8.54834C6.10141 8.61266 6.15536 8.67713 6.21855 8.72454C6.00019 8.68133 5.83343 8.45451 5.75539 8.26146C5.70264 8.08319 5.62986 7.91445 5.64464 7.70874L5.78282 7.83633V7.83633Z",
    fill: "#E60012"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99386 7.99243C6.09088 8.26978 6.19957 8.54828 6.45056 8.75612L6.55406 8.84895C6.39675 8.8036 6.2312 8.7488 6.13197 8.5937C5.97488 8.37633 5.8905 8.12848 5.83136 7.87109L5.99386 7.99243Z",
    fill: "#E60012"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46746 8.32049L6.57501 8.47239C6.89253 8.78678 7.41469 8.86796 7.81246 8.66964C7.83663 8.66012 7.85987 8.64747 7.8851 8.64221C7.89463 8.65799 7.88411 8.68336 7.87466 8.70127L7.84089 8.73191C7.60867 8.82886 7.36607 8.89959 7.09305 8.89746C6.83559 8.90485 6.62256 8.80143 6.42951 8.6528L6.40527 8.67711C6.23211 8.47772 6.11199 8.2583 6.04233 8.01562C6.19316 8.09687 6.32402 8.22453 6.46746 8.32049V8.32049Z",
    fill: "#E60012"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32285 8.03977L5.17422 9.07462C5.17109 9.09154 5.14678 9.08414 5.13612 9.08094L5.12567 9.07042L5.29243 8.04411C5.29975 8.02719 5.31027 8.04724 5.32285 8.03977Z",
    fill: "#E60012"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66883 8.46613L5.58246 9.08425L5.23004 9.05361L5.33034 8.22347L5.35451 8.12012C5.45487 8.23093 5.56356 8.35013 5.66883 8.46613V8.46613Z",
    fill: "#E60012"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10351 8.60434C7.31455 8.63704 7.56866 8.68026 7.76805 8.59062C7.77117 8.5843 7.78184 8.58117 7.77864 8.57271C7.75539 8.55046 7.72376 8.57058 7.69846 8.57271C7.45998 8.63917 7.17737 8.60648 6.9654 8.50731C6.96327 8.4936 6.97905 8.49459 6.98637 8.49047C7.26814 8.52317 7.57087 8.50518 7.84403 8.46616C7.86401 8.46616 7.87666 8.47668 7.88512 8.49359L7.88831 8.60754L7.87879 8.61813C7.62667 8.69718 7.33453 8.80266 7.05923 8.70144C6.9686 8.67614 6.88522 8.63491 6.79971 8.59695C6.70162 8.5157 6.57403 8.44725 6.51596 8.3269C6.71648 8.40922 6.90833 8.51144 7.10351 8.60434V8.60434Z",
    fill: "#E60012"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72374 8.6487L5.66887 9.17505L5.63098 9.09487L5.69637 8.5C5.7617 8.53056 5.71528 8.59901 5.72374 8.6487Z",
    fill: "#E60012"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95597 8.69697C5.92633 8.89529 5.90636 9.09787 5.8662 9.29192L5.44419 9.25389C5.4368 9.23917 5.42834 9.22546 5.42621 9.20854C5.51705 9.18849 5.59709 9.23072 5.68999 9.22652C5.70584 9.19169 5.70157 9.14108 5.7069 9.0978L5.76597 8.57983C5.81985 8.64111 5.89249 8.65795 5.95597 8.69697V8.69697Z",
    fill: "#E60012"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95911 9.3543C5.92421 9.35537 5.92741 9.30163 5.91049 9.27526L5.98641 8.71509L6.02551 8.7394L5.95911 9.3543V9.3543Z",
    fill: "#E60012"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15315 8.81522L6.10134 9.45764L6.09089 9.47236L5.7797 9.46816C5.75972 9.4597 5.72589 9.45971 5.72375 9.43014L5.73115 9.42381C5.81453 9.42061 5.8947 9.44385 5.97275 9.43014L5.99073 9.39218L6.05613 8.75928C6.08342 8.78885 6.12032 8.79624 6.15315 8.81522V8.81522Z",
    fill: "#E60012"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16993 9.51986L6.12885 9.47863L6.18792 8.82886L6.23213 8.84578L6.16993 9.51986Z",
    fill: "#E60012"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28076 9.63077C6.18792 9.6371 6.08137 9.63816 5.99707 9.60326V9.59694C6.06126 9.59694 6.12153 9.60859 6.1838 9.61378L6.19425 9.59694L6.26384 8.85962L6.31559 8.88073L6.28076 9.63077V9.63077Z",
    fill: "#E60012"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39456 8.92177L6.38411 9.3088C6.41574 9.44492 6.4716 9.58622 6.42953 9.73499H6.41261L6.31879 9.63797L6.35042 8.89746C6.36513 8.90599 6.38517 8.90919 6.39456 8.92177V8.92177Z",
    fill: "#E60012"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4748 8.93559L6.42946 8.9704L6.42633 8.92188C6.43898 8.93452 6.45902 8.9314 6.4748 8.93559V8.93559Z",
    fill: "#E60012"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56451 8.95035C6.52342 8.98625 6.4748 9.00309 6.42952 9.02946C6.41161 8.97992 6.4812 8.98831 6.50224 8.95668C6.51589 8.93031 6.54439 8.95142 6.56451 8.95035Z",
    fill: "#E60012"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71326 8.97033C6.62675 9.02201 6.53485 9.06324 6.44316 9.10219C6.43683 9.08946 6.44315 9.07262 6.43683 9.05997C6.50329 9.03352 6.56861 9.00616 6.62675 8.95654L6.71326 8.97033V8.97033Z",
    fill: "#E60012"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23537 9.01246L7.23218 9.0325C6.99384 9.15376 6.75224 9.26458 6.50544 9.36473L6.47794 9.31305C6.67419 9.22761 6.86725 9.13791 7.05924 9.04302L7.12783 8.99121C7.16678 9.00087 7.22699 8.93641 7.23537 9.01246V9.01246Z",
    fill: "#E60012"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85879 8.99136C6.73226 9.07891 6.58882 9.12639 6.44637 9.17805C6.44531 9.16647 6.4495 9.15282 6.44318 9.1433C6.5476 9.08424 6.66467 9.05468 6.76169 8.97778L6.85879 8.99136V8.99136Z",
    fill: "#E60012"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04124 8.99772C6.89567 9.10747 6.72692 9.16128 6.56763 9.23719L6.46115 9.27835C6.45162 9.2615 6.44849 9.24139 6.45056 9.21928C6.60566 9.15175 6.77021 9.1064 6.90633 8.99459C6.95374 8.99039 6.99902 9.00191 7.04124 8.99772Z",
    fill: "#E60012"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3461 9.04309C7.33878 9.07465 7.32285 9.10848 7.29023 9.12213L6.58128 9.44812C6.57175 9.45131 6.5623 9.45551 6.55078 9.45444C6.53799 9.43859 6.536 9.41855 6.52335 9.40277L7.12141 9.12945L7.32804 9.0293C7.33565 9.03143 7.33977 9.03776 7.3461 9.04309V9.04309Z",
    fill: "#E60012"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62772 9.18452C5.53069 9.18985 5.41888 9.13817 5.34403 9.21622L5.14685 9.17506L5.19213 9.10547L5.59623 9.14663L5.62772 9.18452V9.18452Z",
    fill: "#E60012"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44312 9.28892C7.48322 9.28892 7.51172 9.26255 7.54961 9.25729C7.56446 9.3681 7.5528 9.48624 7.54648 9.59691L7.53909 9.60324C7.43772 9.6075 7.34922 9.58106 7.2522 9.57587C7.25419 9.44402 7.25852 9.30477 7.26585 9.17085C7.29016 9.15493 7.31447 9.15713 7.33245 9.18443L7.44312 9.28892V9.28892Z",
    fill: "#E60012"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15942 9.6381C7.15942 9.49885 7.17101 9.35434 7.1762 9.21303L7.22796 9.18872L7.21438 9.6413L7.15942 9.6381Z",
    fill: "#E60012"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39577 9.22338C5.39996 9.24137 5.38944 9.26142 5.37885 9.27827C5.36933 9.28986 5.35767 9.29732 5.3441 9.29938C5.33138 9.28986 5.33358 9.27095 5.33358 9.26142C5.35455 9.24876 5.36933 9.22025 5.39577 9.22338Z",
    fill: "#E60012"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13195 9.25398C7.1215 9.3532 7.13827 9.46281 7.11716 9.55777L6.85458 9.53034C6.82708 9.48918 6.83553 9.42699 6.83461 9.37105L7.12463 9.23706L7.13195 9.25398V9.25398Z",
    fill: "#E60012"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51587 9.48625H6.51267C6.50435 9.50942 6.50322 9.54005 6.48111 9.55476C6.47158 9.53692 6.47265 9.51368 6.46746 9.49257C6.44315 9.42193 6.41791 9.35228 6.40839 9.2753L6.41884 9.25732L6.51907 9.45455L6.51587 9.48625V9.48625Z",
    fill: "#E60012"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92846 9.39219C5.7396 9.39219 5.55073 9.37108 5.37466 9.32998L5.42314 9.28882L5.86939 9.32366L5.92846 9.39219Z",
    fill: "#E60012"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62254 9.30877C7.61728 9.32675 7.6362 9.36051 7.60562 9.36151C7.58343 9.36471 7.58564 9.34367 7.5813 9.32995C7.58564 9.31623 7.58343 9.29725 7.60142 9.29199C7.60989 9.29405 7.62041 9.30038 7.62254 9.30877V9.30877Z",
    fill: "#E60012"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6605 9.41651L7.64671 9.64441C7.6605 9.6592 7.65623 9.68138 7.67734 9.69296L7.56348 9.67612C7.59191 9.59387 7.57712 9.48511 7.59191 9.39234C7.61622 9.37443 7.64671 9.39341 7.6605 9.41651V9.41651Z",
    fill: "#E60012"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80603 9.56217C6.8609 9.59807 6.93582 9.58222 6.99709 9.60326C6.99808 9.62018 6.97591 9.61172 6.96866 9.62444C6.91272 9.63809 6.84932 9.62757 6.79245 9.62018L6.782 9.60646C6.77035 9.56537 6.79558 9.50311 6.74817 9.48199C6.68171 9.49991 6.61838 9.5326 6.55099 9.53467C6.55519 9.51469 6.56365 9.49145 6.58575 9.48619L6.79245 9.38916L6.80603 9.56217V9.56217Z",
    fill: "#E60012"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95789 9.44821C7.96322 9.47458 7.9591 9.50514 7.97488 9.52732C7.97488 9.56954 7.97907 9.61802 7.95789 9.64859C7.86407 9.64333 7.77239 9.63274 7.68482 9.61376C7.67736 9.55682 7.68163 9.49676 7.69527 9.44394C7.73223 9.45873 7.76699 9.48929 7.8124 9.47238L7.864 9.39966C7.89883 9.40805 7.95057 9.40385 7.95789 9.44821V9.44821Z",
    fill: "#E60012"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68588 9.41959C5.69221 9.44184 5.68467 9.46708 5.67209 9.48614C5.66378 9.49979 5.64899 9.49979 5.63733 9.50611C5.62567 9.48926 5.63314 9.46289 5.63101 9.44071C5.64892 9.43338 5.66157 9.4112 5.68588 9.41959V9.41959Z",
    fill: "#E60012"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15948 9.57264C5.99586 9.56838 5.82199 9.57051 5.66888 9.53043C5.67635 9.51565 5.69533 9.50094 5.71438 9.49561L6.09729 9.51046L6.15948 9.57264Z",
    fill: "#E60012"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04751 9.52421C8.03905 9.59692 8.06762 9.68448 8.0232 9.74148C7.96214 9.752 7.88197 9.75946 7.84401 9.7004C7.84089 9.66977 7.88098 9.68562 7.89569 9.68668C7.93158 9.68874 7.96534 9.69621 8.00337 9.69301C8.01694 9.64028 8.00436 9.57602 8.01282 9.52002L8.04751 9.52421V9.52421Z",
    fill: "#E60012"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07924 9.73518L8.06879 9.71719C8.07298 9.6518 8.07298 9.58435 8.08236 9.52002H8.10668V9.71407C8.10206 9.72693 8.09644 9.74022 8.07924 9.73518V9.73518Z",
    fill: "#E60012"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94843 9.62738C5.9463 9.64004 5.94104 9.65376 5.92845 9.65902H5.91786C5.92099 9.63997 5.89469 9.61046 5.92845 9.60307C5.94523 9.60214 5.9431 9.61686 5.94843 9.62738Z",
    fill: "#E60012"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44313 9.63803C7.45052 9.64436 7.45792 9.65388 7.44946 9.66227C7.441 9.66546 7.42636 9.67072 7.41157 9.66859C7.40838 9.65914 7.39779 9.65281 7.39039 9.64436C7.35464 9.6359 7.36609 9.70555 7.32813 9.67598C7.31868 9.66227 7.3039 9.64535 7.31456 9.62744L7.44313 9.63803Z",
    fill: "#E60012"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24597 9.68644C7.25336 9.69276 7.26061 9.70435 7.25229 9.71387C7.17424 9.71813 7.09306 9.70754 7.01693 9.69703C7.0106 9.6907 7.01494 9.68018 7.0138 9.67272C7.02333 9.66327 7.03179 9.65161 7.04537 9.65161C7.11197 9.66327 7.18156 9.66846 7.24597 9.68644V9.68644Z",
    fill: "#E60012"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30192 9.67614C6.32715 9.69093 6.35253 9.71624 6.36731 9.74155C6.2238 9.74048 6.07922 9.71837 5.93478 9.70678L5.98646 9.65503L6.30192 9.67614V9.67614Z",
    fill: "#E60012"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81971 9.72762C7.82817 9.73501 7.82603 9.74767 7.82603 9.75933C7.81246 9.77404 7.79227 9.77298 7.77116 9.77298L7.43269 9.74454L7.40518 9.73082C7.41257 9.7203 7.41371 9.69705 7.43269 9.70025C7.56034 9.7129 7.68573 9.72983 7.81971 9.72762V9.72762Z",
    fill: "#E60012"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81246 3.52101L7.63298 4.08106L8.12408 3.743L8.61504 4.08106L8.43577 3.52101L8.4421 3.50729L8.95787 3.12012H8.32503L8.12394 2.49951L7.92306 3.12012H7.29022L7.80613 3.50729L7.81246 3.52101Z",
    fill: "url(#paint132_linear_9_3255)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12109 2.52515V3.23595L7.92307 3.12023",
    fill: "url(#paint133_linear_9_3255)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93563 3.12329L8.44397 3.50236L8.12112 3.23581L8.93563 3.12329Z",
    fill: "url(#paint134_linear_9_3255)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12407 3.74305L7.63297 4.08111L8.12407 3.25366V3.74305Z",
    fill: "url(#paint135_linear_9_3255)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29022 3.12012L7.79831 3.49059L8.13594 3.23584L7.29022 3.12012Z",
    fill: "url(#paint136_linear_9_3255)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26192 4.01199L6.22005 4.33633L6.45469 4.10205L6.75721 4.23767L6.60297 3.94937L6.60496 3.94127L6.84827 3.67755L6.50203 3.7411L6.32973 3.42188L6.28218 3.78147L5.93594 3.84509L6.25716 4.0051L6.26192 4.01199Z",
    fill: "url(#paint137_linear_9_3255)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33078 3.43628L6.40222 3.82509L6.28217 3.78159",
    fill: "url(#paint138_linear_9_3255)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83639 3.68164L6.60552 3.93845L6.40222 3.82501L6.83639 3.68164Z",
    fill: "url(#paint139_linear_9_3255)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45471 4.10216L6.22006 4.33644L6.40566 3.83447L6.45471 4.10216Z",
    fill: "url(#paint140_linear_9_3255)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93594 3.8451L6.25119 3.99672L6.41026 3.82349L5.93594 3.8451Z",
    fill: "url(#paint141_linear_9_3255)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63469 3.88388L9.47546 4.16956L9.78026 4.03912L10.0109 4.27739L9.97468 3.95233L9.97958 3.94558L10.3034 3.79098L9.95825 3.72153L9.91674 3.36108L9.73911 3.67739L9.39407 3.60795L9.63284 3.87571L9.63469 3.88388Z",
    fill: "url(#paint142_linear_9_3255)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9125 3.37476L9.83444 3.76236L9.73911 3.67742",
    fill: "url(#paint143_linear_9_3255)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2907 3.79046L9.98105 3.94321L9.83441 3.76245L10.2907 3.79046Z",
    fill: "url(#paint144_linear_9_3255)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78027 4.03906L9.47549 4.16949L9.83408 3.77222L9.78027 4.03906Z",
    fill: "url(#paint145_linear_9_3255)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39407 3.60791L9.63043 3.86573L9.84241 3.76387L9.39407 3.60791Z",
    fill: "url(#paint146_linear_9_3255)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67154 4.67974L8.39758 4.85829L8.72812 4.88488L8.82109 5.2031L8.94044 4.89867L8.94791 4.8949L9.30645 4.90897L9.03349 4.68678L9.16478 4.34865L8.86019 4.54561L8.58716 4.32349L8.67367 4.67156L8.67154 4.67974Z",
    fill: "url(#paint147_linear_9_3255)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15697 4.3606L8.90741 4.66716L9.0335 4.68678",
    fill: "url(#paint148_linear_9_3255)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59564 4.33276L8.67468 4.66884L8.9074 4.6672L8.59564 4.33276Z",
    fill: "url(#paint149_linear_9_3255)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72812 4.88494L8.82109 5.20317L8.89991 4.67383L8.72812 4.88494Z",
    fill: "url(#paint150_linear_9_3255)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30643 4.90897L8.95722 4.89042L8.901 4.66211L9.30643 4.90897Z",
    fill: "url(#paint151_linear_9_3255)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25327 4.95197L7.37255 5.25642L7.46559 4.93818L7.79605 4.9116L7.52217 4.73304L7.51997 4.72487L7.60648 4.37671L7.33345 4.59891L7.02887 4.40194L7.16016 4.74008L6.88721 4.96228L7.24574 4.94821L7.25327 4.95197Z",
    fill: "url(#paint152_linear_9_3255)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03677 4.41382L7.28627 4.72039L7.16017 4.74001",
    fill: "url(#paint153_linear_9_3255)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59801 4.38599L7.51904 4.72206L7.28625 4.72043L7.59801 4.38599Z",
    fill: "url(#paint154_linear_9_3255)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46561 4.93816L7.37256 5.25638L7.29379 4.72705L7.46561 4.93816Z",
    fill: "url(#paint155_linear_9_3255)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88721 4.96219L7.23643 4.94364L7.29265 4.71533L6.88721 4.96219Z",
    fill: "url(#paint156_linear_9_3255)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1224 14.7864L8.90005 15.2484L8.95926 15.0588L12.1224 14.7864Z",
    fill: "url(#paint157_linear_9_3255)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7494 14.2267C14.7494 14.2267 12.4688 14.7421 12.4304 14.6918C12.3919 14.6414 14.5717 14.0401 14.5717 14.0401C14.5717 14.0401 14.5983 13.9424 14.5006 13.9424C14.4029 13.9424 12.0512 14.7628 12.0128 14.7154C11.9743 14.6681 14.314 13.818 14.314 13.818C14.314 13.818 14.2696 13.7114 13.9941 13.7914C13.7187 13.8713 11.7729 14.6858 11.7462 14.6266C11.7196 14.5674 13.6565 13.8091 13.6565 13.667C13.6565 13.5248 11.376 14.751 11.3464 14.7065C11.3168 14.6621 12.8657 13.7292 12.8302 13.6936C12.7947 13.6581 10.9732 14.7983 10.9554 14.7599C10.9377 14.7214 12.2882 13.7914 12.2882 13.6758C12.2882 13.5603 10.8606 14.8221 10.8044 14.8043C10.7482 14.7865 11.7284 13.9157 11.6751 13.7558C11.6381 13.6448 10.5467 14.7954 10.3868 14.8309C10.2269 14.8665 11.2973 13.8115 11.2812 13.7795C11.2812 13.7795 11.2842 13.6581 11.0088 13.9157C10.7333 14.1734 10.1025 14.9109 10.1025 14.9109C10.1025 14.9109 9.84482 15.0442 10.2535 14.5288C10.2535 14.5288 11.0354 13.7647 10.7244 13.8358C10.7244 13.8358 9.88036 14.8487 9.82705 14.8931C9.77374 14.9376 9.64046 14.8843 9.79151 14.7599C9.94255 14.6355 10.4223 13.8891 10.3246 13.8891C10.2269 13.8891 9.57827 14.9198 9.50719 14.9376C9.35614 14.9198 9.87147 14.1734 9.94255 13.9868C9.94255 13.9868 9.88036 13.9157 9.76485 14.129C9.64935 14.3422 9.26729 14.9998 9.16067 14.9465C9.05405 14.8931 9.69377 14.2356 9.5605 14.0668C9.5605 14.0668 9.48942 14.0135 9.44499 14.1557C9.40056 14.2978 9.0807 14.9909 9.00074 14.9909C8.92077 14.9909 9.16067 14.5733 9.26729 14.209C9.26729 14.209 9.29394 14.0668 9.18732 14.1201C9.0807 14.1734 8.98297 14.6799 8.98297 14.6799C8.98297 14.6799 8.87635 14.1734 8.92077 14.0313C8.9652 13.8891 12.8391 13.3915 14.0119 13.6225C14.0119 13.6225 14.7049 13.7292 14.7494 14.2267Z",
    fill: "url(#paint158_linear_9_3255)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7494 14.2266C14.7494 14.2266 12.4526 14.7597 12.497 14.8086C12.5414 14.8575 14.3096 14.653 14.3096 14.653C14.3096 14.653 14.391 14.6797 14.314 14.7152C14.2688 14.7361 13.4547 14.8132 12.7858 14.8574C12.3161 14.8885 11.9151 14.8863 11.9151 14.9107C11.9151 14.9107 11.69 14.9937 12.9221 15.1299C12.9221 15.1299 13.3841 15.0707 13.3011 15.1536C13.2182 15.2365 11.4116 14.9344 11.4827 15.0173C11.5538 15.1003 12.7502 15.4082 12.6495 15.4675C12.5489 15.5268 11.1509 14.9759 11.1154 15.0706C11.0799 15.1654 12.1579 15.5682 12.229 15.6393C12.229 15.6393 10.8074 15.0706 10.7719 15.1299C10.7363 15.1891 12.0512 15.7341 11.8499 15.7578C11.6485 15.7814 10.4756 15.047 10.3927 15.1891C10.3098 15.3313 11.6958 15.8999 11.3168 15.9236C11.0324 15.9117 10.2742 15.1891 10.1084 15.2365C10.1084 15.2365 9.98998 15.2009 10.0966 15.3194C10.2032 15.4379 11.1035 15.9947 10.9614 16.0302C10.8192 16.0658 9.80047 15.2601 9.70565 15.3076C9.61083 15.355 10.061 15.5919 9.93069 15.6393C9.8004 15.6867 9.55155 15.2601 9.43313 15.3431C9.31471 15.426 9.30284 15.4971 9.33838 15.5563C9.37392 15.6156 9.05406 15.3194 9.01851 15.426C8.98297 15.5327 9.17255 16.2672 9.42133 16.2909C9.67011 16.3145 14.32 15.9295 14.7494 14.2266V14.2266Z",
    fill: "url(#paint159_linear_9_3255)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8708 10.0359C14.8708 10.0359 14.4562 8.99336 13.4256 9.00523L13.0583 9.68049C13.0583 9.68049 13.7573 9.7279 14.2075 10.4032L14.8708 10.0359Z",
    fill: "url(#paint160_linear_9_3255)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5637 13.5425L13.2745 13.4803C13.2745 13.4803 15.7889 11.8366 15.7978 10.8059C15.7978 10.8059 15.8689 10.5749 15.6112 10.4683C15.6112 10.4683 13.9586 11.65 14.003 11.7033C14.0475 11.7566 15.6823 10.7526 15.6734 10.7881C15.6645 10.8237 14.0475 11.7566 14.083 11.7833C14.1185 11.8099 15.5846 11.0724 15.549 11.2235C15.5135 11.3745 13.7187 11.9165 13.7809 11.9521C13.8431 11.9876 15.1847 11.57 15.1581 11.7033C15.1314 11.8366 13.31 12.2009 13.3544 12.2542C13.3989 12.3075 14.936 11.9965 14.7849 12.1209C14.6339 12.2453 12.9901 12.3341 12.999 12.3786C13.0079 12.423 14.4473 12.4852 14.4473 12.4852C14.4473 12.4852 12.4393 12.6007 12.5281 12.6807C12.617 12.7606 14.2429 12.7962 14.003 12.8495C13.7631 12.9028 12.0927 12.8228 12.1994 12.8584C12.306 12.8939 13.8342 13.1071 13.5854 13.1071C13.3367 13.1071 11.8795 12.965 11.9328 13.0272C11.9861 13.0894 13.1767 13.3115 13.0079 13.3559C12.8391 13.4003 11.5419 13.1071 11.5508 13.1604C11.5596 13.2138 12.5281 13.5514 12.3771 13.5336C12.226 13.5159 11.3197 13.1782 11.3464 13.3115C11.3731 13.4448 11.7907 13.4892 11.7551 13.5425C11.7196 13.5958 11.1865 13.3115 11.2131 13.3648C11.2398 13.4181 11.4353 13.6047 11.4353 13.6047L12.5637 13.5425V13.5425Z",
    fill: "url(#paint161_linear_9_3255)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5402 10.3973C15.5402 10.3973 14.0031 11.6589 13.9586 11.6412C13.9142 11.6234 14.4917 11.117 14.6606 10.9481C14.8294 10.7793 15.2914 10.3262 15.1315 10.3884C14.9715 10.4506 13.852 11.73 13.7632 11.73C13.6394 11.73 14.8116 10.4684 14.7227 10.4772C14.6339 10.4861 13.6565 11.7745 13.5943 11.7034C13.5321 11.6323 14.5273 10.3528 14.2874 10.5394C14.0475 10.726 13.4255 11.8633 13.3456 11.8278C13.2656 11.7922 14.0119 10.7171 13.932 10.7349C13.852 10.7527 13.1412 11.9788 13.0435 12.0765C12.9457 12.1743 13.0257 11.9077 13.0701 11.8278C13.1145 11.7478 13.6654 10.8149 13.5321 10.8948C13.3989 10.9748 12.9191 12.0765 12.7858 12.1832C12.6525 12.2898 13.1945 11.1081 13.1501 11.0637C13.1057 11.0192 12.6436 12.2898 12.5726 12.3076C12.5015 12.3253 12.9635 11.2236 12.8302 11.2058C12.6969 11.188 12.4393 12.3253 12.3327 12.3431C12.226 12.3609 12.4482 11.2769 12.3593 11.3391C12.2906 11.3871 12.1727 12.5652 12.0839 12.5652C11.995 12.5652 12.1905 11.6145 12.0483 11.5257C12.0483 11.5257 11.9151 12.7163 11.844 12.6452C11.7729 12.5741 11.8262 11.6323 11.7551 11.7922C11.684 11.9522 11.4619 11.9522 11.4619 11.9522C11.4619 11.9522 11.7875 11.6455 12.386 11.2858C13.3834 10.6863 14.9427 9.95856 15.5757 10.3973",
    fill: "url(#paint162_linear_9_3255)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0403 13.1337C10.0403 13.1337 10.5467 13.0182 10.68 13.6047C10.68 13.6047 10.4934 13.7024 10.4757 13.6136C10.4579 13.5247 10.4934 13.3648 10.3957 13.3648C10.298 13.3648 10.3957 13.6047 10.2802 13.6047C10.1647 13.6047 10.2002 13.4714 10.1025 13.4536C10.0048 13.4358 9.82705 13.4536 9.87147 13.347C9.9159 13.2404 9.96032 13.1426 10.0403 13.1337Z",
    fill: "url(#paint163_linear_9_3255)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8981 13.4448C9.92475 13.4448 10.058 13.4626 10.0669 13.5426C10.0758 13.6225 10.1913 13.6403 10.1646 13.6936C10.138 13.7469 10.0758 13.818 10.0225 13.7292C9.96918 13.6403 9.97806 13.6314 9.93364 13.6136C9.88921 13.5959 9.7826 13.4804 9.87144 13.4804",
    fill: "url(#paint164_linear_9_3255)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2269 13.6492C10.2216 13.6865 10.2713 13.7291 10.3513 13.7291C10.4312 13.7291 10.4401 13.7025 10.3957 13.658C10.3513 13.6136 10.2358 13.587 10.2269 13.6492Z",
    fill: "url(#paint165_linear_9_3255)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80927 13.4714C9.77373 13.4803 9.50718 13.507 9.59603 13.5603C9.68488 13.6136 9.68488 13.5781 9.78262 13.6225C9.88035 13.6669 9.92478 13.7558 9.93366 13.7202C9.94255 13.6847 9.88035 13.6136 9.84481 13.5958C9.80927 13.5781 9.80927 13.4714 9.80927 13.4714Z",
    fill: "url(#paint166_linear_9_3255)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69376 13.4093L9.82703 13.3826L9.80037 13.2849L9.69376 13.4093Z",
    fill: "url(#paint167_linear_9_3255)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6445 13.3381C10.6445 13.3381 10.6889 13.4802 10.7689 13.498C10.8488 13.5158 10.9466 13.5513 10.9021 13.4536C10.8577 13.3558 10.8399 13.3292 10.8844 13.3292C10.9288 13.3292 10.9643 13.3647 11.0532 13.3292C11.142 13.2936 11.2309 13.2314 11.1776 13.2226C11.1243 13.2137 11.1065 13.2403 11.0532 13.1959C10.9999 13.1515 10.9466 12.9649 10.9377 13.0715C10.9288 13.1781 10.9999 13.1959 10.9288 13.2403C10.8577 13.2847 10.8933 13.3025 10.8311 13.3025C10.7689 13.3025 10.5912 13.267 10.6178 13.3292",
    fill: "url(#paint168_linear_9_3255)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6089 13.2315C10.6089 13.2315 10.7155 13.2581 10.7511 13.2403C10.7866 13.2226 10.8577 13.2315 10.8488 13.1959C10.8399 13.1604 10.8399 13.187 10.8577 13.0893C10.8755 12.9916 10.9021 13.0004 10.8222 12.9738C10.7422 12.9471 10.7244 12.9649 10.6711 12.876C10.6178 12.7872 10.7155 12.7072 10.7511 12.7517C10.7866 12.7961 10.7155 12.8494 10.7866 12.8672C10.8577 12.8849 10.8755 12.9382 10.8844 12.8672C10.8932 12.7961 10.9288 12.7783 10.8932 12.7605C10.8577 12.7428 10.7955 12.7783 10.8488 12.6806C10.9021 12.5828 10.9199 12.4318 10.9554 12.5295C10.991 12.6273 10.9288 12.6628 10.9732 12.7428C11.0176 12.8227 11.1243 12.805 11.0798 12.8405C11.0354 12.876 10.9199 12.8139 10.9732 12.9294C11.0265 13.0449 11.0621 13.1337 11.1243 13.0804C11.1865 13.0271 11.2575 13.0626 11.2042 12.956C11.1509 12.8494 11.3109 12.9027 11.1687 12.7428C11.0265 12.5828 10.991 12.6539 11.0532 12.5295C11.1154 12.4051 11.1331 12.3341 11.0621 12.3518C10.991 12.3696 11.0354 12.414 10.911 12.4851C10.7866 12.5562 10.6978 12.5384 10.6622 12.5828C10.6267 12.6273 10.5467 12.725 10.4845 12.7783C10.4223 12.8316 10.4223 12.8139 10.449 12.8405C10.4756 12.8672 10.4934 12.8849 10.3779 12.9027C10.2624 12.9205 10.218 13.0893 10.2891 13.0982C10.3601 13.1071 10.4401 13.0893 10.4668 13.1159C10.4934 13.1426 10.4756 13.0893 10.5112 12.9649C10.5467 12.8405 10.5734 12.7872 10.5912 12.8494C10.6089 12.9116 10.6 12.956 10.5823 13.0093C10.5645 13.0626 10.4934 13.1781 10.6089 13.2315Z",
    fill: "url(#paint169_linear_9_3255)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3197 12.956C11.3037 12.9774 11.142 12.112 11.373 11.9609C11.3997 11.9609 11.4797 12.7428 11.3197 12.956Z",
    fill: "url(#paint170_linear_9_3255)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2398 13.0983C11.2398 13.0983 13.7898 11.7122 13.8875 11.7567C13.8875 11.7567 13.1234 12.272 12.8568 12.4142C12.5903 12.5563 11.3286 13.2494 11.3286 13.2494C11.3286 13.2494 11.142 13.2938 11.2398 13.0983Z",
    fill: "url(#paint171_linear_9_3255)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7688 13.6313C10.7688 13.6313 10.76 13.5691 10.8488 13.6136C10.9377 13.658 10.9732 13.6224 10.9821 13.5691C10.991 13.5158 11.0798 13.4803 11.1243 13.5158C11.1687 13.5513 11.0976 13.2848 11.1332 13.3559C11.1687 13.4269 11.3375 13.4803 11.2576 13.5691C11.1776 13.658 10.7333 13.6402 10.7333 13.6402",
    fill: "url(#paint172_linear_9_3255)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1008 10.406C14.083 10.3794 13.9053 10.1483 13.8076 10.1306C13.7098 10.1128 13.6832 10.0773 13.6654 10.1395C13.6476 10.2017 13.7631 10.255 13.6121 10.2461C13.4611 10.2372 13.3989 10.1661 13.39 10.2816C13.3811 10.3971 13.2656 10.3705 13.3811 10.3971C13.4966 10.4238 13.4788 10.4504 13.5321 10.3882C13.5854 10.326 13.541 10.2994 13.6565 10.2816C13.772 10.2638 13.701 10.1928 13.7987 10.2372C13.8964 10.2816 13.9675 10.2816 13.9142 10.326C13.8609 10.3705 13.8875 10.3527 13.7987 10.3882C13.7098 10.4238 13.8165 10.3172 13.772 10.4149C13.7276 10.5126 13.8342 10.5215 13.7276 10.5126C13.621 10.5037 13.6121 10.4682 13.5943 10.5482C13.5766 10.6281 13.6654 10.5926 13.541 10.5926C13.4166 10.5926 13.3278 10.5748 13.3633 10.6637C13.3989 10.7525 14.1008 10.406 14.1008 10.406Z",
    fill: "url(#paint173_linear_9_3255)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6832 10.0683C13.7187 10.0683 13.8431 10.1483 13.8164 10.0683C13.7898 9.98833 13.7009 9.97945 13.6032 9.96168C13.5055 9.94391 13.4966 9.87283 13.4077 9.87283C13.3189 9.87283 13.2745 9.81063 13.1945 9.84617C13.1145 9.88171 12.9368 9.81952 12.9724 9.92614C13.0079 10.0328 13.0346 10.0861 13.079 10.0683C13.1234 10.0505 13.2922 10.0505 13.2833 10.1038C13.2745 10.1571 13.2656 10.1483 13.3455 10.1394C13.4255 10.1305 13.4877 10.1927 13.4788 10.095C13.4699 9.99722 13.461 10.0061 13.4344 9.97945C13.4077 9.95279 13.5588 10.0328 13.5588 10.0328C13.5588 10.0328 13.5943 10.0683 13.5588 10.0861C13.5432 10.0938 13.5259 10.117 13.4988 10.1405C13.464 10.1707 13.4127 10.2016 13.3278 10.2016C13.1767 10.2016 13.1501 10.166 13.0967 10.166C13.0434 10.166 12.848 10.0239 12.8124 10.1394C12.7769 10.2549 12.768 10.2193 12.688 10.2282C12.6081 10.2371 12.5014 10.166 12.5548 10.2549C12.6081 10.3437 12.6703 10.4592 12.7769 10.4059C12.8835 10.3526 12.8302 10.1749 12.9546 10.2282C13.079 10.2815 13.0257 10.2282 13.0701 10.3526C13.1145 10.477 13.1767 10.5925 13.2211 10.4859C13.2656 10.3793 13.2745 10.2815 13.2745 10.2815C13.2745 10.2815 13.3633 10.2282 13.5677 10.1749C13.6309 10.1584 13.6475 10.0742 13.6565 10.0772",
    fill: "url(#paint174_linear_9_3255)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5814 10.5571C12.5814 10.5571 12.7325 10.4327 12.7769 10.5215C12.8213 10.6104 12.768 10.6104 12.8036 10.7081C12.8391 10.8059 12.9457 10.8236 12.9368 10.717C12.9279 10.6104 12.7769 10.5304 12.8924 10.5215C13.0079 10.5127 13.1323 10.4416 13.1145 10.5393C13.0968 10.6371 13.0701 10.5837 13.1412 10.6104C13.2123 10.6371 13.2834 10.5749 13.2123 10.6371C13.1412 10.6992 13.0523 10.6015 13.0523 10.7081C13.0523 10.8148 13.1412 10.797 13.0523 10.8414C12.9635 10.8858 13.1501 10.9747 12.9279 10.8947C12.7058 10.8148 12.7147 10.8414 12.6436 10.7792C12.5725 10.717 12.6081 10.6371 12.5636 10.6815C12.5192 10.7259 12.457 10.6904 12.5281 10.7792C12.5992 10.8681 12.6525 10.8414 12.6969 10.9125C12.7414 10.9836 12.8302 10.9391 12.7058 10.9747C12.5814 11.0102 12.7058 11.0635 12.5814 11.0102C12.457 10.9569 12.5015 10.9569 12.457 10.9569C12.4126 10.9569 12.4215 10.9569 12.3948 10.9836C12.3682 11.0102 12.4304 10.9925 12.3682 11.0102C12.306 11.028 12.2882 11.1524 12.2704 11.0369C12.2527 10.9214 12.2971 10.8148 12.3859 10.8148C12.4748 10.8148 12.5459 10.8947 12.5015 10.797C12.457 10.6992 12.457 10.5482 12.5814 10.5571Z",
    fill: "url(#paint175_linear_9_3255)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1283 11.1524C12.1283 11.1524 12.1905 11.0369 12.2616 11.0902C12.3326 11.1435 12.4037 11.1346 12.4481 11.0991C12.4926 11.0635 12.617 11.0102 12.5192 11.108C12.4215 11.2057 12.5281 11.2501 12.3682 11.2324C12.2082 11.2146 12.2171 11.1346 12.1638 11.2324C12.1105 11.3301 12.0394 11.3479 12.0661 11.3745C12.0927 11.4012 12.2171 11.2324 12.2349 11.3301L11.533 11.8188C11.533 11.8188 12.1549 10.7615 12.1283 11.1524Z",
    fill: "url(#paint176_linear_9_3255)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3614 9.0941C14.3614 9.0941 14.2074 8.43661 14.1304 8.59654C14.0533 8.75647 14.3436 9.23037 14.1955 9.15929C14.0474 9.0882 13.7098 8.96381 13.7098 8.96381C13.7098 8.96381 14.7406 7.16895 15.244 7.37629C15.244 7.37629 15.9429 7.51255 15.7238 8.41884C15.7238 8.41884 15.4632 9.99442 15.0959 10.2077C15.0959 10.2077 14.9774 10.1959 15.0248 10.1484C15.0722 10.101 15.161 10.0418 15.1729 10.0122C15.1847 9.98262 15.2381 9.93514 15.1255 9.99442C15.0129 10.0537 14.8826 9.95888 14.9596 9.92334C15.0367 9.8878 15.4217 9.72793 15.2973 9.69829C15.1729 9.66865 14.7997 10.0182 14.8471 9.82268C14.8945 9.62721 15.4514 9.41987 15.3566 9.29548C15.2617 9.17109 14.7997 9.75757 14.7642 9.59167C14.7286 9.42577 15.6171 8.99331 15.5757 8.83935C15.5343 8.68539 14.6931 9.5857 14.7405 9.35469C14.7879 9.12368 15.7061 8.60251 15.6586 8.3833C15.6112 8.16408 15.0307 9.15922 14.9537 8.95784C14.8768 8.75647 15.7119 8.29444 15.5638 7.93904C15.5402 7.86206 15.0249 8.73273 15.0308 8.52546C15.0308 8.52546 15.5816 7.68436 15.3802 7.57774C15.321 7.58364 15.0188 8.47215 15.007 8.27077C15.007 8.27077 15.1848 7.66062 15.09 7.65472C14.9952 7.64882 14.9833 8.45445 14.9063 8.35963C14.8293 8.2648 14.9123 7.53025 14.8293 7.71393C14.7464 7.8976 14.8057 8.93424 14.7168 8.83942C14.628 8.7446 14.6517 7.95091 14.5569 8.06343C14.4621 8.17595 14.6517 9.17116 14.5391 9.05266C14.4265 8.93417 14.3674 8.15825 14.3614 8.23523C14.1955 8.33588 14.5391 9.30735 14.3792 9.0941",
    fill: "url(#paint177_linear_9_3255)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4088 9.30124C14.4088 9.30124 14.9064 8.85115 14.9478 8.40092C14.9478 8.40092 15.0012 8.27653 15.013 8.35351C15.0248 8.43049 14.9893 9.05245 14.545 9.4434C14.545 9.4434 14.4504 9.4434 14.4088 9.30124V9.30124Z",
    fill: "url(#paint178_linear_9_3255)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0661 11.0013C12.0661 11.0013 12.3415 10.868 12.3238 10.7703C12.3238 10.7703 12.2971 10.6281 12.3415 10.6459C12.386 10.6637 12.3682 10.6814 12.4215 10.5837C12.4748 10.486 12.4837 10.4593 12.5281 10.4238C12.5726 10.3882 12.5281 10.3171 12.5281 10.3171L12.0661 11.0013Z",
    fill: "url(#paint179_linear_9_3255)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2834 10.6104C13.2834 10.6104 13.3189 10.6015 13.3011 10.5215C13.2834 10.4415 13.3633 10.3971 13.3899 10.4948C13.4166 10.5926 13.2834 10.6104 13.2834 10.6104Z",
    fill: "url(#paint180_linear_9_3255)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99185 13.9691C8.99185 13.9691 9.48941 13.5959 9.55161 13.6137C9.6138 13.6314 9.87147 13.7647 9.87147 13.7647L8.99185 13.9691Z",
    fill: "url(#paint181_linear_9_3255)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2085 7.10966C15.2085 7.10966 14.6197 7.66651 14.6896 7.52435C14.6896 7.52435 15.1851 7.10383 15.156 6.97347C15.127 6.84311 14.5671 7.58946 14.5089 7.48284C14.4506 7.37622 15.197 6.70102 15.1327 6.61807C15.0686 6.53512 14.6371 7.15117 14.5847 7.05045C14.5322 6.94973 15.0977 6.33958 15.0861 6.22115C15.0745 6.10273 14.573 6.86678 14.5905 6.64764C14.608 6.4285 15.1211 6.03158 14.9928 5.88352C14.9404 5.91316 14.6721 6.4285 14.6779 6.26856C14.6779 6.26856 14.9286 5.71172 14.8062 5.61697C14.7654 5.5933 14.7013 6.28626 14.5905 6.22115C14.5905 6.22115 14.6838 5.17271 14.5148 5.27343C14.4274 5.25566 14.509 6.07309 14.4274 6.09086C14.4274 6.09086 14.299 5.17271 14.2815 5.25566C14.2641 5.33862 14.4565 6.31591 14.3282 6.20338C14.3282 6.20338 14.0366 5.17278 14.0716 5.4097C14.1067 5.64661 14.3866 6.58253 14.27 6.51145C14.27 6.51145 13.9608 5.64071 13.9841 5.83618C14.0075 6.03165 14.4389 6.89649 14.3282 6.86685C14.2174 6.83721 13.9986 6.10273 13.9609 6.10863C13.9232 6.11453 14.3107 7.05052 14.2407 7.06232C14.1708 7.07412 13.8443 6.32785 13.8735 6.52922C13.9026 6.73059 14.2991 7.32881 14.2 7.2696C14.1008 7.21039 13.7918 6.70102 13.821 6.83131C13.8502 6.9616 14.28 7.59237 14.0876 7.5628C13.8952 7.53323 13.8122 7.09786 13.7743 7.11855C13.7365 7.13923 14.0718 7.82644 14.0076 7.84421C13.9434 7.86198 13.7365 7.46514 13.6985 7.47694C13.6606 7.48874 14.0076 8.12846 13.9084 8.05148C13.8092 7.9745 13.5498 7.6309 13.6256 7.78493C13.7013 7.93896 13.9667 8.21739 13.8151 8.19962C13.6635 8.18185 13.5411 7.98637 13.5411 7.98637L13.8268 6.71872L14.0385 5.25126C14.0385 5.25126 14.1132 5.17271 14.1532 5.17271C14.1532 5.17271 15.3834 4.90616 15.2085 7.10966V7.10966Z",
    fill: "url(#paint182_linear_9_3255)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9053 8.32685C13.9053 8.32685 14.5184 6.63867 14.5139 5.80347C14.5139 5.80347 14.665 6.2522 14.3185 7.81598L13.8964 8.34021",
    fill: "url(#paint183_linear_9_3255)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M13.39 8.84225C13.4078 8.90892 13.4211 8.93558 13.4522 8.91333C13.4832 8.89108 13.4655 8.82 13.51 8.81559C13.5544 8.81119 13.5011 8.79782 13.5722 8.82895C13.6432 8.86009 13.6699 8.88227 13.6521 8.81118C13.6344 8.7401 13.6788 8.72233 13.6032 8.71345C13.5277 8.70456 13.4477 8.6912 13.5099 8.66013C13.5721 8.62907 13.5588 8.58457 13.5987 8.629C13.6387 8.67343 13.6254 8.73122 13.6743 8.6779C13.7232 8.62459 13.7809 8.629 13.701 8.59346C13.621 8.55792 13.5855 8.60234 13.621 8.55792C13.6565 8.51349 13.7765 8.52678 13.6743 8.48236C13.5721 8.43793 13.581 8.35796 13.5588 8.44234C13.5366 8.52671 13.5855 8.51342 13.5144 8.53119C13.4433 8.54896 13.4611 8.43786 13.4166 8.55785C13.3722 8.67783 13.3989 8.77998 13.3989 8.77998L13.39 8.84225Z",
    fill: "url(#paint184_linear_9_3255)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7676 8.69576C13.7004 8.68616 13.7899 8.68687 13.8076 8.63356C13.8254 8.58025 13.8254 8.58466 13.8032 8.56689C13.7809 8.54912 13.7321 8.57578 13.7809 8.52687C13.8298 8.47797 13.9053 8.50022 13.8342 8.46468C13.7631 8.42914 13.7764 8.46468 13.7454 8.42025C13.7143 8.37582 13.8253 8.36246 13.7231 8.34469C13.6209 8.32692 13.6698 8.31803 13.6209 8.32692C13.572 8.3358 13.5631 8.398 13.5321 8.3358C13.501 8.27361 13.4965 8.25584 13.5187 8.22471C13.5409 8.19357 13.5454 8.14915 13.5676 8.16251C13.5899 8.17587 13.612 8.14474 13.6387 8.18476C13.6653 8.22478 13.6387 8.22478 13.7187 8.22478C13.7986 8.22478 13.8253 8.19364 13.8164 8.23814C13.8075 8.28264 13.8342 8.29145 13.8386 8.31811C13.8431 8.34476 13.7897 8.34924 13.8431 8.34476C13.8965 8.34028 13.9142 8.33588 13.9409 8.32699C13.9675 8.31811 13.972 8.39807 14.0297 8.29586C14.0874 8.19364 14.2119 8.07373 14.2119 8.07373C14.2119 8.07373 13.8609 8.70905 13.7676 8.69576Z",
    fill: "url(#paint185_linear_9_3255)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6476 8.89567C13.6476 8.89567 13.7187 8.92232 13.7454 8.829C13.772 8.73568 13.6565 8.86461 13.6476 8.89567Z",
    fill: "url(#paint186_linear_9_3255)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5144 8.97112C13.568 8.96856 13.6388 8.99777 13.6388 8.99777C13.6432 8.96664 13.5943 8.89557 13.5499 8.91781C13.5055 8.94006 13.4344 8.95783 13.4344 8.95783C13.4344 8.95783 13.3988 8.89116 13.3544 8.96231C13.3263 9.00737 13.4215 8.97553 13.5144 8.97112Z",
    fill: "url(#paint187_linear_9_3255)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6496 10.1604L13.2715 8.80981C13.2715 8.80981 13.2005 9.56214 12.6496 10.1604Z",
    fill: "url(#paint188_linear_9_3255)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94949 14.9258L7.17679 15.3523L7.11544 15.1634L3.94949 14.9258Z",
    fill: "url(#paint189_linear_9_3255)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31653 14.3949C1.31653 14.3949 3.60263 14.8851 3.64052 14.8344C3.6784 14.7837 1.4921 14.2064 1.4921 14.2064C1.4921 14.2064 1.46438 14.1089 1.56211 14.1079C1.65978 14.1067 4.02037 14.9012 4.05826 14.8534C4.09615 14.8057 1.74742 13.9814 1.74742 13.9814C1.74742 13.9814 1.79064 13.8743 2.06693 13.9513C2.34329 14.0282 4.29795 14.8212 4.32396 14.7616C4.34991 14.7021 2.40478 13.9653 2.40321 13.8231C2.40172 13.681 4.69557 14.8819 4.72464 14.8372C4.75372 14.7925 3.19463 13.8767 3.22981 13.8407C3.26493 13.8048 5.09881 14.9249 5.11616 14.8862C5.1335 14.8475 3.77287 13.9325 3.77152 13.817C3.77024 13.7015 5.21169 14.9473 5.2677 14.929C5.32371 14.9107 4.33391 14.0507 4.38552 13.8902C4.42127 13.7789 5.52523 14.9173 5.68559 14.9511C5.84587 14.9849 4.76395 13.9418 4.77966 13.9096C4.77966 13.9096 4.77532 13.7882 5.05361 14.0428C5.33189 14.2975 5.97076 15.0279 5.97076 15.0279C5.97076 15.0279 6.22992 15.1584 5.81552 14.6475C5.81552 14.6475 5.02524 13.892 5.33701 13.9597C5.33701 13.9597 6.19218 14.9632 6.24599 15.007C6.2998 15.0508 6.4325 14.9961 6.28004 14.8733C6.12764 14.7506 5.63967 14.0096 5.73733 14.0086C5.83507 14.0074 6.49498 15.0309 6.56628 15.0479C6.71711 15.0285 6.1936 14.2879 6.12053 14.1021C6.12053 14.1021 6.18187 14.0303 6.29973 14.2423C6.41758 14.4542 6.80689 15.1075 6.91287 15.053C7.01892 14.9984 6.37201 14.3481 6.50337 14.1778C6.50337 14.1778 6.57388 14.1237 6.61987 14.2653C6.66586 14.407 6.99333 15.0964 7.0733 15.0956C7.15326 15.0947 6.90882 14.6797 6.79814 14.3167C6.79814 14.3167 6.77 14.1748 6.87712 14.2269C6.98423 14.279 7.08766 14.7844 7.08766 14.7844C7.08766 14.7844 7.18866 14.2768 7.14267 14.1352C7.09668 13.9935 3.21752 13.5386 2.04724 13.7826C2.04724 13.7827 1.35548 13.8969 1.31653 14.3949V14.3949Z",
    fill: "url(#paint190_linear_9_3255)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31653 14.395C1.31653 14.395 3.61906 14.9028 3.57513 14.9522C3.5312 15.0015 1.761 14.8167 1.761 14.8167C1.761 14.8167 1.67982 14.8443 1.75723 14.8789C1.80265 14.8993 2.6176 14.9674 3.28697 15.0043C3.75702 15.0301 4.15799 15.0235 4.15828 15.048C4.15828 15.048 4.38424 15.1284 3.15376 15.2782C3.15376 15.2782 2.69109 15.2241 2.77497 15.3061C2.85885 15.388 4.66196 15.0661 4.5918 15.1498C4.52171 15.2336 3.32869 15.5546 3.42998 15.6129C3.53127 15.6711 4.92311 15.1048 4.95972 15.1992C4.99632 15.2935 3.92264 15.7082 3.85242 15.78C3.85242 15.78 5.26764 15.1957 5.30389 15.2545C5.34007 15.3135 4.03126 15.8729 4.23284 15.8943C4.4345 15.9158 5.59923 15.1685 5.68368 15.3096C5.76812 15.4509 4.38844 16.0347 4.76773 16.0543C5.05191 16.0393 5.80217 15.3083 5.9685 15.3538C5.9685 15.3538 6.08649 15.317 5.98122 15.4367C5.87595 15.5564 4.98175 16.1229 5.12434 16.157C5.26686 16.191 6.27663 15.3741 6.37203 15.4205C6.46735 15.4669 6.01982 15.7088 6.15068 15.7547C6.28147 15.8007 6.52556 15.3714 6.64491 15.4531C6.76425 15.5347 6.7769 15.6056 6.742 15.6653C6.70717 15.7249 7.0237 15.4252 7.06037 15.5314C7.09705 15.6376 6.91565 16.3742 6.66715 16.4007C6.41851 16.427 1.76477 16.0932 1.31653 14.395V14.395Z",
    fill: "url(#paint191_linear_9_3255)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14899 10.2057C1.14899 10.2057 1.55216 9.15868 2.5829 9.15918L2.95757 9.83032C2.95757 9.83032 2.2592 9.88541 1.81644 10.5656L1.14899 10.2057Z",
    fill: "url(#paint192_linear_9_3255)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49466 13.687L2.78314 13.6326C2.78314 13.6326 0.250739 12.0166 0.230481 10.9861C0.230481 10.9861 0.156912 10.7559 0.413372 10.6465C0.413372 10.6465 2.07894 11.8099 2.03501 11.8637C1.99123 11.9175 0.345348 10.9316 0.354588 10.9671C0.3639 11.0025 1.99115 11.9175 1.9559 11.9446C1.92064 11.9716 0.446567 11.2503 0.483742 11.401C0.520917 11.5517 2.32161 12.0739 2.25977 12.1101C2.198 12.1464 0.851799 11.7435 0.879947 11.8765C0.908095 12.0095 2.73338 12.3538 2.6896 12.4076C2.64574 12.4614 1.10527 12.1673 1.25767 12.2901C1.41014 12.4128 3.05467 12.4836 3.04628 12.5281C3.03789 12.5726 1.59929 12.6507 1.59929 12.6507C1.59929 12.6507 3.60853 12.744 3.52053 12.825C3.43253 12.9059 1.80713 12.9594 2.04752 13.0101C2.28792 13.0607 3.95739 12.9624 3.8512 12.9991C3.74493 13.0359 2.21918 13.2659 2.46789 13.2631C2.71668 13.2604 4.1722 13.1022 4.11953 13.1649C4.06693 13.2278 2.87881 13.4629 3.04813 13.5056C3.21744 13.5481 4.5114 13.2406 4.50308 13.294C4.49477 13.3474 3.53013 13.6956 3.68096 13.6762C3.83179 13.6569 4.73431 13.3092 4.70915 13.4428C4.68398 13.5764 4.26681 13.6253 4.30299 13.6783C4.3391 13.7312 4.86908 13.441 4.84299 13.4946C4.81697 13.5482 4.62349 13.7369 4.62349 13.7369L3.49466 13.687Z",
    fill: "url(#paint193_linear_9_3255)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0.483589 10.5744C0.483589 10.5744 2.0345 11.8191 2.07872 11.8008C2.12293 11.7825 1.53985 11.2825 1.36926 11.1155C1.19859 10.9485 0.73159 10.5005 0.892233 10.5609C1.0528 10.6214 2.18633 11.8884 2.27518 11.8874C2.39893 11.886 1.21295 10.6373 1.30187 10.6452C1.39087 10.6531 2.3823 11.9307 2.44372 11.8589C2.50506 11.7871 1.49592 10.5187 1.73788 10.7026C1.97977 10.8866 2.61424 12.0169 2.69378 11.9806C2.77339 11.9441 2.01524 10.8773 2.09535 10.8942C2.17553 10.9111 2.89977 12.1293 2.99857 12.2259C3.09745 12.3226 3.01457 12.057 2.96922 11.9775C2.92387 11.898 2.36283 10.9712 2.49688 11.0497C2.63108 11.1282 3.12296 12.2246 3.25738 12.3297C3.39186 12.4348 2.83686 11.2592 2.88079 11.2143C2.92472 11.1695 3.40068 12.4348 3.47197 12.4518C3.54319 12.4687 3.06909 11.3722 3.20215 11.3529C3.33521 11.3336 3.60539 12.468 3.71223 12.4847C3.81906 12.5013 3.58499 11.4199 3.67455 11.4811C3.74371 11.5283 3.87457 12.7051 3.96343 12.7041C4.05228 12.7031 3.84635 11.7547 3.98752 11.6642C3.98752 11.6642 4.13395 12.8533 4.20425 12.7814C4.27447 12.7095 4.21086 11.7684 4.28364 11.9275C4.35643 12.0866 4.33063 12.9666 4.4622 12.8052C4.5937 12.6438 4.57863 12.0842 4.57863 12.0842C4.57863 12.0842 4.24974 11.7811 3.64726 11.428C2.64324 10.8396 1.07612 10.129 0.447906 10.5746",
    fill: "url(#paint194_linear_9_3255)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01326 13.2503C6.01326 13.2503 5.50559 13.1404 5.37878 13.7283C5.37878 13.7283 5.56644 13.824 5.58321 13.735C5.59999 13.6459 5.56274 13.4864 5.66041 13.4852C5.75815 13.4842 5.66304 13.7251 5.77855 13.7239C5.89405 13.7226 5.85702 13.5897 5.95462 13.5709C6.05214 13.552 6.23006 13.5678 6.18442 13.4617C6.13879 13.3556 6.09337 13.2584 6.01326 13.2503V13.2503Z",
    fill: "url(#paint195_linear_9_3255)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15891 13.5598C6.13226 13.5602 5.99919 13.5794 5.99116 13.6594C5.9832 13.7394 5.86791 13.7586 5.89506 13.8115C5.92236 13.8645 5.98533 13.9349 6.03765 13.8456C6.08996 13.7562 6.08094 13.7473 6.12515 13.7291C6.16943 13.7108 6.2747 13.5941 6.18585 13.5951",
    fill: "url(#paint196_linear_9_3255)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83237 13.7677C5.83813 13.8049 5.78887 13.8481 5.7089 13.8491C5.62893 13.85 5.61976 13.8234 5.66369 13.7785C5.70762 13.7336 5.82285 13.7056 5.83237 13.7677Z",
    fill: "url(#paint197_linear_9_3255)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24805 13.5854C6.28366 13.594 6.5505 13.6176 6.46229 13.672C6.374 13.7263 6.37365 13.6907 6.27641 13.7362C6.17917 13.7817 6.13574 13.871 6.12642 13.8356C6.11718 13.8001 6.17853 13.7283 6.21393 13.7102C6.24925 13.6921 6.24805 13.5854 6.24805 13.5854V13.5854Z",
    fill: "url(#paint198_linear_9_3255)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36285 13.5221L6.22928 13.497L6.25487 13.3989L6.36285 13.5221Z",
    fill: "url(#paint199_linear_9_3255)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41136 13.4615C5.41136 13.4615 5.3685 13.6041 5.28874 13.6227C5.20899 13.6414 5.11168 13.678 5.15497 13.5798C5.19826 13.4816 5.21574 13.4547 5.17132 13.4552C5.12689 13.4557 5.09178 13.4917 5.0025 13.4571C4.91329 13.4225 4.82373 13.3612 4.87697 13.3519C4.93014 13.3423 4.94819 13.3688 5.00101 13.3238C5.05382 13.2787 5.10507 13.0915 5.11509 13.1981C5.12519 13.3046 5.05432 13.3231 5.12583 13.3668C5.19733 13.4104 5.16208 13.4285 5.22427 13.4278C5.28647 13.4272 5.46375 13.3897 5.4378 13.4522",
    fill: "url(#paint200_linear_9_3255)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44578 13.3543C5.44578 13.3543 5.33951 13.3822 5.30376 13.3647C5.268 13.3473 5.19706 13.3571 5.20552 13.3214C5.21398 13.2858 5.21433 13.3124 5.19543 13.2149C5.17659 13.1174 5.15001 13.1266 5.22969 13.099C5.30937 13.0715 5.32728 13.089 5.3796 12.9997C5.43192 12.9102 5.33333 12.8314 5.29821 12.8761C5.26324 12.921 5.33489 12.9735 5.26402 12.9921C5.19315 13.0106 5.17595 13.0641 5.16628 12.9931C5.15662 12.9222 5.12086 12.9048 5.15619 12.8867C5.19152 12.8685 5.25414 12.9033 5.19969 12.8062C5.14532 12.709 5.12591 12.5582 5.09144 12.6564C5.05703 12.7544 5.11958 12.7893 5.07601 12.8698C5.03251 12.9502 4.92567 12.9336 4.97053 12.9687C5.01531 13.0037 5.13017 12.9403 5.07814 13.0563C5.02611 13.1725 4.99149 13.2617 4.92873 13.209C4.86596 13.1563 4.79524 13.1927 4.84734 13.0855C4.89944 12.9784 4.74015 13.0334 4.88054 12.8719C5.02099 12.7104 5.05724 12.7811 4.99377 12.6574C4.93015 12.5337 4.91167 12.4628 4.98289 12.4798C5.05419 12.4968 5.01026 12.5417 5.13543 12.6114C5.26068 12.6811 5.34932 12.6624 5.38536 12.7064C5.4214 12.7505 5.50236 12.8473 5.56512 12.8999C5.62796 12.9525 5.62775 12.9348 5.60137 12.9617C5.57507 12.9887 5.55745 13.0066 5.67317 13.0231C5.78889 13.0396 5.83516 13.2079 5.76415 13.2176C5.69321 13.2273 5.61303 13.2104 5.58666 13.2373C5.56029 13.2642 5.57749 13.2107 5.5406 13.0867C5.50371 12.9628 5.47648 12.9098 5.45935 12.9722C5.44222 13.0346 5.45168 13.0789 5.46994 13.132C5.48835 13.185 5.56072 13.2997 5.44578 13.3543V13.3543Z",
    fill: "url(#paint201_linear_9_3255)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73197 13.0867C4.74824 13.1079 4.90035 12.2408 4.66778 12.0923C4.64113 12.0926 4.56976 12.8753 4.73197 13.0867Z",
    fill: "url(#paint202_linear_9_3255)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8135 13.228C4.8135 13.228 2.24833 11.8701 2.15109 11.9157C2.15109 11.9157 2.92083 12.4225 3.18902 12.5618C3.45706 12.701 4.72636 13.3801 4.72636 13.3801C4.72636 13.3801 4.91344 13.4225 4.8135 13.228V13.228Z",
    fill: "url(#paint203_linear_9_3255)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29023 13.756C5.29023 13.756 5.2984 13.6937 5.21005 13.7392C5.12169 13.7846 5.0858 13.7495 5.07627 13.6962C5.06682 13.6431 4.97754 13.6085 4.93354 13.6445C4.88954 13.6804 4.95764 13.4132 4.92295 13.4846C4.88819 13.5561 4.72001 13.6113 4.8009 13.6993C4.88179 13.7873 5.32584 13.7646 5.32584 13.7646",
    fill: "url(#paint204_linear_9_3255)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92297 10.5677C1.94046 10.5408 2.1156 10.3079 2.2132 10.289C2.31072 10.2701 2.33695 10.2343 2.35543 10.2964C2.37391 10.3584 2.25897 10.4129 2.40995 10.4024C2.56086 10.3918 2.62227 10.32 2.63243 10.4355C2.6426 10.5508 2.75782 10.5229 2.6426 10.5508C2.52745 10.5788 2.5455 10.6053 2.49148 10.5436C2.43746 10.482 2.4816 10.4549 2.36588 10.4384C2.25023 10.422 2.32046 10.35 2.22322 10.3955C2.12605 10.441 2.05497 10.4417 2.10878 10.4857C2.16259 10.5296 2.13572 10.512 2.22493 10.5466C2.3142 10.5811 2.20637 10.4757 2.25194 10.5729C2.29743 10.6701 2.19095 10.6802 2.29743 10.6701C2.40398 10.66 2.41244 10.6244 2.43113 10.7042C2.44976 10.7839 2.36055 10.7494 2.48494 10.748C2.60926 10.7466 2.69797 10.7279 2.66343 10.8171C2.62874 10.9064 1.92297 10.5677 1.92297 10.5677V10.5677Z",
    fill: "url(#paint205_linear_9_3255)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33689 10.2255C2.30135 10.2258 2.17782 10.3071 2.20362 10.2269C2.22935 10.1467 2.31806 10.1367 2.41565 10.118C2.51318 10.0991 2.52121 10.0279 2.61006 10.027C2.69891 10.0261 2.74262 9.9633 2.82302 9.99799C2.90334 10.0327 3.08033 9.96849 3.046 10.0755C3.01166 10.1826 2.98558 10.2362 2.94094 10.2189C2.8963 10.2016 2.72748 10.2035 2.73701 10.2567C2.74646 10.3099 2.75528 10.3009 2.67524 10.2929C2.59513 10.2849 2.53365 10.3477 2.54147 10.25C2.54921 10.1522 2.55817 10.1609 2.58454 10.134C2.61091 10.107 2.46079 10.1887 2.46079 10.1887C2.46079 10.1887 2.4256 10.2247 2.46136 10.242C2.47699 10.2495 2.49455 10.2726 2.52199 10.2957C2.55717 10.3256 2.60871 10.356 2.69365 10.355C2.8447 10.3533 2.871 10.3175 2.92431 10.3169C2.97755 10.3163 3.17152 10.172 3.20827 10.2871C3.24509 10.4022 3.25362 10.3665 3.33366 10.3746C3.4137 10.3825 3.51954 10.3103 3.46722 10.3997C3.41491 10.4892 3.35399 10.6055 3.24673 10.5533C3.13954 10.5012 3.19093 10.3228 3.06711 10.3775C2.94336 10.4322 2.99603 10.3783 2.95302 10.5032C2.91002 10.6281 2.84903 10.7443 2.80347 10.6381C2.75791 10.5319 2.74795 10.4344 2.74795 10.4344C2.74795 10.4344 2.65854 10.382 2.45354 10.3309C2.39013 10.3151 2.37258 10.2311 2.36362 10.2342",
    fill: "url(#paint206_linear_9_3255)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44399 10.7017C3.44399 10.7017 3.29152 10.579 3.24816 10.6683C3.20473 10.7576 3.25804 10.757 3.22349 10.8552C3.18909 10.9533 3.08268 10.9722 3.09036 10.8656C3.09803 10.7588 3.24823 10.6772 3.13265 10.6696C3.017 10.662 2.89183 10.5923 2.91073 10.6898C2.92957 10.7873 2.95566 10.7337 2.88486 10.7612C2.81406 10.7886 2.74234 10.7272 2.81406 10.7886C2.88586 10.85 2.97364 10.7514 2.97478 10.858C2.97599 10.9646 2.88699 10.9478 2.97627 10.9912C3.06555 11.0347 2.88003 11.1256 3.10123 11.0431C3.32244 10.9607 3.31384 10.9875 3.38421 10.9245C3.45458 10.8615 3.41826 10.782 3.46311 10.8259C3.50803 10.8698 3.5698 10.8336 3.49971 10.9232C3.42963 11.0129 3.37603 10.9868 3.33239 11.0583C3.28874 11.1299 3.1994 11.0864 3.32414 11.1206C3.44896 11.1547 3.32514 11.2095 3.44896 11.1547C3.57271 11.1 3.52829 11.1005 3.57271 11.1C3.61714 11.0995 3.60826 11.0996 3.63527 11.1259C3.66221 11.1523 3.5998 11.1353 3.66221 11.1523C3.72454 11.1694 3.74367 11.2935 3.76023 11.1779C3.77672 11.0622 3.73116 10.9561 3.6423 10.9571C3.55345 10.9581 3.48329 11.0388 3.52658 10.9406C3.56987 10.8425 3.56831 10.6915 3.44399 10.7017V10.7017Z",
    fill: "url(#paint207_linear_9_3255)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90365 11.292C3.90365 11.292 3.84017 11.1773 3.76966 11.2313C3.69922 11.2854 3.62806 11.2773 3.58321 11.2423C3.53836 11.2072 3.4134 11.1553 3.5122 11.252C3.61108 11.3486 3.50488 11.3942 3.66467 11.3747C3.82446 11.3552 3.81458 11.2753 3.86903 11.3725C3.92341 11.4696 3.9947 11.4866 3.96826 11.5135C3.94196 11.5405 3.81572 11.373 3.79894 11.471L4.5062 11.9519C4.5062 11.9518 3.87265 10.9015 3.90365 11.292V11.292Z",
    fill: "url(#paint208_linear_9_3255)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64797 9.25854C1.64797 9.25854 1.79461 8.59941 1.87351 8.75849C1.95227 8.91749 1.6673 9.39459 1.81458 9.32194C1.96179 9.24923 2.29808 9.12114 2.29808 9.12114C2.29808 9.12114 1.24771 7.33772 0.746523 7.55061C0.746523 7.55061 0.0491488 7.69447 0.278314 8.59834C0.278314 8.59834 0.556169 10.1709 0.925789 10.3801C0.925789 10.3801 1.04414 10.367 0.996159 10.3201C0.948251 10.2732 0.858831 10.2149 0.846605 10.1854C0.834379 10.1559 0.7805 10.1091 0.893732 10.1671C1.00696 10.2252 1.13626 10.1289 1.05885 10.0942C0.981374 10.0595 0.594694 9.90395 0.718731 9.87296C0.842767 9.84197 1.21985 10.1874 1.17031 9.99238C1.12076 9.79747 0.561642 9.59632 0.655042 9.47086C0.748513 9.3454 1.21694 9.92677 1.2507 9.76044C1.28446 9.59418 0.39119 9.17153 0.430924 9.01715C0.470729 8.86269 1.32171 9.75369 1.27174 9.52324C1.22184 9.2928 0.298003 8.78173 0.342997 8.56202C0.387991 8.34231 0.979455 9.33097 1.05423 9.12882C1.12901 8.92666 0.288762 8.47381 0.432914 8.11684C0.455731 8.03957 0.980593 8.90456 0.972418 8.69735C0.972418 8.69735 0.412372 7.86237 0.612536 7.75354C0.671817 7.7588 0.983791 8.6439 0.993316 8.44239C0.993316 8.44239 0.80879 7.83422 0.903541 7.82733C0.998292 7.82043 1.01905 8.62578 1.09496 8.53017C1.1708 8.4345 1.07982 7.70094 1.16476 7.88362C1.2497 8.06637 1.20187 9.10365 1.28972 9.00784C1.37744 8.91202 1.34502 8.11861 1.44105 8.23014C1.53716 8.3416 1.35846 9.33886 1.4697 9.21909C1.58094 9.09939 1.63155 8.3229 1.63837 8.39981C1.80541 8.49861 1.47254 9.47377 1.63013 9.25882",
    fill: "url(#paint209_linear_9_3255)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60285 9.46628C1.60285 9.46628 1.10037 9.02173 1.05389 8.572C1.05389 8.572 0.999156 8.44817 0.988209 8.5253C0.977263 8.60242 1.01963 9.22396 1.46815 9.61001C1.46822 9.60993 1.5629 9.60887 1.60285 9.46628Z",
    fill: "url(#paint210_linear_9_3255)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96416 11.1404C3.96416 11.1404 3.68723 11.0102 3.704 10.9122C3.704 10.9122 3.72909 10.7698 3.68481 10.788C3.64053 10.8063 3.65858 10.8239 3.60413 10.7268C3.54976 10.6297 3.54052 10.6031 3.49581 10.568C3.45096 10.533 3.4946 10.4614 3.4946 10.4614L3.96416 11.1404Z",
    fill: "url(#paint211_linear_9_3255)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74269 10.763C2.74269 10.763 2.70708 10.7545 2.72393 10.6744C2.74077 10.5942 2.66031 10.5507 2.63479 10.6487C2.6092 10.7467 2.74269 10.763 2.74269 10.763Z",
    fill: "url(#paint212_linear_9_3255)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07087 14.074C7.07087 14.074 6.56918 13.7063 6.5072 13.7248C6.44521 13.7433 6.18896 13.8794 6.18896 13.8794L7.07087 14.074Z",
    fill: "url(#paint213_linear_9_3255)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0.779092 7.28359C0.779092 7.28359 1.37397 7.8339 1.30246 7.69252C1.30246 7.69252 0.802407 7.27748 0.830057 7.14683C0.857708 7.01611 1.42572 7.75628 1.48279 7.64902C1.53994 7.54176 0.7862 6.8748 0.849533 6.79114C0.912724 6.70748 1.35094 7.31878 1.40226 7.21748C1.45358 7.11619 0.881378 6.51229 0.891755 6.39372C0.902062 6.27523 1.41185 7.03374 1.39195 6.81474C1.37205 6.59581 0.854651 6.20458 0.981246 6.05509C1.03406 6.08416 1.30793 6.59652 1.30033 6.43666C1.30033 6.43666 1.04358 5.88258 1.16499 5.78655C1.20544 5.76238 1.27723 6.45457 1.38726 6.38832C1.38726 6.38832 1.28234 5.34101 1.45265 5.43981C1.53987 5.42105 1.46723 6.23934 1.54897 6.25618C1.54897 6.25618 1.66725 5.33667 1.68566 5.41948C1.70407 5.50229 1.52231 6.48158 1.64941 6.36764C1.64941 6.36764 1.92954 5.3339 1.89719 5.57117C1.86485 5.80851 1.59517 6.74743 1.71103 6.67506C1.71103 6.67506 2.01057 5.80098 1.98939 5.99666C1.96813 6.19242 1.54627 7.06189 1.65666 7.03111C1.76712 7.00019 1.9778 6.26336 2.01562 6.26883C2.05343 6.27431 1.6762 7.21457 1.74629 7.22559C1.81638 7.23661 2.13468 6.4867 2.10767 6.68843C2.08073 6.89008 1.69092 7.49264 1.78929 7.43236C1.88788 7.37202 2.19126 6.85931 2.16346 6.98988C2.13574 7.12053 1.71288 7.75593 1.90501 7.7243C2.09707 7.69259 2.17526 7.25637 2.21336 7.27662C2.25139 7.29688 1.92371 7.98772 1.98804 8.00478C2.05236 8.02184 2.25502 7.62272 2.29304 7.63409C2.331 7.64547 1.99116 8.28904 2.08947 8.21092C2.18784 8.1328 2.44338 7.78642 2.36931 7.94124C2.29532 8.09612 2.03303 8.37746 2.18436 8.35799C2.33569 8.33851 2.45603 8.14176 2.45603 8.14176L2.15643 6.87729L1.92854 5.4123C1.92854 5.4123 1.85305 5.33454 1.81296 5.33497C1.81303 5.33504 0.579924 5.08213 0.779092 7.28359V7.28359Z",
    fill: "url(#paint214_linear_9_3255)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09563 8.48644C2.09563 8.48644 1.46393 6.80517 1.45924 5.96997C1.45924 5.96997 1.3131 6.42034 1.67689 7.98013L2.10472 8.49973",
    fill: "url(#paint215_linear_9_3255)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61659 8.99599C2.59953 9.06281 2.58653 9.08961 2.55518 9.06778C2.5239 9.04589 2.54082 8.9746 2.4964 8.97069C2.4519 8.96671 2.50507 8.95285 2.43434 8.98469C2.36362 9.01654 2.33717 9.03914 2.35416 8.96785C2.37115 8.89655 2.32651 8.87928 2.402 8.86954C2.47742 8.85981 2.55724 8.84559 2.49469 8.81517C2.43214 8.78475 2.445 8.74018 2.40548 8.78503C2.36596 8.82995 2.37996 8.88753 2.33049 8.83471C2.28109 8.78197 2.2233 8.78702 2.30291 8.75063C2.38245 8.71416 2.41849 8.75816 2.38245 8.71416C2.34641 8.67016 2.22664 8.68481 2.32829 8.63924C2.43001 8.59361 2.4202 8.51379 2.44337 8.59795C2.46647 8.68218 2.4175 8.66931 2.48879 8.6863C2.56001 8.70329 2.54104 8.59247 2.58681 8.71189C2.63259 8.8313 2.607 8.9338 2.607 8.9338L2.61659 8.99599V8.99599Z",
    fill: "url(#paint216_linear_9_3255)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23739 8.85355C2.30449 8.84324 2.21514 8.84495 2.19673 8.79185C2.17839 8.73868 2.17839 8.74309 2.2005 8.72518C2.22253 8.70712 2.27165 8.73328 2.22225 8.68495C2.17285 8.63661 2.09757 8.65971 2.16823 8.62339C2.23895 8.58707 2.22601 8.62275 2.25658 8.57797C2.28714 8.53319 2.17597 8.52111 2.27797 8.5022C2.37998 8.48329 2.331 8.47498 2.37998 8.48329C2.42895 8.49168 2.43855 8.55373 2.46897 8.49118C2.49939 8.42863 2.50359 8.41086 2.48105 8.38001C2.45852 8.34916 2.45355 8.30474 2.43151 8.31839C2.4094 8.33189 2.38687 8.30111 2.36071 8.34134C2.33448 8.38158 2.36114 8.38136 2.28117 8.38222C2.20121 8.38307 2.1742 8.35229 2.18358 8.39657C2.19296 8.44093 2.16645 8.4501 2.16225 8.47682C2.15806 8.50348 2.21144 8.50739 2.15806 8.50348C2.10475 8.49964 2.08691 8.49545 2.06018 8.48685C2.03338 8.47824 2.02983 8.55828 1.97097 8.45671C1.91212 8.35513 1.78638 8.23657 1.78638 8.23657C1.78638 8.23657 2.14427 8.86798 2.23739 8.85355V8.85355Z",
    fill: "url(#paint217_linear_9_3255)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35957 9.05205C2.35957 9.05205 2.28877 9.07949 2.26104 8.9865C2.23332 8.89352 2.35033 9.02105 2.35957 9.05205Z",
    fill: "url(#paint218_linear_9_3255)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49363 9.12629C2.44003 9.1243 2.36959 9.15436 2.36959 9.15436C2.36483 9.12323 2.41281 9.05173 2.45752 9.07334C2.50216 9.09508 2.57345 9.11207 2.57345 9.11207C2.57345 9.11207 2.60828 9.04512 2.65349 9.11562C2.68214 9.16047 2.5866 9.1297 2.49363 9.12629Z",
    fill: "url(#paint219_linear_9_3255)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37142 10.3058L2.73468 8.96216C2.73468 8.96216 2.81401 9.71362 3.37142 10.3058Z",
    fill: "url(#paint220_linear_9_3255)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05889 14.5734L8.09443 14.5615C8.08278 14.5552 8.07162 14.5488 8.05996 14.5427L8.05889 14.5734V14.5734ZM14.006 3.75728L13.9819 3.76495C13.4038 3.57751 12.8663 3.25154 12.5725 2.93985C12.1647 2.50703 12.0572 2.09875 12.0572 2.09875C12.0572 2.09875 12.0569 2.09839 12.0568 2.09832C12.0757 2.09178 12.0868 2.08695 12.0868 2.08695L11.8749 1.88117L8.30398 0.761003C8.27342 0.7384 8.23603 0.724609 8.19516 0.724609C8.14007 0.724609 8.09109 0.749417 8.0574 0.787943C8.05292 0.777849 8.04916 0.772021 8.04916 0.772021L4.43747 1.90491L4.22557 2.11069C4.22557 2.11069 4.23666 2.11552 4.25557 2.12206C4.2555 2.12213 4.25521 2.12249 4.25521 2.12249C4.25521 2.12249 4.14774 2.53085 3.73988 2.96359C3.4461 3.27535 2.90859 3.60132 2.33048 3.78869C2.33048 3.78869 2.20631 4.01281 2.21725 4.01772C2.14582 4.43276 1.83683 6.63747 2.83452 9.08244C3.60688 10.9754 5.14863 12.9796 8.06003 14.5427L8.08264 13.8804C8.08264 13.8804 5.07357 12.6424 3.15438 8.85143C3.15438 8.85143 2.04488 5.38112 2.51224 4.14317C2.52155 4.14083 2.60109 3.90562 2.6023 3.88288C2.65589 3.8747 2.7134 3.85089 2.77147 3.8017C2.77147 3.8017 2.78547 3.72913 2.77936 3.69636C2.83246 3.74327 3.0484 3.86525 3.18907 3.65065L3.13576 3.47295C3.13576 3.47295 3.21203 3.56571 3.28979 3.57957C3.45108 3.60836 3.65728 3.53373 3.47339 3.24194C3.47339 3.24194 3.88801 3.49662 3.96208 3.09089L3.88211 3.00204C3.88211 3.00204 4.20496 3.07312 4.21384 2.85099C4.24597 2.76257 4.11618 2.71793 4.09095 2.71018C4.12791 2.72092 4.39517 2.78859 4.44486 2.50739C4.48018 2.4447 4.27014 2.41356 4.24022 2.41548C4.28564 2.40773 4.63678 2.3331 4.51416 2.15995C4.57607 2.15582 4.64047 2.14061 4.69954 2.10465C4.69954 2.10465 4.77951 1.9536 4.62846 1.90917C4.62846 1.90917 5.09937 2.06911 5.15268 1.94471C5.20599 1.82032 4.97498 1.76701 4.97498 1.76701C4.97498 1.76701 5.53474 1.8914 5.55251 1.81144C5.57028 1.73147 5.42812 1.6515 5.42812 1.6515C5.42812 1.6515 5.99677 1.81144 5.96123 1.58042C5.96215 1.57509 5.96123 1.57005 5.96009 1.56507C6.04197 1.60203 6.15115 1.62819 6.24555 1.57154C6.24555 1.57154 6.30064 1.48468 6.17298 1.39284C6.22735 1.42767 6.35807 1.50337 6.44102 1.48269C6.54764 1.45603 6.42325 1.31387 6.42325 1.31387C6.42325 1.31387 6.76089 1.48269 6.86751 1.37607C6.95878 1.2848 6.87447 1.22623 6.84824 1.21123C6.89679 1.2371 7.19903 1.38893 7.32953 1.2339C7.38284 1.20341 7.31894 1.15365 7.29954 1.14001C7.3279 1.15884 7.47084 1.24115 7.68494 1.15394C7.77379 1.08286 7.56055 1.03843 7.56055 1.03843C7.56055 1.03843 7.90707 1.10951 8.01369 0.994007C8.01817 0.989102 8.022 0.984197 8.02598 0.979293C8.05378 1.04533 8.1191 1.09174 8.19523 1.09174C8.26062 1.09174 8.3177 1.05734 8.35026 1.00588C8.48829 1.06885 8.75208 1.01476 8.75208 1.01476C8.75208 1.01476 8.53883 1.05919 8.62768 1.13027C8.84178 1.21748 8.98465 1.1351 9.01308 1.11634C8.99375 1.12998 8.92978 1.17981 8.98309 1.21023C9.11366 1.36526 9.4159 1.21336 9.46438 1.18756C9.43815 1.20256 9.35378 1.26113 9.44511 1.3524C9.55174 1.45902 9.88937 1.2902 9.88937 1.2902C9.88937 1.2902 9.76498 1.43236 9.8716 1.45902C9.95448 1.47977 10.0853 1.40407 10.1396 1.36917C10.012 1.46101 10.0671 1.54787 10.0671 1.54787C10.1615 1.60452 10.2706 1.57829 10.3525 1.5414C10.3514 1.54638 10.3505 1.55142 10.3514 1.55675C10.3159 1.78777 10.8845 1.62783 10.8845 1.62783C10.8845 1.62783 10.7423 1.7078 10.7601 1.78777C10.7779 1.86773 11.3376 1.74334 11.3376 1.74334C11.3376 1.74334 11.1066 1.79665 11.1599 1.92104C11.2133 2.04543 11.6842 1.8855 11.6842 1.8855C11.5331 1.92993 11.6131 2.08098 11.6131 2.08098C11.6721 2.11694 11.7365 2.13222 11.7985 2.13628C11.6758 2.30943 12.027 2.38406 12.0724 2.39181C12.0425 2.38996 11.8324 2.4211 11.8678 2.48372C11.9174 2.76484 12.1847 2.69725 12.2217 2.68651C12.1965 2.69426 12.0666 2.7389 12.0988 2.82732C12.1077 3.04945 12.4305 2.97837 12.4305 2.97837L12.3505 3.06722C12.4246 3.47295 12.8392 3.21827 12.8392 3.21827C12.6553 3.51006 12.8615 3.58469 13.0228 3.5559C13.1006 3.54204 13.1769 3.44928 13.1769 3.44928L13.1236 3.62698C13.2642 3.84158 13.4802 3.71953 13.5333 3.67269C13.5271 3.70546 13.5412 3.77803 13.5412 3.77803C13.5992 3.82715 13.6567 3.85096 13.7103 3.85921C13.7122 3.89574 13.7211 4.07266 13.723 4.13642C13.7348 4.53341 13.7461 5.95233 13.3901 7.44758C13.2059 8.22151 12.4333 10.0962 11.2221 11.4281C9.89584 12.8868 8.08271 13.8804 8.08271 13.8804L8.09458 14.5616C8.09458 14.5616 11.2857 12.4882 12.7148 9.8821C14.2468 7.08834 14.0063 3.76055 14.006 3.75728V3.75728Z",
    fill: "url(#paint221_linear_9_3255)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9054 4.60415C13.9054 4.60415 14.1008 10.9599 8.06765 14.1114C5.7153 12.9436 4.21855 11.2574 3.37937 9.60945C2.07305 7.04428 2.23 4.60415 2.23 4.60415C2.17576 4.58226 1.90118 7.09297 3.26095 9.75161C4.09757 11.3873 5.6111 13.0681 8.0019 14.2815C8.02394 14.2927 8.04547 14.304 8.06765 14.3151L8.13347 14.2815C14.006 11.0073 13.993 4.56882 13.9054 4.60415Z",
    fill: "#F39800"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06378 13.3056C7.06378 13.3056 8.98294 13.1042 8.98294 12.2275L9.08956 12.9739C9.08956 12.9739 8.73416 13.7202 7.77458 13.7202L7.06378 13.3056Z",
    fill: "url(#paint222_linear_9_3255)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21292 11.5879C8.21292 11.5879 9.52794 11.2207 9.95443 12.1329C9.95443 12.1329 9.69385 12.2869 9.45686 12.1092C9.21987 11.9315 8.99482 11.6116 8.21292 11.5879V11.5879Z",
    fill: "url(#paint223_linear_9_3255)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49723 12.0557C8.0962 11.9367 7.20591 12.0735 7.83376 11.4812C7.83376 11.4812 7.35994 11.8129 7.49023 12.2157L8.17737 12.6718C8.17737 12.6718 8.75192 12.4645 8.74005 12.346C8.7372 12.318 8.62219 12.0928 8.49723 12.0557V12.0557Z",
    fill: "url(#paint224_linear_9_3255)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77569 12.3166C8.84833 12.172 8.43806 11.9789 7.7613 11.9523C7.7613 11.9523 7.5214 11.9034 7.65908 11.6724C7.65908 11.6724 7.55246 11.899 8.04114 11.9079C8.04114 11.9079 8.91636 11.8589 8.98296 12.2277C8.98296 12.2277 9.07778 13.0215 7.06378 13.3058L6.78543 13.0866C6.78543 13.0866 8.6454 13.1162 8.77569 12.3166V12.3166Z",
    fill: "url(#paint225_linear_9_3255)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7613 11.9521C7.83828 11.9744 8.02636 12.003 8.1182 12.0143C8.89007 12.1097 8.65131 12.429 8.65131 12.429L8.63951 12.3342L8.5358 12.3639L8.54469 12.4616L8.39065 12.5416V12.4527L8.25439 12.4823L8.24259 12.6008L8.10036 12.6422L8.10633 12.5238L7.9523 12.5297L7.93751 12.6866L7.83978 12.6955L7.84567 12.5534L7.67387 12.5622V12.6985L7.45174 12.7163L7.45772 12.5504L7.28001 12.5563L7.2889 12.7015H7.14674L7.13486 12.5711H7.00457L6.9927 12.6896H6.83867V12.5475H6.68471L6.66097 12.737H6.45959L6.82979 13.0569C6.82979 13.0569 8.62167 13.1161 8.78451 12.3401C8.83192 11.964 7.7613 11.9521 7.7613 11.9521",
    fill: "url(#paint226_linear_9_3255)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35611 11.2443H9.4746L9.46871 11.3154H9.26136V11.4871L9.34431 11.5641V11.422H9.61087L9.56936 11.653L9.67008 11.7241L10.5408 11.3213L10.2506 10.8711L9.9603 11.1969L9.75303 11.2324L9.50425 11.1139L9.33244 11.1199L9.24949 11.2502H9.05402L9.08366 11.4338L9.35611 11.2443Z",
    fill: "url(#paint227_linear_9_3255)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98995 12.0913L9.7293 11.7596C9.7293 11.7596 10.3572 11.4931 10.4934 11.3923C10.4934 11.3923 10.7008 11.1732 10.7541 11.2087C10.8074 11.2443 11.0206 11.2324 11.0206 11.2324L11.0443 11.4931L9.14878 12.9858C9.14878 12.9858 9.48649 11.8839 8.31365 11.8721C8.31365 11.8721 7.32435 11.9195 7.95228 11.4753C7.95228 11.4753 8.05307 11.4752 7.95825 11.3272C7.95825 11.3272 8.15955 11.3924 8.0589 11.653C8.0589 11.653 7.97595 11.7596 8.28991 11.7655C8.28991 11.7655 9.68196 12.3698 9.96628 12.2749L9.67009 12.5296L9.58124 12.5888L9.44498 12.6599L9.38577 12.506L9.39167 12.7547C9.39167 12.7547 9.96621 12.3401 10.0195 12.2394L9.98995 12.0913V12.0913Z",
    fill: "url(#paint228_linear_9_3255)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0185 11.4693L8.99483 10.8178V10.2639H8.86063V10.4713H8.70248V10.2639H8.57041V10.4713H8.41225V10.2639H8.26234V10.4713H8.10419V10.2639H7.89805V10.4713H7.7399V10.2639H7.56717V10.874H7.57499L7.57314 10.877L7.60868 11.3271H7.79228L7.78638 10.9362C7.78638 10.9362 7.81304 10.9061 7.85249 10.874H8.14079C8.16567 10.9082 8.1892 10.9589 8.1892 11.031L8.1774 11.5522L9.0185 11.4693V11.4693Z",
    fill: "url(#paint229_linear_9_3255)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95677 11.339C7.95677 11.339 7.99231 11.4278 7.94789 11.4367C7.90346 11.4456 7.86792 11.4679 7.86792 11.4679C7.86792 11.4679 7.78796 11.3968 7.73906 11.4545C7.69015 11.5122 7.61019 11.6411 7.61019 11.6411C7.61019 11.6411 7.50357 11.6811 7.57906 11.5655C7.65454 11.4499 7.79684 11.3346 7.95677 11.339V11.339Z",
    fill: "url(#paint230_linear_9_3255)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55545 10.9777C7.55545 10.9777 7.01645 10.8651 6.75579 11.185C6.49514 11.5049 6.32333 11.801 6.28779 11.807C6.25225 11.8129 6.03318 11.8663 6.1516 11.9196C6.27002 11.9729 6.32333 12.0024 6.44183 11.9136C6.56032 11.8247 6.53658 11.6352 6.65507 11.6589C6.77356 11.6826 7.10523 12.0203 7.18818 12.0262C7.27113 12.0321 7.2771 11.9018 7.32444 11.9196C7.37178 11.9373 7.99381 11.2502 7.55545 10.9777V10.9777Z",
    fill: "url(#paint231_linear_9_3255)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63037 12.1862C5.63037 12.1862 6.48923 11.5464 6.66693 11.2147C6.66693 11.2147 6.68463 11.0193 6.5129 11.1377C6.34117 11.2561 6.54844 11.3095 6.29966 11.4398C6.05088 11.5701 5.74878 11.8307 5.87318 11.6826C5.99757 11.5346 6.3234 11.4338 6.23455 11.3569C6.1457 11.2799 6.13973 11.2621 6.04498 11.3746C5.95023 11.4871 5.61857 11.8841 5.55928 11.7241C5.5 11.5642 5.83166 11.5702 5.87318 11.4398C5.91469 11.3094 5.85541 11.3154 5.76066 11.3332C5.66591 11.351 5.55331 11.2148 5.53554 11.3687C5.51777 11.5227 5.67173 11.5879 5.48223 11.5997C5.29273 11.6115 5.25122 11.6471 5.29863 11.5523C5.34604 11.4576 4.961 11.499 4.961 11.499L5.63037 12.1862V12.1862Z",
    fill: "url(#paint232_linear_9_3255)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18011 11.3153C5.18011 11.3153 5.2276 11.4456 5.32825 11.3745C5.4289 11.3035 5.38746 11.2561 5.49408 11.2442C5.6007 11.2324 5.64214 11.2087 5.73099 11.2146C5.81984 11.2205 6.00344 11.268 5.94423 11.1732C5.88502 11.0783 5.87322 11.1021 5.86135 11.0547C5.84948 11.0073 5.64811 10.557 5.49408 10.6341C5.34005 10.7111 5.31048 10.8119 5.31048 10.8711C5.31048 10.9303 5.2276 10.9302 5.29271 10.9895C5.35782 11.0488 5.47631 11.1317 5.35192 11.0902C5.22753 11.0488 4.99061 10.8947 5.03205 11.0073C5.07349 11.1199 5.18011 11.3153 5.18011 11.3153V11.3153Z",
    fill: "url(#paint233_linear_9_3255)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63138 11.7538C6.63138 11.7538 6.55432 11.5051 6.69059 11.5643C6.82685 11.6235 7.1111 11.9434 7.18815 11.9611C7.26521 11.9789 7.22369 11.7183 7.28888 11.9019C7.35406 12.0855 7.31262 12.1684 7.37183 12.2691C7.43104 12.3699 7.60284 12.4943 7.49622 12.4943C7.3896 12.4943 7.38953 12.5297 7.24146 12.5179C7.0934 12.5061 7.08153 12.4765 7.08153 12.4409C7.08153 12.4054 7.05786 12.4528 7.16448 12.3284C7.27111 12.204 7.35399 12.0855 7.20592 12.1033C7.05786 12.1211 7.05779 12.1863 6.97491 12.0855C6.89203 11.9848 6.9334 11.8782 6.77944 11.9315C6.62548 11.9848 6.29964 11.9433 6.41813 12.0559C6.53663 12.1685 6.7439 12.0855 6.9157 12.1922C7.0875 12.2988 7.18225 12.3343 7.07563 12.3402C6.96901 12.3462 6.97491 12.2632 6.77354 12.2632C6.57217 12.2632 6.53655 12.1744 6.47734 12.2632C6.41813 12.3521 6.2405 12.3462 6.34115 12.3995C6.4418 12.4528 6.5544 12.3935 6.71433 12.4587C6.87426 12.5239 6.9334 12.5712 6.83865 12.5476C6.7439 12.5239 6.66699 12.4409 6.48332 12.4765C6.29964 12.512 6.25223 12.6719 6.13971 12.4824C6.02719 12.2929 5.95603 12.2573 6.0864 12.2099C6.21676 12.1625 6.31144 12.1329 6.17525 12.0855C6.03906 12.0381 5.81992 11.8368 6.02129 11.7242C6.22266 11.6116 6.42403 11.5701 6.63138 11.7538V11.7538Z",
    fill: "url(#paint234_linear_9_3255)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77459 11.3614C7.77459 11.3614 7.4725 11.6502 7.41471 11.6724C7.35692 11.6945 7.01047 11.5287 7.09335 11.505C7.17623 11.4814 7.22365 11.4577 7.29473 11.4814C7.36581 11.505 7.46056 11.5584 7.43689 11.4755C7.41322 11.3925 7.43689 11.3451 7.33027 11.3451C7.22365 11.3451 7.12889 11.2977 7.12889 11.3629C7.12889 11.4281 6.9986 11.4576 7.11112 11.5939C7.22365 11.7301 7.40128 11.8309 7.33617 11.8486C7.27106 11.8664 6.75572 11.5348 6.86234 11.4222C6.96896 11.3096 7.06371 11.1971 7.20588 11.1971C7.34804 11.1971 7.41322 11.2858 7.47243 11.203C7.53164 11.1201 7.41919 11.3599 7.77459 11.3614V11.3614Z",
    fill: "url(#paint235_linear_9_3255)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62107 4.06581L8.13242 3.74666L8.14429 3.2395L8.62107 4.06581Z",
    fill: "url(#paint236_linear_9_3255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_3255",
    x1: 4.83636,
    y1: 12.4038,
    x2: 11.0785,
    y2: 12.5285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_3255",
    x1: 7.82146,
    y1: 11.1482,
    x2: 8.13471,
    y2: 11.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_3255",
    x1: 8.08754,
    y1: 14.7419,
    x2: 8.09642,
    y2: 16.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_3255",
    x1: 8.07335,
    y1: 3.8472,
    x2: 8.21554,
    y2: 8.71708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_3255",
    x1: 6.5664,
    y1: 6.60344,
    x2: 4.30888,
    y2: 8.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_3255",
    x1: 9.15022,
    y1: 6.17509,
    x2: 7.3394,
    y2: 6.07518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_3255",
    x1: 9.14238,
    y1: 6.39942,
    x2: 7.33754,
    y2: 6.29982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_3255",
    x1: 9.2381,
    y1: 6.5238,
    x2: 7.26353,
    y2: 6.41487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_3255",
    x1: 9.31002,
    y1: 6.69656,
    x2: 7.20782,
    y2: 6.58058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9_3255",
    x1: 7.37617,
    y1: 7.62682,
    x2: 6.28934,
    y2: 8.44938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_3255",
    x1: 9.11469,
    y1: 8.12233,
    x2: 7.38076,
    y2: 8.02667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_3255",
    x1: 8.8226,
    y1: 8.23862,
    x2: 7.60892,
    y2: 8.17166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9_3255",
    x1: 8.62153,
    y1: 8.31872,
    x2: 7.75494,
    y2: 8.2709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9_3255",
    x1: 8.34537,
    y1: 8.58848,
    x2: 7.95357,
    y2: 8.56686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9_3255",
    x1: 8.48987,
    y1: 8.93778,
    x2: 7.83467,
    y2: 8.90162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9_3255",
    x1: 8.67636,
    y1: 9.07757,
    x2: 7.68845,
    y2: 9.02306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9_3255",
    x1: 9.03924,
    y1: 9.239,
    x2: 7.39512,
    y2: 9.14829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9_3255",
    x1: 8.42307,
    y1: 1.70708,
    x2: 7.85941,
    y2: 2.40335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9_3255",
    x1: 11.561,
    y1: 5.71911,
    x2: 11.4987,
    y2: 4.37687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9_3255",
    x1: 11.5219,
    y1: 5.08631,
    x2: 12.0665,
    y2: 4.32382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9_3255",
    x1: 11.5678,
    y1: 4.85635,
    x2: 11.9116,
    y2: 4.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9_3255",
    x1: 11.5087,
    y1: 4.95368,
    x2: 11.8801,
    y2: 4.43364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9_3255",
    x1: 11.4193,
    y1: 5.15288,
    x2: 11.8929,
    y2: 4.48982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9_3255",
    x1: 11.2802,
    y1: 5.86066,
    x2: 11.734,
    y2: 5.22523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9_3255",
    x1: 11.1563,
    y1: 5.63227,
    x2: 11.3835,
    y2: 5.31411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9_3255",
    x1: 11.1159,
    y1: 5.97384,
    x2: 11.3561,
    y2: 5.63752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9_3255",
    x1: 11.3066,
    y1: 6.02155,
    x2: 11.5262,
    y2: 5.71409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9_3255",
    x1: 11.5341,
    y1: 6.16378,
    x2: 11.7393,
    y2: 5.87644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9_3255",
    x1: 11.0391,
    y1: 6.10569,
    x2: 11.1479,
    y2: 5.95343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9_3255",
    x1: 11.1135,
    y1: 6.34943,
    x2: 11.4007,
    y2: 5.94741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9_3255",
    x1: 11.4617,
    y1: 6.31346,
    x2: 11.6834,
    y2: 6.00295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9_3255",
    x1: 11.264,
    y1: 6.3525,
    x2: 11.5262,
    y2: 5.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9_3255",
    x1: 11.651,
    y1: 6.39647,
    x2: 11.9324,
    y2: 6.00244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9_3255",
    x1: 10.9765,
    y1: 6.45774,
    x2: 11.2102,
    y2: 6.13052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9_3255",
    x1: 11.7643,
    y1: 6.39207,
    x2: 11.8549,
    y2: 6.26516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9_3255",
    x1: 11.4583,
    y1: 6.3857,
    x2: 11.5326,
    y2: 6.28164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9_3255",
    x1: 11.284,
    y1: 7.00402,
    x2: 11.784,
    y2: 6.30412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_9_3255",
    x1: 11.1908,
    y1: 7.05855,
    x2: 11.7095,
    y2: 6.33232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9_3255",
    x1: 11.0744,
    y1: 6.76218,
    x2: 11.3762,
    y2: 6.33954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9_3255",
    x1: 10.8255,
    y1: 6.77033,
    x2: 11.119,
    y2: 6.35945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9_3255",
    x1: 11.205,
    y1: 7.27268,
    x2: 11.9137,
    y2: 6.28053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9_3255",
    x1: 10.9756,
    y1: 7.34533,
    x2: 11.706,
    y2: 6.32277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9_3255",
    x1: 11.127,
    y1: 7.53979,
    x2: 12.0353,
    y2: 6.26815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9_3255",
    x1: 11.4187,
    y1: 7.23243,
    x2: 10.784,
    y2: 7.19742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9_3255",
    x1: 10.9445,
    y1: 6.98543,
    x2: 11.2059,
    y2: 6.61958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9_3255",
    x1: 9.18229,
    y1: 6.73913,
    x2: 9.17127,
    y2: 6.86012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9_3255",
    x1: 9.08879,
    y1: 6.74383,
    x2: 9.07801,
    y2: 6.86206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9_3255",
    x1: 8.50114,
    y1: 6.74348,
    x2: 8.4903,
    y2: 6.86246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9_3255",
    x1: 8.24373,
    y1: 6.74383,
    x2: 8.23186,
    y2: 6.87411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9_3255",
    x1: 8.94554,
    y1: 6.74567,
    x2: 8.93434,
    y2: 6.86876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9_3255",
    x1: 8.8587,
    y1: 6.74793,
    x2: 8.84867,
    y2: 6.85806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9_3255",
    x1: 8.70837,
    y1: 6.74684,
    x2: 8.69704,
    y2: 6.87131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_9_3255",
    x1: 8.42501,
    y1: 6.74597,
    x2: 8.41385,
    y2: 6.86867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9_3255",
    x1: 8.61509,
    y1: 6.74976,
    x2: 8.60408,
    y2: 6.87066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9_3255",
    x1: 8.86814,
    y1: 6.80133,
    x2: 8.98326,
    y2: 7.41543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9_3255",
    x1: 8.11968,
    y1: 7.34573,
    x2: 8.13155,
    y2: 6.83635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9_3255",
    x1: 10.4029,
    y1: 7.43312,
    x2: 10.6727,
    y2: 7.05551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9_3255",
    x1: 8.13682,
    y1: 7.109,
    x2: 8.11255,
    y2: 7.37549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9_3255",
    x1: 8.70404,
    y1: 7.12515,
    x2: 8.68361,
    y2: 7.34965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9_3255",
    x1: 9.16509,
    y1: 7.12926,
    x2: 9.14421,
    y2: 7.35855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9_3255",
    x1: 9.75868,
    y1: 7.26269,
    x2: 9.75009,
    y2: 7.35706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9_3255",
    x1: 9.66024,
    y1: 7.26354,
    x2: 9.65237,
    y2: 7.34985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9_3255",
    x1: 9.55502,
    y1: 7.26273,
    x2: 9.54645,
    y2: 7.35696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9_3255",
    x1: 9.45177,
    y1: 7.26253,
    x2: 9.44279,
    y2: 7.36115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9_3255",
    x1: 8.42245,
    y1: 7.26712,
    x2: 8.41412,
    y2: 7.35867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_9_3255",
    x1: 9.3535,
    y1: 7.27172,
    x2: 9.3466,
    y2: 7.34749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_9_3255",
    x1: 8.50684,
    y1: 7.27132,
    x2: 8.49977,
    y2: 7.34889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_9_3255",
    x1: 8.3356,
    y1: 7.27125,
    x2: 8.32855,
    y2: 7.34869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_9_3255",
    x1: 8.13041,
    y1: 7.27418,
    x2: 8.11636,
    y2: 7.42847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_9_3255",
    x1: 8.69231,
    y1: 7.2918,
    x2: 8.68237,
    y2: 7.40091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_9_3255",
    x1: 9.14023,
    y1: 7.27852,
    x2: 9.15809,
    y2: 7.37376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_9_3255",
    x1: 10.2061,
    y1: 7.66,
    x2: 10.4756,
    y2: 7.28278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_9_3255",
    x1: 10.3575,
    y1: 7.77468,
    x2: 10.5961,
    y2: 7.44065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_9_3255",
    x1: 10.0042,
    y1: 7.99375,
    x2: 10.3381,
    y2: 7.52625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_9_3255",
    x1: 9.83452,
    y1: 7.97403,
    x2: 10.0904,
    y2: 7.61576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_9_3255",
    x1: 4.928,
    y1: 3.19393,
    x2: 4.9134,
    y2: 3.20499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_9_3255",
    x1: 4.86686,
    y1: 3.28172,
    x2: 4.84683,
    y2: 3.29688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_9_3255",
    x1: 3.86776,
    y1: 4.62394,
    x2: 4.93801,
    y2: 5.33753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_9_3255",
    x1: 4.19558,
    y1: 4.54446,
    x2: 4.68318,
    y2: 4.86957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_9_3255",
    x1: 4.36874,
    y1: 4.52968,
    x2: 4.63824,
    y2: 4.70938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_9_3255",
    x1: 4.41178,
    y1: 4.60782,
    x2: 4.68096,
    y2: 4.78727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_9_3255",
    x1: 4.41656,
    y1: 4.71015,
    x2: 4.77094,
    y2: 4.94643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_9_3255",
    x1: 4.69078,
    y1: 4.65358,
    x2: 4.94945,
    y2: 4.82606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_9_3255",
    x1: 4.44259,
    y1: 5.31683,
    x2: 4.90362,
    y2: 5.62423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_9_3255",
    x1: 4.86114,
    y1: 5.39928,
    x2: 5.11035,
    y2: 5.56544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_9_3255",
    x1: 4.88347,
    y1: 5.70032,
    x2: 5.15964,
    y2: 5.88446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_9_3255",
    x1: 4.70304,
    y1: 5.77274,
    x2: 4.95127,
    y2: 5.93823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_9_3255",
    x1: 4.51625,
    y1: 5.95675,
    x2: 4.70582,
    y2: 6.08314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_9_3255",
    x1: 5.09067,
    y1: 5.98633,
    x2: 5.21286,
    y2: 6.06778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_9_3255",
    x1: 4.82707,
    y1: 6.05434,
    x2: 5.11768,
    y2: 6.2481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_9_3255",
    x1: 4.56935,
    y1: 6.34372,
    x2: 4.83611,
    y2: 5.97025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_9_3255",
    x1: 4.7741,
    y1: 6.30585,
    x2: 4.96273,
    y2: 6.04178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_9_3255",
    x1: 4.25461,
    y1: 6.07866,
    x2: 4.61715,
    y2: 6.32037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_9_3255",
    x1: 5.14595,
    y1: 6.07967,
    x2: 5.17425,
    y2: 6.45717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_9_3255",
    x1: 4.37179,
    y1: 6.28969,
    x2: 4.49218,
    y2: 6.36996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_9_3255",
    x1: 4.70283,
    y1: 6.30281,
    x2: 4.79448,
    y2: 6.36392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_9_3255",
    x1: 4.38628,
    y1: 6.44817,
    x2: 4.98002,
    y2: 6.84406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_9_3255",
    x1: 4.78939,
    y1: 6.26985,
    x2: 4.85293,
    y2: 7.11704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_9_3255",
    x1: 5.03855,
    y1: 6.34646,
    x2: 5.06721,
    y2: 6.72864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_9_3255",
    x1: 5.26381,
    y1: 6.34629,
    x2: 5.29726,
    y2: 6.79243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_9_3255",
    x1: 4.22223,
    y1: 6.46948,
    x2: 5.09575,
    y2: 7.05188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_9_3255",
    x1: 4.91369,
    y1: 6.21647,
    x2: 5.00541,
    y2: 7.4394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_9_3255",
    x1: 4.06989,
    y1: 6.49825,
    x2: 5.20425,
    y2: 7.25458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_9_3255",
    x1: 4.92277,
    y1: 6.98562,
    x2: 5.42616,
    y2: 7.32127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_9_3255",
    x1: 5.16177,
    y1: 6.62939,
    x2: 5.19097,
    y2: 7.01871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_9_3255",
    x1: 7.07263,
    y1: 6.73921,
    x2: 7.06162,
    y2: 6.86019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_9_3255",
    x1: 7.1659,
    y1: 6.74404,
    x2: 7.1552,
    y2: 6.86166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_9_3255",
    x1: 7.75369,
    y1: 6.74337,
    x2: 7.74283,
    y2: 6.86257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_9_3255",
    x1: 8.01164,
    y1: 6.74469,
    x2: 8.00005,
    y2: 6.8719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_9_3255",
    x1: 7.30957,
    y1: 6.74574,
    x2: 7.29841,
    y2: 6.86828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_9_3255",
    x1: 7.39569,
    y1: 6.74817,
    x2: 7.38575,
    y2: 6.85735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_9_3255",
    x1: 7.54621,
    y1: 6.74729,
    x2: 7.53503,
    y2: 6.87011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_9_3255",
    x1: 7.83001,
    y1: 6.74597,
    x2: 7.81884,
    y2: 6.86859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_9_3255",
    x1: 7.62772,
    y1: 6.74129,
    x2: 7.64366,
    y2: 6.82628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_9_3255",
    x1: 7.28659,
    y1: 6.81102,
    x2: 7.39904,
    y2: 7.41087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_9_3255",
    x1: 5.6337,
    y1: 7.36651,
    x2: 5.79232,
    y2: 7.14442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_9_3255",
    x1: 7.56558,
    y1: 7.12813,
    x2: 7.54563,
    y2: 7.34728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_9_3255",
    x1: 7.06974,
    y1: 7.1126,
    x2: 7.10135,
    y2: 7.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_9_3255",
    x1: 6.48539,
    y1: 7.25526,
    x2: 6.49807,
    y2: 7.32291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_9_3255",
    x1: 6.58394,
    y1: 7.2565,
    x2: 6.59568,
    y2: 7.31903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_9_3255",
    x1: 6.6889,
    y1: 7.25554,
    x2: 6.70154,
    y2: 7.32299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_9_3255",
    x1: 6.79188,
    y1: 7.25479,
    x2: 6.80518,
    y2: 7.32574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_9_3255",
    x1: 7.82171,
    y1: 7.26026,
    x2: 7.83393,
    y2: 7.32547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_9_3255",
    x1: 6.89111,
    y1: 7.26572,
    x2: 6.9013,
    y2: 7.32008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_9_3255",
    x1: 7.73772,
    y1: 7.26535,
    x2: 7.74813,
    y2: 7.32088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_9_3255",
    x1: 7.90923,
    y1: 7.26573,
    x2: 7.9195,
    y2: 7.3205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_9_3255",
    x1: 7.54939,
    y1: 7.2746,
    x2: 7.56729,
    y2: 7.37004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_9_3255",
    x1: 7.08626,
    y1: 7.24846,
    x2: 7.09753,
    y2: 7.37245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_9_3255",
    x1: 5.85041,
    y1: 7.58858,
    x2: 5.98649,
    y2: 7.39806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_9_3255",
    x1: 5.715,
    y1: 7.72058,
    x2: 5.86178,
    y2: 7.51508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_9_3255",
    x1: 6.01365,
    y1: 7.87677,
    x2: 6.1753,
    y2: 7.65046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_9_3255",
    x1: 6.2324,
    y1: 7.89192,
    x2: 6.36364,
    y2: 7.70817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_9_3255",
    x1: 8.58555,
    y1: 2.81871,
    x2: 7.5911,
    y2: 4.04716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_9_3255",
    x1: 8.29494,
    y1: 2.66591,
    x2: 7.92554,
    y2: 3.12223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_9_3255",
    x1: 8.71711,
    y1: 2.94641,
    x2: 8.33709,
    y2: 3.41584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_9_3255",
    x1: 8.24378,
    y1: 3.35055,
    x2: 7.64468,
    y2: 4.09063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_9_3255",
    x1: 7.85217,
    y1: 3.00616,
    x2: 7.57398,
    y2: 3.34981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_9_3255",
    x1: 6.61433,
    y1: 3.55003,
    x2: 6.19373,
    y2: 4.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_9_3255",
    x1: 6.44003,
    y1: 3.49576,
    x2: 6.2838,
    y2: 3.78246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_9_3255",
    x1: 6.69917,
    y1: 3.6068,
    x2: 6.53844,
    y2: 3.90178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_9_3255",
    x1: 6.48087,
    y1: 3.87539,
    x2: 6.22748,
    y2: 4.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_9_3255",
    x1: 6.23197,
    y1: 3.72625,
    x2: 6.11431,
    y2: 3.94217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_9_3255",
    x1: 10.1335,
    y1: 3.58585,
    x2: 9.45641,
    y2: 4.14647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_9_3255",
    x1: 9.99183,
    y1: 3.47064,
    x2: 9.74029,
    y2: 3.67894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_9_3255",
    x1: 10.1911,
    y1: 3.67015,
    x2: 9.93234,
    y2: 3.88438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_9_3255",
    x1: 9.88872,
    y1: 3.83823,
    x2: 9.48084,
    y2: 4.17594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_9_3255",
    x1: 9.71296,
    y1: 3.60755,
    x2: 9.52356,
    y2: 3.76438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_9_3255",
    x1: 8.85351,
    y1: 4.32419,
    x2: 8.85112,
    y2: 5.20322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_9_3255",
    x1: 9.03258,
    y1: 4.36031,
    x2: 9.0317,
    y2: 4.68682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_9_3255",
    x1: 8.75192,
    y1: 4.33316,
    x2: 8.751,
    y2: 4.66906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_9_3255",
    x1: 8.81427,
    y1: 4.67359,
    x2: 8.81282,
    y2: 5.20318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_9_3255",
    x1: 9.10402,
    y1: 4.66263,
    x2: 9.10335,
    y2: 4.90842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_9_3255",
    x1: 7.34003,
    y1: 4.37741,
    x2: 7.34243,
    y2: 5.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_9_3255",
    x1: 7.16107,
    y1: 4.41357,
    x2: 7.16197,
    y2: 4.74005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_9_3255",
    x1: 7.44167,
    y1: 4.38646,
    x2: 7.4426,
    y2: 4.72236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_9_3255",
    x1: 7.37939,
    y1: 4.72678,
    x2: 7.38084,
    y2: 5.25635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_9_3255",
    x1: 7.08952,
    y1: 4.71588,
    x2: 7.09019,
    y2: 4.96167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_9_3255",
    x1: 10.5108,
    y1: 14.9167,
    x2: 10.5126,
    y2: 15.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_9_3255",
    x1: 11.8287,
    y1: 13.956,
    x2: 11.8344,
    y2: 15.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_9_3255",
    x1: 12.4425,
    y1: 16.2215,
    x2: 11.8376,
    y2: 14.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_9_3255",
    x1: 15.0368,
    y1: 10.2935,
    x2: 13.6983,
    y2: 9.52357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_9_3255",
    x1: 15.1754,
    y1: 12.9847,
    x2: 13.0432,
    y2: 11.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_9_3255",
    x1: 14.9995,
    y1: 12.2621,
    x2: 12.885,
    y2: 11.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_9_3255",
    x1: 10.79,
    y1: 13.6735,
    x2: 10.1533,
    y2: 13.3073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_9_3255",
    x1: 10.2157,
    y1: 13.7241,
    x2: 9.92585,
    y2: 13.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_9_3255",
    x1: 10.4374,
    y1: 13.7424,
    x2: 10.285,
    y2: 13.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_9_3255",
    x1: 10.0189,
    y1: 13.6978,
    x2: 9.71507,
    y2: 13.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_9_3255",
    x1: 9.83619,
    y1: 13.3984,
    x2: 9.75872,
    y2: 13.3538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_9_3255",
    x1: 11.1587,
    y1: 13.4426,
    x2: 10.8069,
    y2: 13.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_9_3255",
    x1: 11.3308,
    y1: 13.0941,
    x2: 10.6923,
    y2: 12.7269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_9_3255",
    x1: 11.6054,
    y1: 12.6079,
    x2: 11.2498,
    y2: 12.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_9_3255",
    x1: 13.4544,
    y1: 13.0125,
    x2: 12.2223,
    y2: 12.3038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_9_3255",
    x1: 11.2678,
    y1: 13.6867,
    x2: 10.9484,
    y2: 13.5031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_9_3255",
    x1: 14.0697,
    y1: 10.6743,
    x2: 13.5453,
    y2: 10.3726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_9_3255",
    x1: 13.7623,
    y1: 10.5174,
    x2: 12.9687,
    y2: 10.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_9_3255",
    x1: 13.1203,
    y1: 11.0343,
    x2: 12.5969,
    y2: 10.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_9_3255",
    x1: 12.335,
    y1: 11.6041,
    x2: 11.9489,
    y2: 11.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_9_3255",
    x1: 16.0199,
    y1: 9.27572,
    x2: 14.6033,
    y2: 8.46083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_9_3255",
    x1: 14.9308,
    y1: 8.98289,
    x2: 14.7379,
    y2: 8.87198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_9_3255",
    x1: 12.394,
    y1: 10.7149,
    x2: 12.3012,
    y2: 10.6615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_9_3255",
    x1: 13.3955,
    y1: 10.57,
    x2: 13.3101,
    y2: 10.5209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_9_3255",
    x1: 9.80636,
    y1: 14.0824,
    x2: 9.30581,
    y2: 13.7945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_9_3255",
    x1: 15.3862,
    y1: 7.40091,
    x2: 13.9156,
    y2: 6.55505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_9_3255",
    x1: 14.7234,
    y1: 7.36994,
    x2: 14.0915,
    y2: 7.00647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_9_3255",
    x1: 13.7479,
    y1: 8.80433,
    x2: 13.4749,
    y2: 8.64732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_9_3255",
    x1: 14.0917,
    y1: 8.44762,
    x2: 13.6909,
    y2: 8.21708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_9_3255",
    x1: 13.7374,
    y1: 8.86966,
    x2: 13.6941,
    y2: 8.84476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_9_3255",
    x1: 13.6528,
    y1: 9.05527,
    x2: 13.4525,
    y2: 8.94007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_9_3255",
    x1: 13.0921,
    y1: 9.56073,
    x2: 12.9485,
    y2: 9.47811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_9_3255",
    x1: 5.56252,
    y1: 15.0383,
    x2: 5.56526,
    y2: 15.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_9_3255",
    x1: 4.23418,
    y1: 14.092,
    x2: 4.2428,
    y2: 15.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_9_3255",
    x1: 3.6454,
    y1: 16.3644,
    x2: 4.23519,
    y2: 14.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_9_3255",
    x1: 0.985711,
    y1: 10.4651,
    x2: 2.31586,
    y2: 9.68042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_9_3255",
    x1: 0.876777,
    y1: 13.1578,
    x2: 2.99538,
    y2: 11.9079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_9_3255",
    x1: 1.08444,
    y1: 12.5003,
    x2: 3.18539,
    y2: 11.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_9_3255",
    x1: 5.26968,
    y1: 13.7982,
    x2: 5.9023,
    y2: 13.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_9_3255",
    x1: 5.84439,
    y1: 13.8425,
    x2: 6.13232,
    y2: 13.6726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_9_3255",
    x1: 5.6229,
    y1: 13.8631,
    x2: 5.7743,
    y2: 13.7738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_9_3255",
    x1: 6.04086,
    y1: 13.814,
    x2: 6.34281,
    y2: 13.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_9_3255",
    x1: 6.22032,
    y1: 13.5126,
    x2: 6.2973,
    y2: 13.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_9_3255",
    x1: 4.89846,
    y1: 13.5715,
    x2: 5.24791,
    y2: 13.3653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_9_3255",
    x1: 4.72243,
    y1: 13.2248,
    x2: 5.35688,
    y2: 12.8505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_9_3255",
    x1: 4.4425,
    y1: 12.7415,
    x2: 4.79591,
    y2: 12.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_9_3255",
    x1: 2.59792,
    y1: 13.1667,
    x2: 3.8223,
    y2: 12.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_9_3255",
    x1: 4.79209,
    y1: 13.8169,
    x2: 5.1093,
    y2: 13.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_9_3255",
    x1: 1.95701,
    y1: 10.8355,
    x2: 2.47817,
    y2: 10.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_9_3255",
    x1: 2.26271,
    y1: 10.6753,
    x2: 3.05128,
    y2: 10.2101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_9_3255",
    x1: 2.91042,
    y1: 11.1847,
    x2: 3.43049,
    y2: 10.8778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_9_3255",
    x1: 3.70189,
    y1: 11.7459,
    x2: 4.08551,
    y2: 11.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_9_3255",
    x1: -0.00830716,
    y1: 9.45828,
    x2: 1.39924,
    y2: 8.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_9_3255",
    x1: 1.07743,
    y1: 9.15357,
    x2: 1.26905,
    y2: 9.04053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_9_3255",
    x1: 3.63328,
    y1: 10.8576,
    x2: 3.72546,
    y2: 10.8032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_9_3255",
    x1: 2.62997,
    y1: 10.7238,
    x2: 2.71489,
    y2: 10.6738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_9_3255",
    x1: 6.25769,
    y1: 14.1962,
    x2: 6.75507,
    y2: 13.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_9_3255",
    x1: 0.604571,
    y1: 7.57664,
    x2: 2.06574,
    y2: 6.71464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_9_3255",
    x1: 1.26699,
    y1: 7.53855,
    x2: 1.8948,
    y2: 7.16817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_9_3255",
    x1: 2.25823,
    y1: 8.96197,
    x2: 2.5295,
    y2: 8.80194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_9_3255",
    x1: 1.91061,
    y1: 8.60896,
    x2: 2.3088,
    y2: 8.37404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_9_3255",
    x1: 2.26943,
    y1: 9.02699,
    x2: 2.31249,
    y2: 9.00159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_9_3255",
    x1: 2.35629,
    y1: 9.21182,
    x2: 2.55523,
    y2: 9.09445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_9_3255",
    x1: 2.92241,
    y1: 9.71095,
    x2: 3.06512,
    y2: 9.62676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_9_3255",
    x1: 15.4228,
    y1: -2.81495,
    x2: 3.84385,
    y2: 11.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_9_3255",
    x1: 7.4542,
    y1: 13.3569,
    x2: 8.89365,
    y2: 12.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_9_3255",
    x1: 9.2164,
    y1: 12.4281,
    x2: 8.94401,
    y2: 11.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_9_3255",
    x1: 8.6784,
    y1: 12.3755,
    x2: 7.6152,
    y2: 11.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_9_3255",
    x1: 8.47408,
    y1: 12.0126,
    x2: 7.46589,
    y2: 12.6827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_9_3255",
    x1: 6.73962,
    y1: 12.4934,
    x2: 7.92484,
    y2: 12.5171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_9_3255",
    x1: 9.8988,
    y1: 11.7477,
    x2: 9.6976,
    y2: 10.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_9_3255",
    x1: 9.74991,
    y1: 13.0532,
    x2: 9.20659,
    y2: 10.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_9_3255",
    x1: 7.55478,
    y1: 10.8875,
    x2: 9.02955,
    y2: 10.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_9_3255",
    x1: 7.78841,
    y1: 11.6254,
    x2: 7.72303,
    y2: 11.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_9_3255",
    x1: 7.05997,
    y1: 12.1739,
    x2: 6.76092,
    y2: 10.8946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_9_3255",
    x1: 6.01433,
    y1: 12.1933,
    x2: 5.76106,
    y2: 11.1099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_9_3255",
    x1: 5.56412,
    y1: 11.4059,
    x2: 5.36388,
    y2: 10.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_9_3255",
    x1: 6.86551,
    y1: 12.7681,
    x2: 6.54197,
    y2: 11.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_9_3255",
    x1: 6.84697,
    y1: 11.5061,
    x2: 7.77132,
    y2: 11.5246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_9_3255",
    x1: 8.46481,
    y1: 3.62882,
    x2: 8.03833,
    y2: 3.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#F7AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF462"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalemblem);
export default __webpack_public_path__ + "static/media/nationalemblem.e022066898cb2230747aa685cad6486e.svg";
export { ForwardRef as ReactComponent };